webpackJsonp([49],{

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AjaxByGetByResumeClient = exports.AjaxByToken = exports.AjaxGetByResumeClient = exports.AjaxByPost = exports.cancelRequestByKey = exports.cancelRequest = undefined;

var _defineProperty2 = __webpack_require__(327);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _promise = __webpack_require__(344);

var _promise2 = _interopRequireDefault(_promise);

var _keys = __webpack_require__(328);

var _keys2 = _interopRequireDefault(_keys);

var _axios = __webpack_require__(35);

var _axios2 = _interopRequireDefault(_axios);

var _store = __webpack_require__(28);

var _store2 = _interopRequireDefault(_store);

var _merge = __webpack_require__(362);

var _merge2 = _interopRequireDefault(_merge);

var _omit = __webpack_require__(353);

var _omit2 = _interopRequireDefault(_omit);

var _antd = __webpack_require__(426);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CancelToken = _axios2.default.CancelToken;
var cancel = [];

var cancelRequest = exports.cancelRequest = function cancelRequest() {
    cancel.forEach(function (item) {
        (0, _keys2.default)(item).forEach(function (key) {
            if (key.indexOf('basicUserinfo') === -1) {
                item[key]('cancel request by change page!');
            }
        });
    });
    cancel = [];
};

var cancelRequestByKey = exports.cancelRequestByKey = function cancelRequestByKey(key) {
    cancel.forEach(function (item) {
        item[key] && item[key]('cancel request: ' + key + '!');
    });
};

var AjaxByPost = exports.AjaxByPost = function AjaxByPost(uri, data) {
    return new _promise2.default(function (resolve, reject) {
        (0, _axios2.default)({
            url: prefixUri + '/' + uri,
            method: 'post',
            data: (0, _merge2.default)(data, {
                head: {
                    type: 'h'
                }
            }),
            header: {
                contentType: 'application/json;charset=utf-8'
            },
            cancelToken: new CancelToken(function (c) {
                cancel.push((0, _defineProperty3.default)({}, uri, c));
            }),
            transformResponse: function transformResponse(data, b) {
                NProgress.done();
                try {
                    return JSON.parse(data);
                } catch (err) {}
            }
        }).then(function (response) {
            var data = response.data;
            var returnCode = data.returnCode,
                returnMsg = data.returnMsg;

            if (returnCode !== 'AAAAAAA') {
                if (returnMsg === '登录已失效,请重新登录' && returnCode === '0000005') {
                    cancelRequest();
                    _store2.default.remove('token');
                    location.href = location.origin + '/#/login';
                }

                _antd.notification.error(returnMsg);
                reject(response);
            } else {
                resolve((0, _omit2.default)(data, ['returnCode', 'returnMsg']));
            }
        }).catch(function (response, e) {
            if (response instanceof Error) {
                reject(response);

                _antd.notification.error('网络错误', response.message);
            } else if (_axios2.default.isCancel(response)) {} else {}
        });
    });
};
var AjaxGetByResumeClient = exports.AjaxGetByResumeClient = function AjaxGetByResumeClient(uri, data) {
    return new _promise2.default(function (resolve, reject) {
        alert('' + resumeUrl + uri);
        (0, _axios2.default)({
            url: '' + resumeUrl + uri,
            method: 'get',
            params: data,
            header: {
                contentType: 'application/json;charset=utf-8'
            }
        }).then(function (response) {
            alert(123123);
            var data = response.data;

            console.log(response);
        }).catch(function (response, e) {});
    });
};
var AjaxByToken = exports.AjaxByToken = function AjaxByToken(uri, data) {
    var token = _store2.default.get('token');
    return AjaxByPost(uri, (0, _merge2.default)(data, { data: token }));
};
var AjaxByGetByResumeClient = exports.AjaxByGetByResumeClient = function AjaxByGetByResumeClient(uri, data) {
    return AjaxGetByResumeClient(uri, (0, _merge2.default)(data));
};

/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var USER_LOGOUT = exports.USER_LOGOUT = "USER_LOGOUT";
var LOGIN_START = exports.LOGIN_START = "LOGIN_START";
var LOGIN_DONE = exports.LOGIN_DONE = "LOGIN_DONE";

/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LOAD_CATEGORY_START = exports.LOAD_CATEGORY_START = "LOAD_CATEGORY_START";
var LOAD_CATEGORY_DONE = exports.LOAD_CATEGORY_DONE = "LOAD_CATEGORY_DONE";
var LOAD_RECRUIT_CATEGORY = exports.LOAD_RECRUIT_CATEGORY = "LOAD_RECRUIT_CATEGORY";

var LOAD_LIST_START = exports.LOAD_LIST_START = "LOAD_LIST_START";
var LOAD_LIST_DONE = exports.LOAD_LIST_DONE = "LOAD_LIST_DONE";
var LOAD_RECRUIT_LIST = exports.LOAD_RECRUIT_LIST = "LOAD_RECRUIT_LIST";

var LOAD_RECOMMEND_START = exports.LOAD_RECOMMEND_START = "LOAD_RECOMMEND_START";
var LOAD_RECOMMEND_DONE = exports.LOAD_RECOMMEND_DONE = "LOAD_RECOMMEND_DONE";
var LOAD_RECOMMEND_LIST = exports.LOAD_RECOMMEND_LIST = "LOAD_RECOMMEND_LIST";

var SHOW_INFO_MODAL = exports.SHOW_INFO_MODAL = "SHOW_INFO_MODAL";
var HIDE_INFO_MODAL = exports.HIDE_INFO_MODAL = "HIDE_INFO_MODAL";

var SHOW_UPLOAD_MODAL = exports.SHOW_UPLOAD_MODAL = "SHOW_UPLOAD_MODAL";
var HIDE_UPLOAD_MODAL = exports.HIDE_UPLOAD_MODAL = "HIDE_UPLOAD_MODAL";

var UPLOAD_RESUME_START = exports.UPLOAD_RESUME_START = "UPLOAD_RESUME_START";
var UPLOAD_RESUME_DONE = exports.UPLOAD_RESUME_DONE = "UPLOAD_RESUME_DONE";
var SET_RESETFORM_TRUE = exports.SET_RESETFORM_TRUE = "SET_RESETFORM_TRUE";
var SET_RESETFORM_FALSE = exports.SET_RESETFORM_FALSE = "SET_RESETFORM_FALSE";

var SHOW_RECOMMEND_MODAL = exports.SHOW_RECOMMEND_MODAL = "SHOW_RECOMMEND_MODAL";
var HIDE_RECOMMEND_MODAL = exports.HIDE_RECOMMEND_MODAL = "HIDE_RECOMMEND_MODAL";

var SELECT_POSITION = exports.SELECT_POSITION = "SELECT_POSITION";

var UP_INFO_NAME = exports.UP_INFO_NAME = "UP_INFO_NAME";
var UP_INFO_FILEPATH = exports.UP_INFO_FILEPATH = "UP_INFO_FILEPATH";

var MATCH_UPRESUME = exports.MATCH_UPRESUME = "MATCH_UPRESUME";

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

module.exports = antd;

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getRemainedDownloadNum = exports.deleteCollectResume = exports.collectResumeList = exports.collectResume = exports.downLoadResumeList = exports.downLoadResume = exports.clearResumeListData = exports.clearResumeDetailData = exports.searchResumeDetail = exports.searchResume = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _resumeSearch = __webpack_require__(225);

var types = _interopRequireWildcard(_resumeSearch);

var _ajax = __webpack_require__(12);

var _axios = __webpack_require__(35);

var _axios2 = _interopRequireDefault(_axios);

var _antd = __webpack_require__(18);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultData = {};

var RESUME_SEARCH = { type: types.RESUME_SEARCH };

var RESUME_DETAIL = { type: types.RESUME_DETAIL };

var RESUME_SEARCH_START = { type: types.RESUME_SEARCH_START };
var RESUME_SEARCH_DONE = { type: types.RESUME_SEARCH_DONE };

var CLEAR_RESUME_DETAIL_DATA = { type: types.CLEAR_RESUME_DETAIL_DATA };
var CLEAR_RESUME_DATA = { type: types.CLEAR_RESUME_DATA };

var VIEW_DETAILS_START = { type: types.VIEW_DETAILS_START };
var VIEW_DETAILS_DONE = { type: types.VIEW_DETAILS_DONE };

var DOWNLOAD_NUM = { type: types.DOWNLOAD_NUM };

var ISCOLLECT = { type: types.ISCOLLECT };
var NOCOLLECT = { type: types.NOCOLLECT };

var searchResume = exports.searchResume = function searchResume(data) {
    return function (dispatch, getState) {
        NProgress.start();
        dispatch((0, _extends3.default)({}, RESUME_SEARCH_START));
        (0, _axios2.default)({
            url: resumeUrl + '/client/queryResume',
            method: 'get',
            params: data
        }).then(function (res) {
            if (res.data.result) {
                dispatch((0, _extends3.default)({}, RESUME_SEARCH_DONE));
                dispatch((0, _extends3.default)({}, RESUME_SEARCH, { resumeData: res.data.data, totalHits: res.data.totalHits }));
            } else {
                dispatch((0, _extends3.default)({}, RESUME_SEARCH_DONE));
                _antd.Modal.info({
                    className: "searchTip",
                    title: '哎呦不巧，网页君神游外太空去了，您稍后刷新再试试~~'
                });
            }
            NProgress.done();
        }).catch(function (error) {});
    };
};
var searchResumeDetail = exports.searchResumeDetail = function searchResumeDetail(data) {
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, VIEW_DETAILS_START));
        (0, _axios2.default)({
            url: resumeUrl + '/client/viewResume',
            method: 'post',
            data: data
        }).then(function (res) {
            if (res.data.result) {
                dispatch((0, _extends3.default)({}, RESUME_DETAIL, { resumeDetailData: res.data.data, isView: res.data.isView }));
            } else {
                dispatch((0, _extends3.default)({}, VIEW_DETAILS_DONE));
                console.log(res.data.msg);
            }
        }).catch(function (error) {});
    };
};
var clearResumeDetailData = exports.clearResumeDetailData = function clearResumeDetailData() {
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, CLEAR_RESUME_DETAIL_DATA));
    };
};
var clearResumeListData = exports.clearResumeListData = function clearResumeListData() {
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, CLEAR_RESUME_DATA));
    };
};

var downLoadResume = exports.downLoadResume = function downLoadResume(data, searchResumeDetail) {
    return function (dispatch, getState) {
        NProgress.start();
        (0, _axios2.default)({
            url: resumeUrl + '/client/downResume',
            method: 'post',
            data: data
        }).then(function (res) {
            if (res.data.result) {
                _antd.message.success("下载成功！");
                searchResumeDetail(data);
            } else {
                _antd.message.success('' + res.data.msg);
            }
            NProgress.done();
        }).catch(function (error) {});
    };
};
var downLoadResumeList = exports.downLoadResumeList = function downLoadResumeList(data) {
    return function (dispatch, getState) {
        NProgress.start();
        dispatch((0, _extends3.default)({}, RESUME_SEARCH_START));
        (0, _axios2.default)({
            url: resumeUrl + '/client/viewResumeInfoList',
            method: 'post',
            data: data
        }).then(function (res) {
            dispatch((0, _extends3.default)({}, RESUME_SEARCH_DONE));
            dispatch((0, _extends3.default)({}, RESUME_SEARCH, { resumeData: res.data.data, totalHits: res.data.totalHits }));
            NProgress.done();
        }).catch(function (error) {
            dispatch((0, _extends3.default)({}, RESUME_SEARCH_DONE));
        });
    };
};
var collectResume = exports.collectResume = function collectResume(data) {
    return function (dispatch, getState) {
        NProgress.start();
        (0, _axios2.default)({
            url: resumeUrl + '/client/addCollection',
            method: 'post',
            data: data
        }).then(function (res) {
            _antd.message.success(res.data.msg);
            NProgress.done();
            dispatch((0, _extends3.default)({}, NOCOLLECT));
        }).catch(function (error) {});
    };
};
var collectResumeList = exports.collectResumeList = function collectResumeList(data) {
    return function (dispatch, getState) {
        NProgress.start();
        dispatch((0, _extends3.default)({}, RESUME_SEARCH_START));
        (0, _axios2.default)({
            url: resumeUrl + '/client/collectionList',
            method: 'post',
            data: data
        }).then(function (res) {
            NProgress.done();
            dispatch((0, _extends3.default)({}, RESUME_SEARCH_DONE));
            dispatch((0, _extends3.default)({}, RESUME_SEARCH, { resumeData: res.data.data, totalHits: res.data.totalHits }));
        }).catch(function (error) {});
    };
};
var deleteCollectResume = exports.deleteCollectResume = function deleteCollectResume(data, collectResumeList, sorKey) {
    return function (dispatch, getState) {
        (0, _axios2.default)({
            url: resumeUrl + '/client/delCollection',
            method: 'post',
            data: data
        }).then(function (res) {
            _antd.message.success(res.data.msg);

            if (collectResumeList && sorKey) {
                collectResumeList({ sorKey: sorKey });
            }
            dispatch((0, _extends3.default)({}, ISCOLLECT));
        }).catch(function (error) {});
    };
};
var getRemainedDownloadNum = exports.getRemainedDownloadNum = function getRemainedDownloadNum(data) {
    return function (dispatch, getState) {
        (0, _axios2.default)({
            url: resumeUrl + '/client/viewContract',
            method: 'post',
            data: data
        }).then(function (res) {
            if (res.data.result) {
                dispatch((0, _extends3.default)({}, DOWNLOAD_NUM, { contract_count: res.data.contract_count }));
            }
        }).catch(function (error) {});
    };
};

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SHOW_ADDINTERVIEW_MODAL = exports.SHOW_ADDINTERVIEW_MODAL = "SHOW_ADDINTERVIEW_MODAL";
var HIDE_ADDINTERVIEW_MODAL = exports.HIDE_ADDINTERVIEW_MODAL = "HIDE_ADDINTERVIEW_MODAL";
var START_ADDINTERVIEW_MODAL = exports.START_ADDINTERVIEW_MODAL = "START_ADDINTERVIEW_MODAL";
var DONE_ADDINTERVIEW_MODAL = exports.DONE_ADDINTERVIEW_MODAL = "DONE_ADDINTERVIEW_MODAL";
var ADD_INTERVIEW_DATA = exports.ADD_INTERVIEW_DATA = "ADD_INTERVIEW_DATA";
var ADD_TAGLIST = exports.ADD_TAGLIST = "ADD_TAGLIST";

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LOAD_DOWNLOAD_START = exports.LOAD_DOWNLOAD_START = "LOAD_DOWNLOAD_START";
var LOAD_DOWNLOAD_DONE = exports.LOAD_DOWNLOAD_DONE = "LOAD_DOWNLOAD_DONE";
var SHOW_QR_MODAL = exports.SHOW_QR_MODAL = "SHOW_QR_MODAL";
var HIDE_QR_MODAL = exports.HIDE_QR_MODAL = "HIDE_QR_MODAL";

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GET_HISTORY_START = exports.GET_HISTORY_START = "GET_HISTORY_START";
var GET_HISTORY_END = exports.GET_HISTORY_END = "GET_HISTORY_END";
var GET_EMAIL_HISTORY = exports.GET_EMAIL_HISTORY = "GET_EMAIL_HISTORY";

var GET_PERSON_INFO_HISTORY_RECORD = exports.GET_PERSON_INFO_HISTORY_RECORD = "GET_PERSON_INFO_HISTORY_RECORD";

var SEND_EMAIL_START = exports.SEND_EMAIL_START = "SEND_EMAIL_START";
var SEND_EMAIL_DONE = exports.SEND_EMAIL_DONE = "SEND_EMAIL_DONE";

var SHOW_UPLOAD_MODAL = exports.SHOW_UPLOAD_MODAL = "SHOW_UPLOAD_MODAL";
var HIDE_UPLOAD_MODAL = exports.HIDE_UPLOAD_MODAL = "HIDE_UPLOAD_MODAL";

var RESET_FILELIST_TRUE = exports.RESET_FILELIST_TRUE = "RESET_FILELIST_TRUE";
var RESET_FILELIST_FALSE = exports.RESET_FILELIST_FALSE = "RESET_FILELIST_FALSE";

var SHOW_EMAIL_MODAL = exports.SHOW_EMAIL_MODAL = "SHOW_EMAIL_MODAL";
var HIDE_EMAIL_MODAL = exports.HIDE_EMAIL_MODAL = "HIDE_EMAIL_MODAL";

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var REMOVE_UPLOAD_FILE = exports.REMOVE_UPLOAD_FILE = "REMOVE_UPLOAD_FILE";

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var URGENT_TASKS = exports.URGENT_TASKS = "URGENT_TASKS";
var RESUME = exports.RESUME = "RESUME";
var RESUMEACCOUNT = exports.RESUMEACCOUNT = "RESUMEACCOUNT";
var TASK_PROGRESS = exports.TASK_PROGRESS = "TASK_PROGRESS";
var GET_ENTRY_START = exports.GET_ENTRY_START = "GET_ENTRY_START";
var GET_ENTRY_DONE = exports.GET_ENTRY_DONE = "GET_ENTRY_DONE";
var GET_ENTRY_LIST = exports.GET_ENTRY_LIST = "ENTRY_PERSON";
var SHOW_MEMO_MODAL = exports.SHOW_MEMO_MODAL = "SHOW_MEMO_MODAL";
var HIDE_MEMO_MODAL = exports.HIDE_MEMO_MODAL = "HIDE_MEMO_MODAL";
var ADD_MEMO_EVENT = exports.ADD_MEMO_EVENT = "ADD_MEMO_EVENT";
var GET_MEMO_CONTENT = exports.GET_MEMO_CONTENT = "GET_MEMO_CONTENT";
var GET_DATE_MEMO_CONTENT = exports.GET_DATE_MEMO_CONTENT = "GET_DATE_MEMO_CONTENT";
var GET_VIDEO = exports.GET_VIDEO = "GET_VIDEO";

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SINGLECALL = exports.SINGLECALL = 'SINGLECALL';
var PHONELOGINFO = exports.PHONELOGINFO = 'PHONELOGINFO';
var SHOW_ROBOT_CALL_MODAL = exports.SHOW_ROBOT_CALL_MODAL = 'SHOW_ROBOT_CALL_MODAL';
var HIDE_ROBOT_CALL_MODAL = exports.HIDE_ROBOT_CALL_MODAL = 'HIDE_ROBOT_CALL_MODAL';

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var INTERVIEW_TABLE_DATA = exports.INTERVIEW_TABLE_DATA = "INTERVIEW_TABLE_DATA";
var LOAD_TABLE_START = exports.LOAD_TABLE_START = "LOAD_TABLE_START";
var LOAD_TABLE_DONE = exports.LOAD_TABLE_DONE = "LOAD_TABLE_DONE";
var CANCELINTERVIEW_TABLE_DATA = exports.CANCELINTERVIEW_TABLE_DATA = "CANCELINTERVIEW_TABLE_DATA";
var SEARCH_TABLE_DATA = exports.SEARCH_TABLE_DATA = "SEARCH_TABLE_DATA";

var SHOW_INTERVIEW_MODAL = exports.SHOW_INTERVIEW_MODAL = "SHOW_INTERVIEW_MODAL";
var HIDE_INTERVIEW_MODAL = exports.HIDE_INTERVIEW_MODAL = "HIDE_INTERVIEW_MODAL";
var INTERVIEW_LIST_DATA = exports.INTERVIEW_LIST_DATA = "INTERVIEW_LIST_DATA";

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LOAD_CATEGORY_START = exports.LOAD_CATEGORY_START = "LOAD_CATEGORY_START";
var LOAD_CATEGORY_DONE = exports.LOAD_CATEGORY_DONE = "LOAD_CATEGORY_DONE";
var JOB_CATEGORY = exports.JOB_CATEGORY = "JOB_CATEGORY";
var JOB_LIST = exports.JOB_LIST = "JOB_LIST";
var LOAD_LIST_START = exports.LOAD_LIST_START = "LOAD_LIST_START";
var LOAD_LIST_DONE = exports.LOAD_LIST_DONE = "LOAD_LIST_DONE";
var JOB_INFO = exports.JOB_INFO = "JOB_INFO";
var LOAD_INFO_START = exports.LOAD_INFO_START = "LOAD_INFO_START";
var LOAD_INFO_DONE = exports.LOAD_INFO_DONE = "LOAD_INFO_DONE";
var ABORT_JOB_START = exports.ABORT_JOB_START = "ABORT_JOB_START";
var ABORT_JOB_DONE = exports.ABORT_JOB_DONE = "ABORT_JOB_DONE";
var ABORT_JOB_INFO = exports.ABORT_JOB_INFO = "ABORT_JOB_INFO";
var CREATE_JOB_START = exports.CREATE_JOB_START = "CREATE_JOB_START";
var CREATE_JOB_DONE = exports.CREATE_JOB_DONE = "CREATE_JOB_DONE";
var SHOW_JOB_MODAL = exports.SHOW_JOB_MODAL = "SHOW_JOB_MODAL";
var HIDE_JOB_MODAL = exports.HIDE_JOB_MODAL = "HIDE_JOB_MODAL";
var SHOW_SAVEJOB_MODAL = exports.SHOW_SAVEJOB_MODAL = "SHOW_SAVEJOB_MODAL";
var HIDE_SAVEJOB_MODAL = exports.HIDE_SAVEJOB_MODAL = "HIDE_SAVEJOB_MODAL";
var RESET_FORM = exports.RESET_FORM = "RESET_FORM";
var RESUMEID = exports.RESUMEID = "RESUMEID";
var CANCELLRESUMEID = exports.CANCELLRESUMEID = "CANCELLRESUMEID";
var SHOW_SALARY_MODAL = exports.SHOW_SALARY_MODAL = "SHOW_SALARY_MODAL";
var HIDE_SALARY_MODAL = exports.HIDE_SALARY_MODAL = "HIDE_SALARY_MODAL";
var SALARYDATA = exports.SALARYDATA = "SALARYDATA";
var CANCELSALARY = exports.CANCELSALARY = "CANCELSALARY";
var ADD_TAGLIST = exports.ADD_TAGLIST = "ADD_TAGLIST";

var CLEAR_CHOOSED_STATUS = exports.CLEAR_CHOOSED_STATUS = "CLEAR_CHOOSED_STATUS";

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GET_MANAGE_START = exports.GET_MANAGE_START = 'GET_MANAGE_START';
var GET_MANAGE_END = exports.GET_MANAGE_END = 'GET_MANAGE_END';
var GET_MANAGE_STATISTICS = exports.GET_MANAGE_STATISTICS = 'GET_MANAGE_STATISTICS';

var LOAD_LIST_START = exports.LOAD_LIST_START = 'LOAD_LIST_START';
var LOAD_LIST_DONE = exports.LOAD_LIST_DONE = 'LOAD_LIST_DONE';
var LOAD_CREW_LIST = exports.LOAD_CREW_LIST = 'LOAD_CREW_LIST';

var SHOW_UPLOAD_CLERK_MODAL = exports.SHOW_UPLOAD_CLERK_MODAL = 'SHOW_UPLOAD_CLERK_MODAL';
var HIDE_UPLOAD_CLERK_MODAL = exports.HIDE_UPLOAD_CLERK_MODAL = 'HIDE_UPLOAD_CLERK_MODAL';

var UPLOAD_CLERK_START = exports.UPLOAD_CLERK_START = 'UPLOAD_CLERK_START';
var UPLOAD_CLERK_DONE = exports.UPLOAD_CLERK_DONE = 'UPLOAD_CLERK_DONE';
var SET_RESETFORM_TRUE = exports.SET_RESETFORM_TRUE = "SET_RESETFORM_TRUE";
var SET_RESETFORM_FALSE = exports.SET_RESETFORM_FALSE = "SET_RESETFORM_FALSE";

var EXPORT_CLERK_START = exports.EXPORT_CLERK_START = 'EXPORT_CLERK_START';
var EXPORT_CLERK_DONE = exports.EXPORT_CLERK_DONE = 'EXPORT_CLERK_DONE';

var DELETE_EMPLOYEE_START = exports.DELETE_EMPLOYEE_START = 'DELETE_EMPLOYEE_START';
var DELETE_EMPLOYEE_DONE = exports.DELETE_EMPLOYEE_DONE = 'DELETE_EMPLOYEE_DONE';

var QUERY_EMPLOYEE_START = exports.QUERY_EMPLOYEE_START = 'QUERY_EMPLOYEE_START';
var QUERY_EMPLOYEE_DONE = exports.QUERY_EMPLOYEE_DONE = 'QUERY_EMPLOYEE_DONE';
var QUERY_EMPLOYEE_LIST = exports.QUERY_EMPLOYEE_LIST = 'QUERY_EMPLOYEE_LIST';
var QUERY_RESET_FORM = exports.QUERY_RESET_FORM = 'QUERY_RESET_FORM';

var SHOW_DISMISSION_MODAL = exports.SHOW_DISMISSION_MODAL = 'SHOW_DISMISSION_MODAL';
var HIDE_DISMISSION_MODAL = exports.HIDE_DISMISSION_MODAL = 'HIDE_DISMISSION_MODAL';

var SHOW_FORMAL_MODAL = exports.SHOW_FORMAL_MODAL = 'SHOW_FORMAL_MODAL';
var HIDE_FORMAL_MODAL = exports.HIDE_FORMAL_MODAL = 'HIDE_FORMAL_MODAL';

var SHOW_TRANSFER_PERSONNEL_MODAL = exports.SHOW_TRANSFER_PERSONNEL_MODAL = 'SHOW_TRANSFER_PERSONNEL_MODAL';
var HIDE_TRANSFER_PERSONNEL_MODAL = exports.HIDE_TRANSFER_PERSONNEL_MODAL = 'HIDE_TRANSFER_PERSONNEL_MODAL';
var MOBILIZE_EMPLOYEE_START = exports.MOBILIZE_EMPLOYEE_START = 'MOBILIZE_EMPLOYEE_START';
var MOBILIZE_EMPLOYEE_DONE = exports.MOBILIZE_EMPLOYEE_DONE = 'MOBILIZE_EMPLOYEE_DONE';

var SHOW_ATTACHMENT_MODAL = exports.SHOW_ATTACHMENT_MODAL = 'SHOW_ATTACHMENT_MODAL';
var HIDE_ATTACHMENT_MODAL = exports.HIDE_ATTACHMENT_MODAL = 'HIDE_ATTACHMENT_MODAL';

var OPERATION_LIST_START = exports.OPERATION_LIST_START = 'OPERATION_LIST_START';
var OPERATION_LIST_DONE = exports.OPERATION_LIST_DONE = 'OPERATION_LIST_DONE';
var OPERATION_LIST = exports.OPERATION_LIST = 'OPERATION_LIST';

var LOAD_EMPLOYEEINFO_START = exports.LOAD_EMPLOYEEINFO_START = 'LOAD_EMPLOYEEINFO_START';
var LOAD_EMPLOYEEINFO_DONE = exports.LOAD_EMPLOYEEINFO_DONE = 'LOAD_EMPLOYEEINFO_DONE';
var LOAD_EMPLOYEEINFO = exports.LOAD_EMPLOYEEINFO = 'LOAD_EMPLOYEEINFO';
var SHOW_INFO_MODAL = exports.SHOW_INFO_MODAL = 'SHOW_INFO_MODAL';
var HIDE_INFO_MODAL = exports.HIDE_INFO_MODAL = 'HIDE_INFO_MODAL';

var CREDITINVESTGATION_START = exports.CREDITINVESTGATION_START = 'CREDITINVESTGATION_START';
var CREDITINVESTGATION_DONE = exports.CREDITINVESTGATION_DONE = 'CREDITINVESTGATION_DONE';
var CREDITINVESTGATION = exports.CREDITINVESTGATION = 'CREDITINVESTGATION';
var SEARCHCREDITINVESTGATION = exports.SEARCHCREDITINVESTGATION = 'SEARCHCREDITINVESTGATION';
var SEARCHCREDITINVESTGATION_START = exports.SEARCHCREDITINVESTGATION_START = 'SEARCHCREDITINVESTGATION_START';

var CREDITINVESTGATIONSTATE = exports.CREDITINVESTGATIONSTATE = 'CREDITINVESTGATIONSTATE';
var HIDECREDITINVESTGATIONSTATE = exports.HIDECREDITINVESTGATIONSTATE = 'HIDECREDITINVESTGATIONSTATE';
var CANCELLOADING = exports.CANCELLOADING = 'CANCELLOADING';
var CANCELDATA = exports.CANCELDATA = 'CANCELDATA';

var IMAGEURL = exports.IMAGEURL = 'IMAGEURL';
var CANCELIMAGEURL = exports.CANCELIMAGEURL = 'CANCELIMAGEURL';

var SHOW_IMAGE_MODAL = exports.SHOW_IMAGE_MODAL = 'SHOW_IMAGE_MODAL';
var HIDE_IMAGE_MODAL = exports.HIDE_IMAGE_MODAL = 'HIDE_IMAGE_MODAL';

var SHOW_STAFF_MODAL = exports.SHOW_STAFF_MODAL = 'SHOW_STAFF_MODAL';
var HIDE_STAFF_MODAL = exports.HIDE_STAFF_MODAL = 'HIDE_STAFF_MODAL';

var GET_ARCHIVES_START = exports.GET_ARCHIVES_START = 'GET_ARCHIVES_START';
var GET_ARCHIVES_DONE = exports.GET_ARCHIVES_DONE = 'GET_ARCHIVES_DONE';
var GET_ARCHIVES_LIST = exports.GET_ARCHIVES_LIST = 'GET_ARCHIVES_LIST';

var GET_LEAVEARCHIVES_START = exports.GET_LEAVEARCHIVES_START = 'GET_LEAVEARCHIVES_START';
var GET_LEAVEARCHIVES_DONE = exports.GET_LEAVEARCHIVES_DONE = 'GET_LEAVEARCHIVES_DONE';
var GET_LEAVEARCHIVES_LIST = exports.GET_LEAVEARCHIVES_LIST = 'GET_LEAVEARCHIVES_LIST';

var GET_ARCHIVES_DATA = exports.GET_ARCHIVES_DATA = 'GET_ARCHIVES_DATA';

var ARCHIVES_TABLE_DATA = exports.ARCHIVES_TABLE_DATA = 'ARCHIVES_TABLE_DATA';

var SHOW_PERSONALMATERIAL_MODAL = exports.SHOW_PERSONALMATERIAL_MODAL = 'SHOW_PERSONALMATERIAL_MODAL';
var HIDE_PERSONALMATERIAL_MODAL = exports.HIDE_PERSONALMATERIAL_MODAL = 'HIDE_PERSONALMATERIAL_MODAL';

var PROGRESS = exports.PROGRESS = 'PROGRESS';
var CANCELPROGRESS = exports.CANCELPROGRESS = 'CANCELPROGRESS';

var GET_EMPLOYEE_WORK = exports.GET_EMPLOYEE_WORK = 'GET_EMPLOYEE_WORK';
var GET_EMPLOYEE_SEX = exports.GET_EMPLOYEE_SEX = 'GET_EMPLOYEE_SEX';
var GET_EMPLOYEE_EDU = exports.GET_EMPLOYEE_EDU = 'GET_EMPLOYEE_EDU';
var GET_EMPLOYEE_AGE = exports.GET_EMPLOYEE_AGE = 'GET_EMPLOYEE_AGE';
var GET_EMPLOYEE_MARRY = exports.GET_EMPLOYEE_MARRY = 'GET_EMPLOYEE_MARRY';
var GET_EMPLOYEE_CHILD = exports.GET_EMPLOYEE_CHILD = 'GET_EMPLOYEE_CHILD';
var GET_EMPLOYEE_DEPART = exports.GET_EMPLOYEE_DEPART = 'GET_EMPLOYEE_DEPART';
var GET_EMPLOYEE_POST = exports.GET_EMPLOYEE_POST = 'GET_EMPLOYEE_POST';

var GET_ORGANIZE_CHART = exports.GET_ORGANIZE_CHART = 'GET_ORGANIZE_CHART';
var GET_DEPARTMENT_START = exports.GET_DEPARTMENT_START = 'GET_DEPARTMENT_START';
var GET_DEPARTMENT_DONE = exports.GET_DEPARTMENT_DONE = 'GET_DEPARTMENT_DONE';
var GET_DEPARTMENT_LIST = exports.GET_DEPARTMENT_LIST = 'GET_DEPARTMENT_LIST';
var GET_DEPARTMENT_STAFF = exports.GET_DEPARTMENT_STAFF = 'GET_DEPARTMENT_STAFF';
var ADD_EDIT_DEPARTMENT = exports.ADD_EDIT_DEPARTMENT = 'ADD_EDIT_DEPARTMENT';
var DELETE_DEPARTMENT = exports.DELETE_DEPARTMENT = 'DELETE_DEPARTMENT';
var ADD_MECHANISM = exports.ADD_MECHANISM = 'ADD_MECHANISM';
var DELETE_MECHANISM = exports.DELETE_MECHANISM = 'DELETE_MECHANISM';
var EDIT_MECHANISM = exports.EDIT_MECHANISM = 'EDIT_MECHANISM';
var GET_ARRANGE_DEPARTMENT = exports.GET_ARRANGE_DEPARTMENT = 'GET_ARRANGE_DEPARTMENT';
var ARRANGE_DEPARTMENT = exports.ARRANGE_DEPARTMENT = 'ARRANGE_DEPARTMENT';
var GET_BD_LINK = exports.GET_BD_LINK = 'GET_BD_LINK';
var IS_PREVIEW_IMAGE = exports.IS_PREVIEW_IMAGE = 'IS_PREVIEW_IMAGE';
var IS_PREVIEW_IMAGE_START = exports.IS_PREVIEW_IMAGE_START = 'IS_PREVIEW_IMAGE_START';
var IS_PREVIEW_IMAGE_DONE = exports.IS_PREVIEW_IMAGE_DONE = 'IS_PREVIEW_IMAGE_DONE';

var GET_STAFF_LINK = exports.GET_STAFF_LINK = 'GET_STAFF_LINK';
var GET_STAFF_LINK_START = exports.GET_STAFF_LINK_START = 'GET_STAFF_LINK_START';
var GET_STAFF_LINK_DONE = exports.GET_STAFF_LINK_DONE = 'GET_STAFF_LINK_DONE';

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LOAD_RESUME_INFO = exports.LOAD_RESUME_INFO = "LOAD_RESUME_INFO";
var LOAD_INFO_START = exports.LOAD_INFO_START = "LOAD_INFO_START";
var LOAD_INFO_DONE = exports.LOAD_INFO_DONE = "LOAD_INFO_DONE";

var SHOW_MODAL_LOADING = exports.SHOW_MODAL_LOADING = "SHOW_MODAL_LOADING";
var HIDE_MODAL_LOADING = exports.HIDE_MODAL_LOADING = "HIDE_MODAL_LOADING";
var SHOW_RESUME_EDIT_MODEL = exports.SHOW_RESUME_EDIT_MODEL = "SHOW_RESUME_EDIT_MODEL";

var HIDE_RESUME_EDIT_MODEL = exports.HIDE_RESUME_EDIT_MODEL = "HIDE_RESUME_EDIT_MODEL";

var DOWNLOAD_RESUME = exports.DOWNLOAD_RESUME = "DOWNLOAD_RESUME";
var DOWNLOAD_RESUME_START = exports.DOWNLOAD_RESUME_START = "DOWNLOAD_RESUME_START";
var DOWNLOAD_RESUME_DONE = exports.DOWNLOAD_RESUME_DONE = "DOWNLOAD_RESUME_DONE";

var SHOW_MODAL = exports.SHOW_MODAL = "SHOW_MODAL";
var HIDE_MODAL = exports.HIDE_MODAL = "HIDE_MODAL";

var SHOW_SHARE_MODAL = exports.SHOW_SHARE_MODAL = "SHOW_SHARE_MODAL";
var HIDE_SHARE_MODAL = exports.HIDE_SHARE_MODAL = "HIDE_HARE_MODAL";

var SHOW_INTERVIEW_EVALUATION_MODAL = exports.SHOW_INTERVIEW_EVALUATION_MODAL = "SHOW_INTERVIEW_EVALUATION_MODAL";
var HIDE_INTERVIEW_EVALUATION_MODAL = exports.HIDE_INTERVIEW_EVALUATION_MODAL = "HIDE_INTERVIEW_EVALUATION_MODAL";

var GET_TAGS = exports.GET_TAGS = "GET_TAGS";

var GET_EVALUATION = exports.GET_EVALUATION = "GET_EVALUATION";

var GET_EVALUATION_ID = exports.GET_EVALUATION_ID = "GET_EVALUATION_ID";

var RESUME_INFORMATION = exports.RESUME_INFORMATION = "RESUME_INFORMATION";

var RESUME_INFO = exports.RESUME_INFO = "RESUME_INFO";

var FILL_LOADING = exports.FILL_LOADING = "FILL_LOADING";

var SHOW_BACKGROUNDSURVEY_MODAL = exports.SHOW_BACKGROUNDSURVEY_MODAL = "SHOW_BACKGROUNDSURVEY_MODAL";
var HIDE_BACKGROUNDSURVEY_MODAL = exports.HIDE_BACKGROUNDSURVEY_MODAL = "HIDE_BACKGROUNDSURVEY_MODAL";

var SHOW_QRCODE_LINKMODAL = exports.SHOW_QRCODE_LINKMODAL = "SHOW_QRCODE_LINKMODAL";
var HIDE_QRCODE_LINKMODAL = exports.HIDE_QRCODE_LINKMODAL = "HIDE_QRCODE_LINKMODAL";
var INTERVIEW_INFO = exports.INTERVIEW_INFO = "INTERVIEW_INFO";
var SCORES = exports.SCORES = "SCORES";
var SUMMARY = exports.SUMMARY = "SUMMARY";
var SHOW_ECHARTS_STATUS = exports.SHOW_ECHARTS_STATUS = "SHOW_ECHARTS_STATUS";
var HIDE_ECHARTS_STATUS = exports.HIDE_ECHARTS_STATUS = "HIDE_ECHARTS_STATUS";

var TEMP_BACICINFO = exports.TEMP_BACICINFO = "TEMP_BACICINFO";

var TEMP_INTENTION = exports.TEMP_INTENTION = "TEMP_INTENTION";

var TEMP_ASSESSMENT = exports.TEMP_ASSESSMENT = "TEMP_ASSESSMENT";

var TEMP_EDUCLIST = exports.TEMP_EDUCLIST = "TEMP_EDUCLIST";

var TEMP_PROJECT_LIST = exports.TEMP_PROJECT_LIST = "TEMP_PROJECT_LIST";

var TEMP_WORK_LIST = exports.TEMP_WORK_LIST = "TEMP_WORK_LIST";

var TEMP_LAN_LIST = exports.TEMP_LAN_LIST = "TEMP_LAN_LIST";

var TEMP_TRAIN_LIST = exports.TEMP_TRAIN_LIST = "TEMP_TRAIN_LIST";

var TEMP_CERT_LIST = exports.TEMP_CERT_LIST = "TEMP_CERT_LIST";

var TEMP_OTHER_LIST = exports.TEMP_OTHER_LIST = "TEMP_OTHER_LIST";

var TEMP_BORNDATA = exports.TEMP_BORNDATA = "TEMP_BORNDATA";

var TEMP_ADVAR = exports.TEMP_ADVAR = "TEMP_ADVAR";

var TYPE = exports.TYPE = "TYPE";

var GET_EVALUATION_INTERVIEWS = exports.GET_EVALUATION_INTERVIEWS = "GET_EVALUATION_INTERVIEWS";

var TEMP_ADVAR_FILEPATH = exports.TEMP_ADVAR_FILEPATH = "TEMP_ADVAR_FILEPATH";

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var RESUME_SEARCH = exports.RESUME_SEARCH = "RESUME_SEARCH";
var RESUME_DETAIL = exports.RESUME_DETAIL = "RESUME_DETAIL";
var RESUME_SEARCH_START = exports.RESUME_SEARCH_START = "RESUME_SEARCH_START";
var RESUME_SEARCH_DONE = exports.RESUME_SEARCH_DONE = "RESUME_SEARCH_DONE";
var CLEAR_RESUME_DETAIL_DATA = exports.CLEAR_RESUME_DETAIL_DATA = "CLEAR_RESUME_DETAIL_DATA";
var CLEAR_RESUME_DATA = exports.CLEAR_RESUME_DATA = "CLEAR_RESUME_DATA";
var VIEW_DETAILS_START = exports.VIEW_DETAILS_START = "VIEW_DETAILS_START";
var VIEW_DETAILS_DONE = exports.VIEW_DETAILS_DONE = "VIEW_DETAILS_DONE";
var DOWNLOAD_NUM = exports.DOWNLOAD_NUM = "DOWNLOAD_NUM";
var ISCOLLECT = exports.ISCOLLECT = "ISCOLLECT";
var NOCOLLECT = exports.NOCOLLECT = "NOCOLLECT";

/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GET_INDUSTRY = exports.GET_INDUSTRY = "GET_INDUSTRY";
var GET_DEPARTMENT = exports.GET_DEPARTMENT = "GET_DEPARTMENT";
var GET_POSITION = exports.GET_POSITION = "GET_POSITION";
var SALARY_DATA = exports.SALARY_DATA = "SALARY_DATA";

var DELETE_DATA = exports.DELETE_DATA = "DELETE_DATA";

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LOAD_LIST_START = exports.LOAD_LIST_START = "LOAD_LIST_START";
var LOAD_LIST_DONE = exports.LOAD_LIST_DONE = "LOAD_LIST_DONE";
var LOAD_TALENT_LIST = exports.LOAD_TALENT_LIST = "LOAD_TALENT_LIST";

var LOAD_CATEGORY_START = exports.LOAD_CATEGORY_START = "LOAD_CATEGORY_START";
var LOAD_CATEGORY_DONE = exports.LOAD_CATEGORY_DONE = "LOAD_CATEGORY_DONE";
var LOAD_TALENT_CATEGORY = exports.LOAD_TALENT_CATEGORY = "LOAD_TALENT_CATEGORY";

var RECOMMEND_POSITION_START = exports.RECOMMEND_POSITION_START = "RECOMMEND_POSITION_START";
var RECOMMEND_POSITION_DONE = exports.RECOMMEND_POSITION_DONE = "RECOMMEND_POSITION_DONE";

var SHOW_CREATE_LABEL_MODAL = exports.SHOW_CREATE_LABEL_MODAL = "SHOW_CREATE_LABEL_MODAL";
var HIDE_CREATE_LABEL_MODAL = exports.HIDE_CREATE_LABEL_MODAL = "HIDE_CREATE_LABEL_MODAL";
var CREATE_LABEL_START = exports.CREATE_LABEL_START = "CREATE_LABEL_START";
var CREATE_LABEL_DONE = exports.CREATE_LABEL_DONE = "CREATE_LABEL_DONE";
var SHOW_DELETE_LABEL_MODAL = exports.SHOW_DELETE_LABEL_MODAL = "SHOW_DELETE_LABEL_MODAL";
var HIDE_DELETE_LABEL_MODAL = exports.HIDE_DELETE_LABEL_MODAL = "HIDE_DELETE_LABEL_MODAL";
var DELETE_LABEL_START = exports.DELETE_LABEL_START = "DELETE_LABEL_START";
var DELETE_LABEL_DONE = exports.DELETE_LABEL_DONE = "DELETE_LABEL_DONE";

var SHOW_MOVE_RESUME_MODAL = exports.SHOW_MOVE_RESUME_MODAL = "SHOW_MOVE_RESUME_MODAL";
var HIDE_MOVE_RESUME_MODAL = exports.HIDE_MOVE_RESUME_MODAL = "HIDE_MOVE_RESUME_MODAL";
var MOVE_RESUME_START = exports.MOVE_RESUME_START = "MOVE_RESUME_START";
var MOVE_RESUME_DONE = exports.MOVE_RESUME_DONE = "MOVE_RESUME_DONE";

var TALENT_SOLE_MODEL_START = exports.TALENT_SOLE_MODEL_START = "TALENT_SOLE_MODEL_START";
var TALENT_SOLE_MODEL_DONE = exports.TALENT_SOLE_MODEL_DONE = "TALENT_SOLE_MODEL_DONE";
var TALENT_SOLE_START = exports.TALENT_SOLE_START = "TALENT_SOLE_START";
var TALENT_SOLE_DONE = exports.TALENT_SOLE_DONE = "TALENT_SOLE_DONE";

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GET_TASK_START = exports.GET_TASK_START = "GET_TASK_START";
var GET_TASK_REPORT = exports.GET_TASK_REPORT = "GET_TASK_REPORT";
var GET_TASK_DONE = exports.GET_TASK_DONE = "GET_TASK_DONE";

/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GET_USER_INFO = exports.GET_USER_INFO = "GET_USER_INFO";
var GET_USER_EMAIL_INFO = exports.GET_USER_EMAIL_INFO = "GET_USER_EMAIL_INFO";
var GET_USER_RESUMEEMAIL_INFO = exports.GET_USER_RESUMEEMAIL_INFO = "GET_USER_RESUMEEMAIL_INFO";
var CHANGE_PASSWD_START = exports.CHANGE_PASSWD_START = "CHANGE_PASSWD_START";
var CHANGE_PASSWD_DONE = exports.CHANGE_PASSWD_DONE = "CHANGE_PASSWD_DONE";
var CHANGE_PASSWD = exports.CHANGE_PASSWD = "CHANGE_PASSWD";
var CHANGE_RES_FALSE = exports.CHANGE_RES_FALSE = "CHANGE_RES_FALSE";

/***/ }),

/***/ 317:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(51);

var _login = __webpack_require__(417);

var _login2 = _interopRequireDefault(_login);

var _home = __webpack_require__(413);

var _home2 = _interopRequireDefault(_home);

var _job = __webpack_require__(416);

var _job2 = _interopRequireDefault(_job);

var _recruit = __webpack_require__(419);

var _recruit2 = _interopRequireDefault(_recruit);

var _talent = __webpack_require__(423);

var _talent2 = _interopRequireDefault(_talent);

var _user = __webpack_require__(425);

var _user2 = _interopRequireDefault(_user);

var _resumeInfo = __webpack_require__(420);

var _resumeInfo2 = _interopRequireDefault(_resumeInfo);

var _task = __webpack_require__(424);

var _task2 = _interopRequireDefault(_task);

var _email = __webpack_require__(411);

var _email2 = _interopRequireDefault(_email);

var _file = __webpack_require__(412);

var _file2 = _interopRequireDefault(_file);

var _manage = __webpack_require__(418);

var _manage2 = _interopRequireDefault(_manage);

var _resumeSearch = __webpack_require__(421);

var _resumeSearch2 = _interopRequireDefault(_resumeSearch);

var _salaryReport = __webpack_require__(422);

var _salaryReport2 = _interopRequireDefault(_salaryReport);

var _intellHR = __webpack_require__(414);

var _intellHR2 = _interopRequireDefault(_intellHR);

var _interview = __webpack_require__(415);

var _interview2 = _interopRequireDefault(_interview);

var _downloadQr = __webpack_require__(410);

var _downloadQr2 = _interopRequireDefault(_downloadQr);

var _addInterview = __webpack_require__(409);

var _addInterview2 = _interopRequireDefault(_addInterview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rootReducer = (0, _redux.combineReducers)({
    Login: _login2.default,
    Home: _home2.default,
    Job: _job2.default,
    Recruit: _recruit2.default,
    Talent: _talent2.default,
    User: _user2.default,
    Resume: _resumeInfo2.default,
    Task: _task2.default,
    Email: _email2.default,
    File: _file2.default,
    Manage: _manage2.default,
    ResumeSearch: _resumeSearch2.default,
    SalaryReport: _salaryReport2.default,
    IntellHR: _intellHR2.default,
    Interview: _interview2.default,
    DownloadQr: _downloadQr2.default,
    addInterviews: _addInterview2.default
});

exports.default = rootReducer;

/***/ }),

/***/ 318:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _hook = __webpack_require__(407);

var JobIndex = {
  path: 'index(/:positionid)',
  breadcrumbName: "职位管理",
  onEnter: _hook.requireAuthHook,
  onLeave: _hook.onLeavePage,
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(2).then((function (require) {
      cb(null, __webpack_require__(785).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var NewJob = {
  path: 'newJob',
  breadcrumbName: "新建职位",
  onEnter: _hook.requireAuthHook,
  onLeave: _hook.onLeavePage,
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(8).then((function (require) {
      cb(null, __webpack_require__(800).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var Job = {
  path: 'job',
  breadcrumbName: '职位管理',
  getChildRoutes: function getChildRoutes(partialNextState, cb) {
    new Promise(function(resolve) { resolve(); }).then((function (require) {
      cb(null, [JobIndex, NewJob]);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  },
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(32).then((function (require) {
      cb(null, __webpack_require__(807).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var Recruit = {
  path: 'recruit(/:stageid)',
  breadcrumbName: "招聘流程",
  onEnter: _hook.requireAuthHook,
  onLeave: _hook.onLeavePage,
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(4).then((function (require) {
      cb(null, __webpack_require__(811).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var resumeInfo = {
  path: 'resumeInfo(/:resumeId)(/:logId)',
  onEnter: _hook.requireAuthHook,
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(0).then((function (require) {
      cb(null, __webpack_require__(812).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var Talent = {
  path: "talent(/:keywords)",
  breadcrumbName: "人才库",
  onEnter: _hook.requireAuthHook,
  onLeave: _hook.onLeavePage,
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(3).then((function (require) {
      cb(null, __webpack_require__(819).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var Task = {
  path: "task",
  breadcrumbName: "任务报表",
  onEnter: _hook.requireAuthHook,
  onLeave: _hook.onLeavePage,
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(11).then((function (require) {
      cb(null, __webpack_require__(820).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var Email = {
  path: "email",
  breadcrumbName: "邮件管理",
  onEnter: _hook.requireAuthHook,
  onLeave: _hook.onLeavePage,
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(1).then((function (require) {
      cb(null, __webpack_require__(801).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var Login = {
  path: "login",
  breadcrumbName: "登陆",
  onEnter: _hook.onEnterLoginHook,
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(44).then((function (require) {
      cb(null, __webpack_require__(808).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var Preview = {
  path: "preview(/:type)(/:resumeId)",
  breadcrumbName: "预览功能",
  onEnter: _hook.requireAuthHook,
  onLeave: _hook.onLeavePage,
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(42).then((function (require) {
      cb(null, __webpack_require__(810).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var ChangePasswd = {
  path: "changePasswd",
  onEnter: _hook.requireAuthHook,
  onLeave: _hook.onLeavePage,
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(15).then((function (require) {
      cb(null, __webpack_require__(798).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var SettingEmail = {
  path: "settingEmail",
  onEnter: _hook.requireAuthHook,
  onLeave: _hook.onLeavePage,
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(19).then((function (require) {
      cb(null, __webpack_require__(816).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var interview = {
  path: "interview",
  breadcrumbName: "面试管理",
  onEnter: _hook.requireAuthHook,
  onLeave: _hook.onLeavePage,
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(12).then((function (require) {
      cb(null, __webpack_require__(806).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var upInfo = {
  path: "upInfo",
  onEnter: _hook.requireAuthHook,
  onLeave: _hook.onLeavePage,
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(14).then((function (require) {
      cb(null, __webpack_require__(821).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var NotFoundPage = {
  path: "*",
  onLeave: _hook.onLeavePage,
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(33).then((function (require) {
      cb(null, __webpack_require__(796).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var ManageClerk = {
  onEnter: _hook.requireAuthHook,
  onLeave: _hook.onLeavePage,
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(7).then((function (require) {
      cb(null, __webpack_require__(787).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var ClerkDetail = {
  path: 'clerkDetail/:rid',
  onEnter: _hook.requireAuthHook,
  onLeave: _hook.onLeavePage,
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(6).then((function (require) {
      cb(null, __webpack_require__(788).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var NewClerkForm = {
  path: 'newClerkForm',
  onEnter: _hook.requireAuthHook,
  onLeave: _hook.onLeavePage,
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(36).then((function (require) {
      cb(null, __webpack_require__(789).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var employeeInfo = {
  path: 'employeeInfo(/:resumeid)(/:rid)',
  onEnter: _hook.requireAuthHook,
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(10).then((function (require) {
      cb(null, __webpack_require__(802).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var Crchives = {
  path: 'archives',
  onEnter: _hook.requireAuthHook,
  onLeave: _hook.onLeavePage,
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(39).then((function (require) {
      cb(null, __webpack_require__(786).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var Organize = {
  path: 'organize',
  onEnter: _hook.requireAuthHook,
  onLeave: _hook.onLeavePage,
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(35).then((function (require) {
      cb(null, __webpack_require__(792).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var Condition = {
  path: 'condition',
  onEnter: _hook.requireAuthHook,
  onLeave: _hook.onLeavePage,
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(37).then((function (require) {
      cb(null, __webpack_require__(790).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var Dynamics = {
  path: 'dynamics',
  onEnter: _hook.requireAuthHook,
  onLeave: _hook.onLeavePage,
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(47).then((function (require) {
      cb(null, __webpack_require__(791).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var ManagerPage = {
  path: "manager",
  breadcrumbName: "员工管理",
  indexRoute: ManageClerk,
  getChildRoutes: function getChildRoutes(partialNextState, cb) {
    new Promise(function(resolve) { resolve(); }).then((function (require) {
      cb(null, [ManageClerk, ClerkDetail, NewClerkForm, Crchives, Organize, Condition, Dynamics]);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  },
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(18).then((function (require) {
      cb(null, __webpack_require__(809).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var HelpEditPurpose = {
  onEnter: _hook.requireAuthHook,
  onLeave: _hook.onLeavePage,
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(30).then((function (require) {
      cb(null, __webpack_require__(775).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var UseObject = {
  path: 'useObject',
  onEnter: _hook.requireAuthHook,
  onLeave: _hook.onLeavePage,
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(21).then((function (require) {
      cb(null, __webpack_require__(784).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var LogPage = {
  path: 'logPage',
  onEnter: _hook.requireAuthHook,
  onLeave: _hook.onLeavePage,
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(29).then((function (require) {
      cb(null, __webpack_require__(776).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var MainPage = {
  path: 'mainPage',
  onEnter: _hook.requireAuthHook,
  onLeave: _hook.onLeavePage,
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(28).then((function (require) {
      cb(null, __webpack_require__(777).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var ResumePage = {
  path: 'resumePage',
  onEnter: _hook.requireAuthHook,
  onLeave: _hook.onLeavePage,
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(24).then((function (require) {
      cb(null, __webpack_require__(781).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var RecrtPage = {
  path: 'RecrtPage',
  onEnter: _hook.requireAuthHook,
  onLeave: _hook.onLeavePage,
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(25).then((function (require) {
      cb(null, __webpack_require__(780).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var TlentPage = {
  path: 'TlentPage',
  onEnter: _hook.requireAuthHook,
  onLeave: _hook.onLeavePage,
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(23).then((function (require) {
      cb(null, __webpack_require__(782).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var TskPage = {
  path: 'TskPage',
  onEnter: _hook.requireAuthHook,
  onLeave: _hook.onLeavePage,
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(22).then((function (require) {
      cb(null, __webpack_require__(783).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var ManagePage = {
  path: 'ManagePage',
  onEnter: _hook.requireAuthHook,
  onLeave: _hook.onLeavePage,
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(27).then((function (require) {
      cb(null, __webpack_require__(778).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var Questions = {
  path: 'Questions',
  onEnter: _hook.requireAuthHook,
  onLeave: _hook.onLeavePage,
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(26).then((function (require) {
      cb(null, __webpack_require__(779).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var Explain = {
  path: 'Explain',
  onEnter: _hook.requireAuthHook,
  onLeave: _hook.onLeavePage,
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(31).then((function (require) {
      cb(null, __webpack_require__(774).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var HelpPage = {
  path: "help",
  breadcrumbName: "使用帮助",
  indexRoute: HelpEditPurpose,
  getChildRoutes: function getChildRoutes(partialNextState, cb) {
    new Promise(function(resolve) { resolve(); }).then((function (require) {
      cb(null, [HelpEditPurpose, UseObject, LogPage, MainPage, ResumePage, RecrtPage, TlentPage, TskPage, ManagePage, Questions, Explain]);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  },

  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(20).then((function (require) {
      cb(null, __webpack_require__(804).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var SystemPage = {
  path: "system",
  indexRoute: upInfo,
  breadcrumbName: "系统管理",
  getChildRoutes: function getChildRoutes(partialNextState, cb) {
    new Promise(function(resolve) { resolve(); }).then((function (require) {
      cb(null, [upInfo, ChangePasswd, SettingEmail]);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  },

  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(16).then((function (require) {
      cb(null, __webpack_require__(818).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var SalaryQuery = {
  path: "salaryQuery",
  breadcrumbName: "薪酬数据",
  onEnter: _hook.requireAuthHook,
  onLeave: _hook.onLeavePage,
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(13).then((function (require) {
      cb(null, __webpack_require__(815).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var ShowResume = {
  path: "showResume",
  breadcrumbName: "简历分享",
  onEnter: _hook.requireHook,
  onLeave: _hook.onLeavePage,
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(34).then((function (require) {
      cb(null, __webpack_require__(817).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var Evaluation = {
  path: "evaluation",
  breadcrumbName: "面试评估表",
  onEnter: _hook.requireHook,
  onLeave: _hook.onLeavePage,
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(43).then((function (require) {
      cb(null, __webpack_require__(803).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var QueryResume = {
  onEnter: _hook.requireAuthHook,
  onLeave: _hook.onLeavePage,
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(38).then((function (require) {
      cb(null, __webpack_require__(795).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var DownloadResume = {
  path: 'downloadResume',
  onEnter: _hook.requireAuthHook,
  onLeave: _hook.onLeavePage,
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(40).then((function (require) {
      cb(null, __webpack_require__(794).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var CollectResume = {
  path: 'collectResume',
  onEnter: _hook.requireAuthHook,
  onLeave: _hook.onLeavePage,
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(41).then((function (require) {
      cb(null, __webpack_require__(793).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var SearchResumePage = {
  path: "searchResume",
  breadcrumbName: "简历搜索",
  indexRoute: QueryResume,
  getChildRoutes: function getChildRoutes(partialNextState, cb) {
    new Promise(function(resolve) { resolve(); }).then((function (require) {
      cb(null, [QueryResume, DownloadResume, CollectResume]);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  },

  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(17).then((function (require) {
      cb(null, __webpack_require__(814).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var CaseView = {
  path: "caseView",
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(46).then((function (require) {
      cb(null, __webpack_require__(797).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var ResumeDetail = {
  path: "resumeDetail",
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(45).then((function (require) {
      cb(null, __webpack_require__(813).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var chooseSalary = {
  breadcrumbName: '行业薪酬',
  path: "chooseSalary",
  getComponent: function getComponent(nextState, cb) {
    __webpack_require__.e/* require.ensure */(9).then((function (require) {
      cb(null, __webpack_require__(799).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
};

var RouteConfig = {
  childRoutes: [{
    path: '/',
    breadcrumbName: '首页',
    component: __webpack_require__(428).default,
    indexRoute: {
      onEnter: _hook.requireAuthHook,
      onLeave: _hook.onLeavePage,
      getComponent: function getComponent(nextState, cb) {
        __webpack_require__.e/* require.ensure */(5).then((function (require) {
          cb(null, __webpack_require__(805).default);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      }
    },
    childRoutes: [SystemPage, Preview, chooseSalary, upInfo, interview, Job, Recruit, Talent, Task, Login, ChangePasswd, SettingEmail, resumeInfo, Email, ManagerPage, employeeInfo, HelpPage, ShowResume, Evaluation, SearchResumePage, CaseView, ResumeDetail, SalaryQuery, NotFoundPage]
  }]
};

module.exports = RouteConfig;

/***/ }),

/***/ 321:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 322:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 323:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 324:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _login = __webpack_require__(396);

var loginActions = _interopRequireWildcard(_login);

var _logout = __webpack_require__(397);

var logoutActions = _interopRequireWildcard(_logout);

var _home = __webpack_require__(392);

var homeActions = _interopRequireWildcard(_home);

var _job = __webpack_require__(395);

var jobActions = _interopRequireWildcard(_job);

var _user = __webpack_require__(404);

var UserActions = _interopRequireWildcard(_user);

var _recruit = __webpack_require__(399);

var RecruitActions = _interopRequireWildcard(_recruit);

var _talent = __webpack_require__(402);

var TalentActions = _interopRequireWildcard(_talent);

var _resumeInfo = __webpack_require__(400);

var ResumeActions = _interopRequireWildcard(_resumeInfo);

var _task = __webpack_require__(403);

var TaskActions = _interopRequireWildcard(_task);

var _email = __webpack_require__(390);

var EmailActions = _interopRequireWildcard(_email);

var _file = __webpack_require__(391);

var FileActions = _interopRequireWildcard(_file);

var _manage = __webpack_require__(398);

var ManageActions = _interopRequireWildcard(_manage);

var _resumeSearch = __webpack_require__(214);

var SearchActions = _interopRequireWildcard(_resumeSearch);

var _salaryReport = __webpack_require__(401);

var SalaryActions = _interopRequireWildcard(_salaryReport);

var _intellHR = __webpack_require__(393);

var IntellHRActions = _interopRequireWildcard(_intellHR);

var _interview = __webpack_require__(394);

var InterviewActions = _interopRequireWildcard(_interview);

var _downloadQR = __webpack_require__(389);

var DownloadQRActions = _interopRequireWildcard(_downloadQR);

var _addInterview = __webpack_require__(388);

var AddInterviewsActions = _interopRequireWildcard(_addInterview);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

module.exports = {
    loginActions: loginActions,
    logoutActions: logoutActions,
    homeActions: homeActions,
    jobActions: jobActions,
    RecruitActions: RecruitActions,
    TalentActions: TalentActions,
    UserActions: UserActions,
    ResumeActions: ResumeActions,
    TaskActions: TaskActions,
    EmailActions: EmailActions,
    FileActions: FileActions,
    ManageActions: ManageActions,
    SearchActions: SearchActions,
    SalaryActions: SalaryActions,
    IntellHRActions: IntellHRActions,
    InterviewActions: InterviewActions,
    DownloadQRActions: DownloadQRActions,
    AddInterviewsActions: AddInterviewsActions
};

/***/ }),

/***/ 388:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getAddInterviewsList = exports.showAddInterviewModal = exports.hideAddInterviewModal = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _addInterview = __webpack_require__(215);

var types = _interopRequireWildcard(_addInterview);

var _ajax = __webpack_require__(12);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SHOW_ADDINTERVIEW_MODAL = { type: types.SHOW_ADDINTERVIEW_MODAL };

var HIDE_ADDINTERVIEW_MODAL = { type: types.HIDE_ADDINTERVIEW_MODAL };

var START_ADDINTERVIEW_MODAL = { type: types.START_ADDINTERVIEW_MODAL };

var DONE_ADDINTERVIEW_MODAL = { type: types.DONE_ADDINTERVIEW_MODAL };

var ADD_INTERVIEW_DATA = { type: types.ADD_INTERVIEW_DATA };

var ADD_TAGLIST = { type: types.ADD_TAGLIST };

var hideAddInterviewModal = exports.hideAddInterviewModal = function hideAddInterviewModal() {
    return function (dispatch, getState) {
        dispatch(HIDE_ADDINTERVIEW_MODAL);
    };
};

var showAddInterviewModal = exports.showAddInterviewModal = function showAddInterviewModal() {
    return function (dispatch, getState) {
        dispatch(SHOW_ADDINTERVIEW_MODAL);
    };
};
var getAddInterviewsList = exports.getAddInterviewsList = function getAddInterviewsList(skip, key) {
    return function (dispatch, getState) {
        var uri = 'getinterviewers';
        (0, _ajax.cancelRequestByKey)(uri);
        dispatch(START_ADDINTERVIEW_MODAL);
        (0, _ajax.AjaxByToken)(uri, {
            head: {
                transcode: 'L0105'
            },
            data: {
                skip: skip ? skip : 0,
                count: 10,
                key: key
            }
        }).then(function (res) {
            dispatch(DONE_ADDINTERVIEW_MODAL);
            dispatch((0, _extends3.default)({}, ADD_INTERVIEW_DATA, { addInterviewList: res.result }));
        }, function (err) {
            dispatch(DONE_ADDINTERVIEW_MODAL);
        });
    };
};

/***/ }),

/***/ 389:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.downloadQr = exports.hideQrModal = exports.showQrModal = undefined;

var _downloadQr = __webpack_require__(216);

var types = _interopRequireWildcard(_downloadQr);

var _ajax = __webpack_require__(12);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var LOAD_DOWNLOAD_START = { type: types.LOAD_DOWNLOAD_START };
var LOAD_DOWNLOAD_DONE = { type: types.LOAD_DOWNLOAD_DONE };

var LOAD_DOWNLOAD_PIC = { type: types.LOAD_DOWNLOAD_PIC };

var SHOW_QR_MODAL = { type: types.SHOW_QR_MODAL };
var HIDE_QR_MODAL = { type: types.HIDE_QR_MODAL };
var showQrModal = exports.showQrModal = function showQrModal() {
  return function (dispatch, getState) {
    dispatch(SHOW_QR_MODAL);
  };
};
var hideQrModal = exports.hideQrModal = function hideQrModal() {
  return function (dispatch, getState) {
    dispatch(HIDE_QR_MODAL);
  };
};
var downloadQr = exports.downloadQr = function downloadQr() {
  return function (dispatch, getState) {
    var uri = 'createwxaqrcode';
    (0, _ajax.cancelRequestByKey)(uri);
    dispatch(LOAD_DOWNLOAD_START);
    (0, _ajax.AjaxByToken)(uri, {
      head: {
        transcode: 'L0043'
      },
      data: {
        skip: skip ? skip + '' : '0',
        count: "10",
        sort: 'desc',
        key: key
      }
    }).then(function (res) {
      dispatch(LOAD_DOWNLOAD_DONE);
    }, function (err) {
      dispatch(LOAD_DOWNLOAD_DONE);
    });
  };
};

/***/ }),

/***/ 390:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hideUploadModal = exports.showUploadModal = exports.resetFileListFalse = exports.sendEmail = exports.updateResumeEmail = exports.resetEmailBoxDetail = exports.getEmailBoxDetail = exports.getEmailHistory = exports.hideEmailModal = exports.showEmailModal = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _email = __webpack_require__(217);

var types = _interopRequireWildcard(_email);

var _axios = __webpack_require__(35);

var _axios2 = _interopRequireDefault(_axios);

var _ajax = __webpack_require__(12);

var _antd = __webpack_require__(18);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GET_HISTORY_START = { type: types.GET_HISTORY_START };
var GET_HISTORY_END = { type: types.GET_HISTORY_END };
var GET_EMAIL_HISTORY = { type: types.GET_EMAIL_HISTORY };

var GET_PERSON_INFO_HISTORY_RECORD = { type: types.GET_PERSON_INFO_HISTORY_RECORD };

var SEND_EMAIL_START = { type: types.SEND_EMAIL_START };
var SEND_EMAIL_DONE = { type: types.SEND_EMAIL_DONE };

var SHOW_UPLOAD_MODAL = { type: types.SHOW_UPLOAD_MODAL };
var HIDE_UPLOAD_MODAL = { type: types.HIDE_UPLOAD_MODAL };

var RESET_FILELIST_TRUE = { type: types.RESET_FILELIST_TRUE };
var RESET_FILELIST_FALSE = { type: types.RESET_FILELIST_FALSE };

var SHOW_EMAIL_MODAL = { type: types.SHOW_EMAIL_MODAL };
var HIDE_EMAIL_MODAL = { type: types.HIDE_EMAIL_MODAL };

var showEmailModal = exports.showEmailModal = function showEmailModal() {
    return function (dispatch, getState) {
        dispatch(SHOW_EMAIL_MODAL);
    };
};
var hideEmailModal = exports.hideEmailModal = function hideEmailModal() {
    return function (dispatch, getState) {
        dispatch(HIDE_EMAIL_MODAL);
    };
};

var getEmailHistory = exports.getEmailHistory = function getEmailHistory() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (dispatch, getState) {
        dispatch(GET_HISTORY_START);
        (0, _ajax.AjaxByToken)('talentStatis', {
            head: {
                transcode: 'L0028'
            },
            data: data
        }).then(function (res) {
            dispatch(GET_HISTORY_END);
            dispatch((0, _extends3.default)({}, GET_EMAIL_HISTORY, { list: res.list }));
        }, function (err) {
            dispatch(GET_HISTORY_END);
            dispatch((0, _extends3.default)({}, GET_EMAIL_HISTORY, { list: [] }));
        });
    };
};

var getEmailBoxDetail = exports.getEmailBoxDetail = function getEmailBoxDetail(data) {
    return function (dispatch, getState) {
        var uri = 'mailBoxDetail';
        (0, _ajax.cancelRequestByKey)(uri);
        (0, _ajax.AjaxByToken)(uri, {
            head: {
                transcode: 'L0029'
            },
            data: data
        }).then(function (res) {
            dispatch((0, _extends3.default)({}, GET_PERSON_INFO_HISTORY_RECORD, { personHistoryList: res.list }));
        });
    };
};

var resetEmailBoxDetail = exports.resetEmailBoxDetail = function resetEmailBoxDetail() {
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, GET_PERSON_INFO_HISTORY_RECORD, { personHistoryList: [] }));
    };
};

var updateResumeEmail = exports.updateResumeEmail = function updateResumeEmail(data, props) {
    return function (dispatch, getState) {
        (0, _ajax.AjaxByToken)("updateResumeEmail", {
            head: {
                transcode: 'L0073'
            },
            data: data
        }).then(function (res) {
            var getRecruitResumeInfo = props.getRecruitResumeInfo,
                addressee = props.addressee,
                logId = addressee.logId,
                resumeid = addressee.resumeid;

            getRecruitResumeInfo({
                resumeId: resumeid,
                logId: logId
            });
            _antd.message.success('邮箱修改成功！');
        }, function (err) {
            _antd.message.error('邮箱修改失败！');
        });
    };
};

var sendEmail = exports.sendEmail = function sendEmail(data, fileList) {
    var reSetTitle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
    var reSetHTML = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
    var getEmailBoxDetail = arguments[4];
    return function (dispatch, getState) {
        dispatch(SEND_EMAIL_START);
        (0, _ajax.AjaxByToken)('sendEmail', {
            head: {
                transcode: 'L0021'
            },
            data: data
        }).then(function (res) {
            dispatch(SEND_EMAIL_DONE);
            _antd.message.success('发送邮件成功！');

            reSetTitle('');

            reSetHTML();
            var resumeid = data.resumeid,
                positionid = data.positionid;

            getEmailBoxDetail({ resumeid: resumeid, positionid: positionid });

            var requestArr = [];
            fileList.forEach(function (item) {
                var response = item.response;

                var fd = new FormData();
                fd.append('fileName', response.filePath);
                requestArr.push(_axios2.default.post(prefixUri + '/uploadremove', fd));
            });
            _axios2.default.all(requestArr).then(_axios2.default.spread(function () {
                dispatch(RESET_FILELIST_TRUE);
            }));
        }, function (err) {
            dispatch(SEND_EMAIL_DONE);
            _antd.message.error('发送邮件失败！');
        });
    };
};

var resetFileListFalse = exports.resetFileListFalse = function resetFileListFalse() {
    return function (dispatch, getState) {
        dispatch(RESET_FILELIST_FALSE);
    };
};

var showUploadModal = exports.showUploadModal = function showUploadModal() {
    return function (dispatch, getState) {
        dispatch(SHOW_UPLOAD_MODAL);
    };
};
var hideUploadModal = exports.hideUploadModal = function hideUploadModal() {
    return function (dispatch, getState) {
        dispatch(HIDE_UPLOAD_MODAL);
    };
};

/***/ }),

/***/ 391:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.removeUploadFIles = exports.removeUploadFIle = undefined;

var _file = __webpack_require__(218);

var types = _interopRequireWildcard(_file);

var _axios = __webpack_require__(35);

var _axios2 = _interopRequireDefault(_axios);

var _antd = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var REMOVE_UPLOAD_FILE = { type: types.REMOVE_UPLOAD_FILE };

var removeUploadFIle = exports.removeUploadFIle = function removeUploadFIle(fileName) {
    return function (dispatch, getState) {
        var fd = new FormData();
        fd.append('fileName', fileName);
        _axios2.default.post(prefixUri + '/uploadremove', fd).then(function (response) {
            var data = response.data;

            if (data.success) {
                _antd.message.success('删除附件成功！');
            } else {
                _antd.message.error('删除附件失败！');
            }
        });
    };
};
var removeUploadFIles = exports.removeUploadFIles = function removeUploadFIles(fileName) {
    return function (dispatch, getState) {
        var fd = new FormData();
        fd.append('fileName', fileName);
        _axios2.default.post(prefixUri + '/uploadremove', fd).then(function (response) {
            var data = response.data;

            if (data.success) {}
        });
    };
};

/***/ }),

/***/ 392:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.editVideo = exports.hideMemoModal = exports.showMemoModal = exports.resetEntryPerson = exports.getEntryPerson = exports.getTaskProgress = exports.resumeAccount = exports.resumeWareHousing = exports.getDateMemoContent = exports.getMemoContent = exports.addMemoContent = exports.getUrgentTasks = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _home = __webpack_require__(219);

var types = _interopRequireWildcard(_home);

var _ajax = __webpack_require__(12);

var _antd = __webpack_require__(18);

var _store = __webpack_require__(28);

var _store2 = _interopRequireDefault(_store);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var URGENT_TASKS = { type: types.URGENT_TASKS };

var RESUME = { type: types.RESUME };

var RESUMEACCOUNT = { type: types.RESUMEACCOUNT };

var TASK_PROGRESS = { type: types.TASK_PROGRESS };

var GET_ENTRY_START = { type: types.GET_ENTRY_START };
var GET_ENTRY_DONE = { type: types.GET_ENTRY_DONE };
var GET_ENTRY_LIST = { type: types.GET_ENTRY_LIST };

var SHOW_MEMO_MODAL = { type: types.SHOW_MEMO_MODAL };
var HIDE_MEMO_MODAL = { type: types.HIDE_MEMO_MODAL };

var ADD_MEMO_EVENT = { type: types.ADD_MEMO_EVENT };

var GET_MEMO_CONTENT = { type: types.GET_MEMO_CONTENT };

var GET_DATE_MEMO_CONTENT = { type: types.GET_DATE_MEMO_CONTENT };

var GET_VIDEO = { type: types.GET_VIDEO };

var getUrgentTasks = exports.getUrgentTasks = function getUrgentTasks() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (dispatch, getState) {
        (0, _ajax.AjaxByToken)('UrgentTasks', {
            head: {
                transcode: 'L0007'
            },
            data: data
        }).then(function (res) {
            dispatch((0, _extends3.default)({}, URGENT_TASKS, { urgentTasks: res.list }));
        }, function (err) {
            dispatch((0, _extends3.default)({}, URGENT_TASKS, { urgentTasks: [] }));
        });
    };
};

var addMemoContent = exports.addMemoContent = function addMemoContent() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var props = arguments[1];
    var onDateMM = arguments[2];
    return function (dispatch, getState) {
        (0, _ajax.AjaxByToken)('employeeinfo/memosEdit', {
            head: {
                transcode: 'L0067'
            },
            data: data
        }).then(function (res) {
            var getMemoContent = props.getMemoContent;

            getMemoContent(onDateMM);
            _antd.notification.success({ message: '添加备忘录成功' });
        }, function (err) {
            _antd.notification.error({ message: '添加备忘录失败' });
        });
    };
};
var getMemoContent = exports.getMemoContent = function getMemoContent(data) {
    return function (dispatch, getState) {
        (0, _ajax.AjaxByToken)('employeeinfo/memosList', {
            head: {
                transcode: 'L0068'
            },
            data: data
        }).then(function (res) {
            dispatch((0, _extends3.default)({}, GET_MEMO_CONTENT, { MemoContent: res.result }));
        }, function (err) {
            _antd.notification.error({ message: '获取备忘录失败' });
            dispatch((0, _extends3.default)({}, GET_MEMO_CONTENT, { MemoContent: [] }));
        });
    };
};
var getDateMemoContent = exports.getDateMemoContent = function getDateMemoContent(data) {
    return function (dispatch, getState) {
        (0, _ajax.AjaxByToken)('employeeinfo/memosList', {
            head: {
                transcode: 'L0068'
            },
            data: data
        }).then(function (res) {
            dispatch((0, _extends3.default)({}, GET_DATE_MEMO_CONTENT, { DateMemoContent: res.result }));
        }, function (err) {
            _antd.message.error(data.onDate + '\u5907\u5FD8\u5F55\u83B7\u53D6\u5931\u8D25');
            dispatch((0, _extends3.default)({}, GET_DATE_MEMO_CONTENT, { DateMemoContent: [] }));
        });
    };
};

var resumeWareHousing = exports.resumeWareHousing = function resumeWareHousing() {
    var latestDays = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 7;
    return function (dispatch, getState) {
        (0, _ajax.AjaxByToken)('ResumeWareHousing', {
            head: {
                transcode: 'L0008'
            },
            data: {
                latestDays: latestDays + ''
            }
        }).then(function (res) {
            dispatch((0, _extends3.default)({}, RESUME, { resumeData: res }));
        }, function (err) {
            _antd.notification.error({ message: res.returnMsg });
            dispatch((0, _extends3.default)({}, RESUME, { resumeData: { content: [] } }));
        });
    };
};

var resumeAccount = exports.resumeAccount = function resumeAccount(keyTime) {
    return function (dispatch, getState) {
        (0, _ajax.AjaxByToken)('ResumeAccount', {
            head: {
                transcode: 'L0069'
            },
            data: {
                keyTime: "30"
            }
        }).then(function (res) {
            dispatch((0, _extends3.default)({}, RESUMEACCOUNT, { resumeCount: res }));
        }, function (err) {
            dispatch((0, _extends3.default)({}, RESUMEACCOUNT, { resumeCount: {} }));
        });
    };
};

var getTaskProgress = exports.getTaskProgress = function getTaskProgress(latestDays) {
    return function (dispatch, getState) {
        (0, _ajax.AjaxByToken)('TaskCompletion', {
            head: {
                transcode: 'L0009'
            },
            data: {
                latestDays: latestDays + '' }
        }).then(function (res) {
            dispatch((0, _extends3.default)({}, TASK_PROGRESS, { taskProgress: res.content }));
        }, function (err) {
            dispatch((0, _extends3.default)({}, TASK_PROGRESS, { taskProgress: [1] }));
        });
    };
};

var getEntryPerson = exports.getEntryPerson = function getEntryPerson() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (dispatch, getState) {
        dispatch(GET_ENTRY_START);
        (0, _ajax.AjaxByToken)('home_personnelList', {
            head: {
                transcode: 'L0010'
            },
            data: data
        }).then(function (res) {
            dispatch(GET_ENTRY_DONE);
            dispatch((0, _extends3.default)({}, GET_ENTRY_LIST, { entryPersonList: res.content }));
        }, function (err) {
            dispatch(GET_ENTRY_DONE);
            dispatch((0, _extends3.default)({}, GET_ENTRY_LIST, { entryPersonList: [] }));
        });
    };
};

var resetEntryPerson = exports.resetEntryPerson = function resetEntryPerson() {
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, GET_ENTRY_LIST, { entryPersonList: [] }));
    };
};

var showMemoModal = exports.showMemoModal = function showMemoModal() {
    return function (dispatch, getState) {
        dispatch(SHOW_MEMO_MODAL);
    };
};

var hideMemoModal = exports.hideMemoModal = function hideMemoModal() {
    return function (dispatch, getState) {
        dispatch(HIDE_MEMO_MODAL);
    };
};

var editVideo = exports.editVideo = function editVideo(data) {
    return function (dispatch, getState) {
        (0, _ajax.AjaxByToken)('structure/companyVideo', {
            head: {
                transcode: 'L0086'
            },
            data: data
        }).then(function (res) {
            dispatch((0, _extends3.default)({}, GET_VIDEO, { video: res.video }));
            var type = data.type;

            if (type == "1") {
                _antd.notification.success({ message: '成功添加企业视频' });
            } else if (type == "2") {
                _antd.notification.success({ message: '成功修改企业视频' });
            } else if (type == "3") {
                _antd.notification.success({ message: '成功删除企业视频' });
            }
        }, function (err) {});
    };
};

/***/ }),

/***/ 393:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hideRobotCallModal = exports.showRobotCallModal = exports.getPhoneLogInfoByRID = exports.triSingleCall = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _intellHR = __webpack_require__(220);

var types = _interopRequireWildcard(_intellHR);

var _ajax = __webpack_require__(12);

var _antd = __webpack_require__(18);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SINGLECALL = { type: types.SINGLECALL };

var PHONELOGINFO = { type: types.PHONELOGINFO };

var SHOW_ROBOT_CALL_MODAL = { type: types.SHOW_ROBOT_CALL_MODAL };
var HIDE_ROBOT_CALL_MODAL = { type: types.HIDE_ROBOT_CALL_MODAL };

var triSingleCall = exports.triSingleCall = function triSingleCall(data) {
    return function (dispatch, getState) {
        (0, _ajax.AjaxByRobotPost)('singleCallByMobile', data).then(function (res) {
            dispatch(SINGLECALL);
            _antd.notification.success({
                message: '提示',
                description: '外呼成功'
            });
        }, function (err) {
            _antd.notification.error({ message: err.data.returnMsg });
        });
    };
};

var getPhoneLogInfoByRID = exports.getPhoneLogInfoByRID = function getPhoneLogInfoByRID(data) {
    return function (dispatch, getState) {
        var uri = 'getPhoneLogInfoByRID';
        (0, _ajax.cancelRequestByKey)(uri);
        (0, _ajax.AjaxByRobotPost)(uri, data).then(function (res) {
            if (res.returnCode == '900') {
                dispatch((0, _extends3.default)({}, PHONELOGINFO, { phoneLogInfo: res.returnCode }));
            } else {
                dispatch((0, _extends3.default)({}, PHONELOGINFO, { phoneLogInfo: res }));
            }
        }, function (err) {
            _antd.notification.error({ message: err.data.returnMsg });
        });
    };
};

var showRobotCallModal = exports.showRobotCallModal = function showRobotCallModal(data) {
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, SHOW_ROBOT_CALL_MODAL));
    };
};

var hideRobotCallModal = exports.hideRobotCallModal = function hideRobotCallModal(data) {
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, HIDE_ROBOT_CALL_MODAL));
    };
};

/***/ }),

/***/ 394:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getinterviewslist = exports.hideInterviewModal = exports.showInterviewModal = exports.searchInterview = exports.addInterviews = exports.cancelInterviews = exports.getinterviews = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _interview = __webpack_require__(221);

var types = _interopRequireWildcard(_interview);

var _ajax = __webpack_require__(12);

var _antd = __webpack_require__(18);

var _axios = __webpack_require__(35);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultData = {};

var INTERVIEW_TABLE_DATA = {
  type: types.INTERVIEW_TABLE_DATA
};

var LOAD_TABLE_START = {
  type: types.LOAD_TABLE_START
};
var LOAD_TABLE_DONE = {
  type: types.LOAD_TABLE_DONE
};

var SHOW_INTERVIEW_MODAL = {
  type: types.SHOW_INTERVIEW_MODAL
};

var HIDE_INTERVIEW_MODAL = {
  type: types.HIDE_INTERVIEW_MODAL
};

var INTERVIEW_LIST_DATA = {
  type: types.INTERVIEW_LIST_DATA
};
var getinterviews = exports.getinterviews = function getinterviews(skip, key) {
  return function (dispatch, getState) {
    var uri = 'getinterviewers';
    (0, _ajax.cancelRequestByKey)(uri);
    dispatch(LOAD_TABLE_START);
    (0, _ajax.AjaxByToken)(uri, {
      head: {
        transcode: 'L0105'
      },
      data: {
        skip: skip ? skip : 0,
        count: 10,
        key: key
      }
    }).then(function (res) {
      dispatch(LOAD_TABLE_DONE);
      dispatch((0, _extends3.default)({}, INTERVIEW_TABLE_DATA, {
        interviewData: res
      }));
    }, function (err) {
      dispatch(LOAD_TABLE_DONE);
    });
  };
};
var cancelInterviews = exports.cancelInterviews = function cancelInterviews(rid) {
  return function (dispatch, getState) {
    var uri = 'updinterviewer';
    (0, _ajax.cancelRequestByKey)(uri);
    dispatch(LOAD_TABLE_START);
    (0, _ajax.AjaxByToken)(uri, {
      head: {
        transcode: 'L0106'
      },
      data: {
        rid: rid,
        type: 2
      }
    }).then(function (res) {
      _antd.notification.success({
        message: '提示',
        description: '取消设置成功'

      });
      dispatch(LOAD_TABLE_DONE);
    }, function (err) {
      dispatch(LOAD_TABLE_DONE);
    });
  };
};
var addInterviews = exports.addInterviews = function addInterviews(rid, index, list) {
  return function (dispatch, getState) {
    var that = undefined;
    var uri = 'updinterviewer';
    (0, _ajax.cancelRequestByKey)(uri);
    dispatch(LOAD_TABLE_START);
    (0, _ajax.AjaxByToken)(uri, {
      head: {
        transcode: 'L0106'
      },
      data: {
        rid: rid,
        type: 1
      }
    }).then(function (res) {
      _antd.message.success('添加面试官成功！');
      list.forEach(function (item) {
        item.isInterviewer = list[index].isInterviewer = 1;
      });
    }, function (err) {
      dispatch(LOAD_TABLE_DONE);
    });
  };
};

var searchInterview = exports.searchInterview = function searchInterview(key) {
  return function (dispatch, getState) {
    var uri = 'getinterviewers';
    (0, _ajax.cancelRequestByKey)(uri);
    dispatch(LOAD_TABLE_START);
    (0, _ajax.AjaxByToken)(uri, {
      head: {
        transcode: 'L0105'
      },
      data: {
        skip: 0,
        count: 10,
        key: key
      }
    }).then(function (res) {
      dispatch(LOAD_TABLE_DONE);
      dispatch((0, _extends3.default)({}, INTERVIEW_TABLE_DATA, {
        interviewData: res
      }));
    }, function (err) {
      dispatch(LOAD_TABLE_DONE);
    });
  };
};
var showInterviewModal = exports.showInterviewModal = function showInterviewModal() {
  return function (dispatch, getState) {
    dispatch(SHOW_INTERVIEW_MODAL);
  };
};
var hideInterviewModal = exports.hideInterviewModal = function hideInterviewModal() {
  return function (dispatch, getState) {
    dispatch(HIDE_INTERVIEW_MODAL);
  };
};
var getinterviewslist = exports.getinterviewslist = function getinterviewslist(skip, key) {
  return function (dispatch, getState) {
    var uri = 'emp/crewquery';
    (0, _ajax.cancelRequestByKey)(uri);
    dispatch(LOAD_TABLE_START);
    (0, _ajax.AjaxByToken)(uri, {
      head: {
        transcode: 'L0043'
      },
      data: {
        skip: skip ? skip + '' : '0',
        count: "10",
        sort: 'desc',
        key: key
      }
    }).then(function (res) {
      dispatch(LOAD_TABLE_DONE);
      dispatch((0, _extends3.default)({}, INTERVIEW_LIST_DATA, {
        interviewList: res
      }));
    }, function (err) {
      dispatch(LOAD_TABLE_DONE);
    });
  };
};

/***/ }),

/***/ 395:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hideSalaryModal = exports.showSalaryModal = exports.cancellResumeId = exports.getResumeId = exports.hideSaveJobModal = exports.showSaveJobModal = exports.hideJobModal = exports.showJobModal = exports.createJob = exports.cancelSalary = exports.searchSalary = exports.abortJobInfo = exports.chooseAddInterviewList = exports.resetForm = exports.clearChoosedStatus = exports.getJobInfo = exports.getJobList = exports.getJobCategory = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _job = __webpack_require__(222);

var types = _interopRequireWildcard(_job);

var _ajax = __webpack_require__(12);

var _axios = __webpack_require__(35);

var _axios2 = _interopRequireDefault(_axios);

var _antd = __webpack_require__(18);

var _isNumber = __webpack_require__(207);

var _isNumber2 = _interopRequireDefault(_isNumber);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var JOB_CATEGORY = { type: types.JOB_CATEGORY };

var LOAD_CATEGORY_START = { type: types.LOAD_CATEGORY_START };
var LOAD_CATEGORY_DONE = { type: types.LOAD_CATEGORY_DONE };

var JOB_LIST = { type: types.JOB_LIST };

var LOAD_LIST_START = { type: types.LOAD_LIST_START };
var LOAD_LIST_DONE = { type: types.LOAD_LIST_DONE };

var JOB_INFO = { type: types.JOB_INFO };

var LOAD_INFO_START = { type: types.LOAD_INFO_START };
var LOAD_INFO_DONE = { type: types.LOAD_INFO_DONE };

var ABORT_JOB_START = { type: types.ABORT_JOB_START };
var ABORT_JOB_DONE = { type: types.ABORT_JOB_DONE };
var ABORT_JOB_INFO = { type: types.ABORT_JOB_INFO };

var CREATE_JOB_START = { type: types.CREATE_JOB_START };
var CREATE_JOB_DONE = { type: types.CREATE_JOB_DONE };

var SHOW_JOB_MODAL = { type: types.SHOW_JOB_MODAL };
var HIDE_JOB_MODAL = { type: types.HIDE_JOB_MODAL };

var SHOW_SAVEJOB_MODAL = { type: types.SHOW_SAVEJOB_MODAL };
var HIDE_SAVEJOB_MODAL = { type: types.HIDE_SAVEJOB_MODAL };

var RESET_FORM = { type: types.RESET_FORM };

var RESUMEID = { type: types.RESUMEID };

var CANCELLRESUMEID = { type: types.CANCELLRESUMEID };

var SHOW_SALARY_MODAL = { type: types.SHOW_SALARY_MODAL };
var HIDE_SALARY_MODAL = { type: types.HIDE_SALARY_MODAL };

var SALARYDATA = { type: types.SALARYDATA };
var CANCELSALARY = { type: types.CANCELSALARY };

var ADD_TAGLIST = { type: types.ADD_TAGLIST };

var CLEAR_CHOOSED_STATUS = { type: types.CLEAR_CHOOSED_STATUS };

var getJobCategory = exports.getJobCategory = function getJobCategory() {
  return function (dispatch, getState) {
    dispatch(LOAD_CATEGORY_START);
    (0, _ajax.AjaxByToken)("PositionStatus", {
      head: {
        transcode: "L0011"
      }
    }).then(function (res) {
      dispatch(LOAD_CATEGORY_DONE);
      dispatch((0, _extends3.default)({}, JOB_CATEGORY, { categoryData: res }));
    }, function (err) {
      dispatch(LOAD_CATEGORY_DONE);
    });
  };
};

var getJobList = exports.getJobList = function getJobList() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (dispatch, getState) {
    if ((0, _isNumber2.default)(data.skip)) data.skip = data.skip + "";
    var uri = "PositionQuery";
    (0, _ajax.cancelRequestByKey)(uri);
    NProgress.start();
    dispatch(LOAD_LIST_START);
    (0, _ajax.AjaxByToken)(uri, {
      head: {
        transcode: "L0012"
      },
      data: (0, _extends3.default)({}, data)
    }).then(function (res) {
      dispatch(LOAD_LIST_DONE);
      dispatch((0, _extends3.default)({}, JOB_LIST, { listData: res }));
    }, function (err) {
      dispatch(LOAD_LIST_DONE);
    });
  };
};

var getJobInfo = exports.getJobInfo = function getJobInfo(data) {
  return function (dispatch, getState) {
    dispatch(LOAD_INFO_START);
    (0, _ajax.AjaxByToken)("lookposition", {
      head: {
        transcode: "L0014"
      },
      data: data
    }).then(function (res) {
      dispatch(LOAD_INFO_DONE);
      dispatch((0, _extends3.default)({}, JOB_INFO, { jobInfo: res.entity || {} }));
      if (res.entity.interviewers) {
        res.entity.interviewers.map(function (obj, idx) {
          obj.userid = obj.interviewerid;
          obj.name = obj.interviewerName;
          return obj;
        });
        dispatch((0, _extends3.default)({}, ADD_TAGLIST, { tagList: res.entity.interviewers || [] }));
      }
    });
  };
};

var clearChoosedStatus = exports.clearChoosedStatus = function clearChoosedStatus() {
  return function (dispatch, getState) {
    dispatch(CLEAR_CHOOSED_STATUS);
  };
};

var resetForm = exports.resetForm = function resetForm() {
  return function (dispatch, getState) {
    dispatch((0, _extends3.default)({}, ADD_TAGLIST, { tagList: [] }));
    dispatch(RESET_FORM);
  };
};
var chooseAddInterviewList = exports.chooseAddInterviewList = function chooseAddInterviewList(list) {
  return function (dispatch, getState) {
    dispatch((0, _extends3.default)({}, ADD_TAGLIST, { tagList: list }));
  };
};

var abortJobInfo = exports.abortJobInfo = function abortJobInfo(data, getJobList, getJobCategory) {
  return function (dispatch, getState) {
    if (!data.positionid) return;

    dispatch(ABORT_JOB_START);
    (0, _ajax.AjaxByToken)("OnStopPosition", {
      head: {
        transcode: "L0038"
      },
      data: data
    }).then(function (res) {
      dispatch(ABORT_JOB_DONE);
      dispatch(HIDE_JOB_MODAL);
      getJobCategory();
      getJobList();
    }, function (err) {
      dispatch(ABORT_JOB_DONE);
    });
  };
};
var searchSalary = exports.searchSalary = function searchSalary(jobpostids, functions, position) {
  return function (dispatch, getState) {
    $.ajax({
      url: "http://www.51jrq.com/vita/m/salary/findbyjob",
      type: "post",
      data: {
        industry: jobpostids,
        functions: functions,
        positions: position
      },
      success: function success(data) {
        if (JSON.parse(data).result) {
          dispatch((0, _extends3.default)({}, SALARYDATA, { salaryData: JSON.parse(data).d.resultlist }));
        } else {
          _antd.notification.error({
            message: JSON.parse(data).msg
          });
        }
      },
      error: function error(err) {
        _antd.notification.error({
          message: "请求失败！"
        });
      }
    });
  };
};
var cancelSalary = exports.cancelSalary = function cancelSalary() {
  return function (dispatch, getState) {
    dispatch(CANCELSALARY);
  };
};

var createJob = exports.createJob = function createJob(data, context) {
  return function (dispatch, getState) {
    NProgress.start();
    dispatch(CREATE_JOB_START);
    (0, _ajax.AjaxByToken)("saveorupdateposition", {
      head: {
        transcode: "L0013"
      },
      data: data
    }).then(function (res) {
      if (context) {
        context();
        _antd.notification.success({
          message: "修改成功!"
        });
        return false;
      }
      dispatch(SHOW_SAVEJOB_MODAL);
      dispatch((0, _extends3.default)({}, ADD_TAGLIST, { tagList: [] }));

      dispatch(CREATE_JOB_DONE);
    }, function (err) {
      dispatch(CREATE_JOB_DONE);
    });
  };
};

var showJobModal = exports.showJobModal = function showJobModal() {
  return function (dispatch, getState) {
    dispatch(SHOW_JOB_MODAL);
  };
};

var hideJobModal = exports.hideJobModal = function hideJobModal() {
  return function (dispatch, getState) {
    dispatch(HIDE_JOB_MODAL);
  };
};

var showSaveJobModal = exports.showSaveJobModal = function showSaveJobModal() {
  return function (dispatch, getState) {
    dispatch(SHOW_SAVEJOB_MODAL);
  };
};

var hideSaveJobModal = exports.hideSaveJobModal = function hideSaveJobModal() {
  return function (dispatch, getState) {
    dispatch(HIDE_SAVEJOB_MODAL);
  };
};

var getResumeId = exports.getResumeId = function getResumeId(data) {
  return function (dispatch, getState) {
    dispatch((0, _extends3.default)({}, RESUMEID, { interview: data }));
  };
};

var cancellResumeId = exports.cancellResumeId = function cancellResumeId(data) {
  return function (dispatch, getState) {
    dispatch((0, _extends3.default)({}, CANCELLRESUMEID, { interview: data }));
  };
};

var showSalaryModal = exports.showSalaryModal = function showSalaryModal(value) {
  return function (dispatch, getState) {
    dispatch((0, _extends3.default)({}, SHOW_SALARY_MODAL, { positionSalary: value }));
  };
};

var hideSalaryModal = exports.hideSalaryModal = function hideSalaryModal() {
  return function (dispatch, getState) {
    dispatch(HIDE_SALARY_MODAL);
  };
};

/***/ }),

/***/ 396:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hideLoading = exports.userLogin = undefined;

var _login = __webpack_require__(129);

var types = _interopRequireWildcard(_login);

var _blueimpMd = __webpack_require__(365);

var _blueimpMd2 = _interopRequireDefault(_blueimpMd);

var _ajax = __webpack_require__(12);

var _store = __webpack_require__(28);

var _store2 = _interopRequireDefault(_store);

var _extend = __webpack_require__(367);

var _extend2 = _interopRequireDefault(_extend);

var _pick = __webpack_require__(363);

var _pick2 = _interopRequireDefault(_pick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var LOGIN_START = { type: types.LOGIN_START };
var LOGIN_DONE = { type: types.LOGIN_DONE };

var userLogin = exports.userLogin = function userLogin() {
    var userInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var context = arguments[1];
    return function (dispatch, getState) {
        dispatch(LOGIN_START);
        userInfo.password = (0, _blueimpMd2.default)(userInfo.password);
        (0, _ajax.AjaxByPost)('login', {
            head: {
                transcode: 'L0001'
            },
            data: userInfo
        }).then(function (res) {
            dispatch(LOGIN_DONE);
            var data = (0, _pick2.default)(res, ['token', 'tokenKey']);
            _store2.default.set('token', data);
            context.router.push('/');
        }, function (err) {
            dispatch(LOGIN_DONE);
        });
    };
};

var hideLoading = exports.hideLoading = function hideLoading() {
    return function (dispatch, getState) {
        dispatch(LOGIN_DONE);
    };
};

/***/ }),

/***/ 397:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.userLoginout = undefined;

var _login = __webpack_require__(129);

var types = _interopRequireWildcard(_login);

var _ajax = __webpack_require__(12);

var _store = __webpack_require__(28);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var userLoginout = exports.userLoginout = function userLoginout(context) {
    return function (dispatch, getState) {
        (0, _ajax.AjaxByToken)('loginout', {
            head: {
                transcode: 'L0000'
            }
        }).then(function (res) {
            _store2.default.remove('token');
            context.router.push('/login');
        });
    };
};

/***/ }),

/***/ 398:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.arrangeDepartmentFuc = exports.getArrangeDepartment = exports.deleteMechnism = exports.getOrganizeChart = exports.deleteDepartment = exports.refreshDepartmentInfo = exports.addEditDepartment = exports.editMechnism = exports.addMechnism = exports.getDepartMentStaff = exports.changeTableData = exports.getTreeList = exports.getDepartMentList = exports.getEmployeeQuality = exports.getArchivesData = exports.hidePersonalMaterialModal = exports.showPersonalMaterialModal = exports.editEmployeeInformation = exports.cancelProgress = exports.showProgress = exports.downloadMaterial = exports.getLeaveArchivesList = exports.getArchivesList = exports.hideResumeModal = exports.showResumeModal = exports.getEmployeeResumeInfo = exports.showcredit = exports.hidecredit = exports.searchCredit = exports.cancelData = exports.searchCreditInvestgation = exports.DeleteMaterial = exports.getBDLink = exports.upInfoLicense = exports.isPreviewLicense = exports.downloadAttachment = exports.cancelImageUrl = exports.hideImageModal = exports.showImageModal = exports.viewUploadAttachment = exports.UploadMaterial = exports.getOperationList = exports.hideAttachmentModal = exports.showAttachmentModal = exports.mobilizeEmployee = exports.hideTransferPersonnelModal = exports.showTransferPersonnelModal = exports.hidePermanentModal = exports.showPermanentModal = exports.positiveEmployees = exports.departureEmployees = exports.hideDismissionModal = exports.showDismissionModal = exports.queryResetForm = exports.queryEmployee = exports.setResetFormFalse = exports.uploadClerkExcel = exports.downloadTememployees = exports.getStaffLink = exports.hideStaffModal = exports.showStaffModal = exports.hideUploadClerkModal = exports.showUploadClerkModal = exports.deleteEmployees = exports.stopExportEmployees = exports.startExportEmployees = exports.getCrewList = exports.getCrewStatis = undefined;

var _stringify = __webpack_require__(336);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _manage = __webpack_require__(223);

var types = _interopRequireWildcard(_manage);

var _axios = __webpack_require__(35);

var _axios2 = _interopRequireDefault(_axios);

var _store = __webpack_require__(28);

var _store2 = _interopRequireDefault(_store);

var _fileSaver = __webpack_require__(279);

var _fileSaver2 = _interopRequireDefault(_fileSaver);

var _ajax = __webpack_require__(12);

var _antd = __webpack_require__(18);

var _isNumber = __webpack_require__(207);

var _isNumber2 = _interopRequireDefault(_isNumber);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GET_MANAGE_START = { type: types.GET_MANAGE_START };
var GET_MANAGE_END = { type: types.GET_MANAGE_END };
var GET_MANAGE_STATISTICS = { type: types.GET_MANAGE_STATISTICS };

var LOAD_LIST_START = { type: types.LOAD_LIST_START };
var LOAD_LIST_DONE = { type: types.LOAD_LIST_DONE };
var LOAD_CREW_LIST = { type: types.LOAD_CREW_LIST };

var SHOW_UPLOAD_CLERK_MODAL = { type: types.SHOW_UPLOAD_CLERK_MODAL };
var HIDE_UPLOAD_CLERK_MODAL = { type: types.HIDE_UPLOAD_CLERK_MODAL };
var UPLOAD_CLERK_START = { type: types.UPLOAD_CLERK_START };
var UPLOAD_CLERK_DONE = { type: types.UPLOAD_CLERK_DONE };
var SET_RESETFORM_TRUE = { type: types.SET_RESETFORM_TRUE };
var SET_RESETFORM_FALSE = { type: types.SET_RESETFORM_FALSE };

var EXPORT_CLERK_START = { type: types.EXPORT_CLERK_START };
var EXPORT_CLERK_DONE = { type: types.EXPORT_CLERK_DONE };

var DELETE_EMPLOYEE_START = { type: types.DELETE_EMPLOYEE_START };
var DELETE_EMPLOYEE_DONE = { type: types.DELETE_EMPLOYEE_DONE };

var QUERY_EMPLOYEE_START = { type: types.QUERY_EMPLOYEE_START };
var QUERY_EMPLOYEE_DONE = { type: types.QUERY_EMPLOYEE_DONE };
var QUERY_EMPLOYEE_LIST = { type: types.QUERY_EMPLOYEE_LIST };
var QUERY_RESET_FORM = { type: types.QUERY_RESET_FORM };

var SHOW_DISMISSION_MODAL = { type: types.SHOW_DISMISSION_MODAL };
var HIDE_DISMISSION_MODAL = { type: types.HIDE_DISMISSION_MODAL };

var SHOW_FORMAL_MODAL = { type: types.SHOW_FORMAL_MODAL };
var HIDE_FORMAL_MODAL = { type: types.HIDE_FORMAL_MODAL };

var SHOW_TRANSFER_PERSONNEL_MODAL = { type: types.SHOW_TRANSFER_PERSONNEL_MODAL };;
var HIDE_TRANSFER_PERSONNEL_MODAL = { type: types.HIDE_TRANSFER_PERSONNEL_MODAL };

var MOBILIZE_EMPLOYEE_START = { type: types.MOBILIZE_EMPLOYEE_START };
var MOBILIZE_EMPLOYEE_DONE = { type: types.MOBILIZE_EMPLOYEE_DONE };

var SHOW_ATTACHMENT_MODAL = { type: types.SHOW_ATTACHMENT_MODAL };
var HIDE_ATTACHMENT_MODAL = { type: types.HIDE_ATTACHMENT_MODAL };

var OPERATION_LIST_START = { type: types.OPERATION_LIST_START };
var OPERATION_LIST_DONE = { type: types.OPERATION_LIST_DONE };
var OPERATION_LIST = { type: types.OPERATION_LIST };

var LOAD_EMPLOYEEINFO_START = { type: types.LOAD_EMPLOYEEINFO_START };
var LOAD_EMPLOYEEINFO_DONE = { type: types.LOAD_EMPLOYEEINFO_DONE };
var LOAD_EMPLOYEEINFO = { type: types.LOAD_EMPLOYEEINFO };

var CREDITINVESTGATION_START = { type: types.CREDITINVESTGATION_START };
var CREDITINVESTGATION_DONE = { type: types.CREDITINVESTGATION_DONE };
var CREDITINVESTGATION = { type: types.CREDITINVESTGATION };
var SEARCHCREDITINVESTGATION = { type: types.SEARCHCREDITINVESTGATION };
var SEARCHCREDITINVESTGATION_START = { type: types.SEARCHCREDITINVESTGATION_START };
var CREDITINVESTGATIONSTATE = { type: types.CREDITINVESTGATIONSTATE };
var HIDECREDITINVESTGATIONSTATE = { type: types.HIDECREDITINVESTGATIONSTATE };
var CANCELDATA = { type: types.CANCELDATA };

var CANCELLOADING = { type: types.CANCELLOADING };

var SHOW_INFO_MODAL = { type: types.SHOW_INFO_MODAL };
var HIDE_INFO_MODAL = { type: types.HIDE_INFO_MODAL };

var IMAGEURL = { type: types.IMAGEURL };
var SHOW_IMAGE_MODAL = { type: types.SHOW_IMAGE_MODAL };
var HIDE_IMAGE_MODAL = { type: types.HIDE_IMAGE_MODAL };
var CANCELIMAGEURL = { type: types.CANCELIMAGEURL };

var IS_PREVIEW_IMAGE = { type: types.IS_PREVIEW_IMAGE };
var IS_PREVIEW_IMAGE_START = { type: types.IS_PREVIEW_IMAGE_START };
var IS_PREVIEW_IMAGE_DONE = { type: types.IS_PREVIEW_IMAGE_DONE };

var SHOW_STAFF_MODAL = { type: types.SHOW_STAFF_MODAL };
var HIDE_STAFF_MODAL = { type: types.HIDE_STAFF_MODAL };

var GET_STAFF_LINK = { type: types.GET_STAFF_LINK };

var GET_STAFF_LINK_START = { type: types.GET_STAFF_LINK_START };
var GET_STAFF_LINK_DONE = { type: types.GET_STAFF_LINK_DONE };

var getCrewStatis = exports.getCrewStatis = function getCrewStatis() {
    return function (dispatch, getState) {
        dispatch(GET_MANAGE_START);
        (0, _ajax.AjaxByToken)('emp/crewstatis', {
            head: {
                transcode: 'L0042'
            }
        }).then(function (res) {
            dispatch(GET_MANAGE_END);
            dispatch((0, _extends3.default)({}, GET_MANAGE_STATISTICS, { list: res }));
        }, function (err) {
            dispatch(GET_MANAGE_END);
            dispatch((0, _extends3.default)({}, GET_MANAGE_STATISTICS, { list: [] }));
        });
    };
};

var getCrewList = exports.getCrewList = function getCrewList() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (dispatch, getState) {
        if ((0, _isNumber2.default)(data.skip)) data.skip = data.skip + '';
        var uri = 'emp/crewquery';
        (0, _ajax.cancelRequestByKey)(uri);
        NProgress.start();
        dispatch(LOAD_LIST_START);
        (0, _ajax.AjaxByToken)(uri, {
            head: {
                transcode: 'L0043'
            },
            data: (0, _extends3.default)({}, data, { count: 20 + '' })
        }).then(function (res) {
            dispatch(LOAD_LIST_DONE);
            dispatch((0, _extends3.default)({}, LOAD_CREW_LIST, { list: res.list, count: res.count }));
        }, function (err) {
            dispatch(LOAD_LIST_DONE);
        });
    };
};

var startExportEmployees = exports.startExportEmployees = function startExportEmployees(data) {
    return function (dispatch, getState) {
        NProgress.start();
        dispatch(EXPORT_CLERK_START);
    };
};

var stopExportEmployees = exports.stopExportEmployees = function stopExportEmployees() {
    return function (dispatch, getState) {
        NProgress.done();
        dispatch(EXPORT_CLERK_DONE);
    };
};

var deleteEmployees = exports.deleteEmployees = function deleteEmployees(data) {
    var getCrewStatis = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
    return function (dispatch, getState) {
        dispatch(DELETE_EMPLOYEE_START);
        (0, _ajax.AjaxByToken)('emp/delete_employees', {
            head: {
                transcode: 'L0047'
            },
            data: data
        }).then(function (res) {
            dispatch(DELETE_EMPLOYEE_DONE);
            _antd.notification.success({
                message: '成功',
                description: '删除人员成功'
            });

            getCrewStatis();
        }, function (err) {
            dispatch(DELETE_EMPLOYEE_DONE);
        });
    };
};

var showUploadClerkModal = exports.showUploadClerkModal = function showUploadClerkModal() {
    return function (dispatch, getState) {
        dispatch(SHOW_UPLOAD_CLERK_MODAL);
    };
};
var hideUploadClerkModal = exports.hideUploadClerkModal = function hideUploadClerkModal() {
    return function (dispatch, getState) {
        dispatch(HIDE_UPLOAD_CLERK_MODAL);
    };
};

var showStaffModal = exports.showStaffModal = function showStaffModal() {
    return function (dispatch, getState) {
        dispatch(SHOW_STAFF_MODAL);
    };
};
var hideStaffModal = exports.hideStaffModal = function hideStaffModal() {
    return function (dispatch, getState) {
        dispatch(HIDE_STAFF_MODAL);
    };
};

var getStaffLink = exports.getStaffLink = function getStaffLink(companyid) {
    return function (dispatch, getState) {
        dispatch(GET_STAFF_LINK_START);
        (0, _ajax.AjaxByToken)('wxaul', {
            head: {
                transcode: 'L0123'
            },
            data: {
                query: 'companyid=' + companyid + '&topage=1'
            }
        }).then(function (res) {
            var key = "%!##@$%|$#$%(^)$}$*{^*+%";
            var sceneArgs = 'companyid=' + companyid;
            var params = (0, _stringify2.default)({
                head: { transcode: 'L0113', type: 'h' },
                data: { page: 'pages/canlogin', width: 258, scene: '' + sceneArgs }
            });
            var linkUrl = '' + (window.location.origin + window.prefixUri + '/createwxaqrcode?params=' + strEnc('' + params, key));

            dispatch((0, _extends3.default)({}, GET_STAFF_LINK, { staffLink: res.result.wxaul, linkUrl: linkUrl }));
            dispatch(GET_STAFF_LINK_DONE);
        }, function (err) {
            dispatch(GET_STAFF_LINK_DONE);
        });
    };
};

var downloadTememployees = exports.downloadTememployees = function downloadTememployees() {
    return function (dispatch, getState) {
        var token = _store2.default.get('token');
        (0, _axios2.default)({
            url: prefixUri + '/employeeinfo/downloadTememployees',
            method: 'get',
            responseType: 'arraybuffer'
        }).then(function (res) {
            var blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            _fileSaver2.default.saveAs(blob, '员工信息导入模板表.xlsx');
        }).catch(function (error) {});
    };
};

var uploadClerkExcel = exports.uploadClerkExcel = function uploadClerkExcel(data) {
    return function (dispatch, getState) {

        dispatch(UPLOAD_CLERK_START);
        (0, _ajax.AjaxByToken)('employeeinfo/excelSave', {
            head: {
                transcode: 'L0044'
            },
            data: data
        }).then(function (res) {
            dispatch(UPLOAD_CLERK_DONE);
            _antd.notification.success({
                message: '提示',
                description: res.upmsg
            });
            dispatch(SET_RESETFORM_TRUE);
            dispatch(HIDE_UPLOAD_CLERK_MODAL);
        }, function (err) {

            dispatch(UPLOAD_CLERK_DONE);
        });
    };
};

var setResetFormFalse = exports.setResetFormFalse = function setResetFormFalse() {
    return function (dispatch, getState) {
        dispatch(SET_RESETFORM_FALSE);
    };
};

var queryEmployee = exports.queryEmployee = function queryEmployee(data) {
    return function (dispatch, getState) {
        dispatch(QUERY_EMPLOYEE_START);
        (0, _ajax.AjaxByToken)('employeeinfo/queryEmployee', {
            head: {
                transcode: 'L0062'
            },
            data: data
        }).then(function (res) {
            dispatch(QUERY_EMPLOYEE_DONE);
            dispatch((0, _extends3.default)({}, QUERY_EMPLOYEE_LIST, { list: res }));
        }, function (err) {
            dispatch(QUERY_EMPLOYEE_DONE);
            dispatch((0, _extends3.default)({}, QUERY_EMPLOYEE_LIST, { list: {} }));
        });
    };
};
var queryResetForm = exports.queryResetForm = function queryResetForm() {
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, QUERY_RESET_FORM, { list: {} }));
    };
};

var showDismissionModal = exports.showDismissionModal = function showDismissionModal() {
    return function (dispatch, getState) {
        dispatch(SHOW_DISMISSION_MODAL);
    };
};
var hideDismissionModal = exports.hideDismissionModal = function hideDismissionModal() {
    return function (dispatch, getState) {
        dispatch(HIDE_DISMISSION_MODAL);
    };
};

var departureEmployees = exports.departureEmployees = function departureEmployees(data) {
    var getOperationList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
    return function (dispatch, getState) {
        var rid = data.rid;

        (0, _ajax.AjaxByToken)('emp/departure_employees', {
            head: {
                transcode: 'L0049'
            },
            data: data
        }).then(function (res) {
            _antd.notification.success({
                message: '提示',
                description: '成功办理离职！'
            });
            dispatch(HIDE_DISMISSION_MODAL);
            getOperationList({ rid: rid });
        }, function (err) {
            _antd.notification.error({
                message: '错误',
                description: '办理离职失败'
            });
        });
    };
};

var positiveEmployees = exports.positiveEmployees = function positiveEmployees(data) {
    var getOperationList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
    return function (dispatch, getState) {
        var rid = data.rid;

        (0, _ajax.AjaxByToken)('emp/positive_employees', {
            head: {
                transcode: 'L0048'
            },
            data: data
        }).then(function (res) {
            _antd.notification.success({
                message: '提示',
                description: '转正成功！'
            });
            dispatch(HIDE_FORMAL_MODAL);
            getOperationList({ rid: rid });
        }, function (err) {
            _antd.notification.error({
                message: '错误',
                description: '办理转正失败！'
            });
        });
    };
};

var showPermanentModal = exports.showPermanentModal = function showPermanentModal() {
    return function (dispatch, getState) {
        dispatch(SHOW_FORMAL_MODAL);
    };
};
var hidePermanentModal = exports.hidePermanentModal = function hidePermanentModal() {
    return function (dispatch, getState) {
        dispatch(HIDE_FORMAL_MODAL);
    };
};

var showTransferPersonnelModal = exports.showTransferPersonnelModal = function showTransferPersonnelModal() {
    return function (dispatch, getState) {
        dispatch(SHOW_TRANSFER_PERSONNEL_MODAL);
    };
};
var hideTransferPersonnelModal = exports.hideTransferPersonnelModal = function hideTransferPersonnelModal() {
    return function (dispatch, getState) {
        dispatch(HIDE_TRANSFER_PERSONNEL_MODAL);
    };
};

var mobilizeEmployee = exports.mobilizeEmployee = function mobilizeEmployee(data) {
    return function (dispatch, getState) {
        dispatch(MOBILIZE_EMPLOYEE_START);
        (0, _ajax.AjaxByToken)('emp/mobilize_employees', {
            head: {
                transcode: 'L0057'
            },
            data: data
        }).then(function (res) {
            dispatch(MOBILIZE_EMPLOYEE_DONE);
            _antd.notification.success({
                message: '提示',
                description: '人事调动成功！'
            });
            dispatch(HIDE_TRANSFER_PERSONNEL_MODAL);
        }, function (err) {
            dispatch(MOBILIZE_EMPLOYEE_DONE);
            _antd.notification.error({
                message: '错误',
                description: '人事调动失败！'
            });
        });
    };
};

var showAttachmentModal = exports.showAttachmentModal = function showAttachmentModal() {
    return function (dispatch, getState) {
        dispatch(SHOW_ATTACHMENT_MODAL);
    };
};
var hideAttachmentModal = exports.hideAttachmentModal = function hideAttachmentModal() {
    return function (dispatch, getState) {
        dispatch(HIDE_ATTACHMENT_MODAL);
    };
};

var getOperationList = exports.getOperationList = function getOperationList(data) {
    return function (dispatch, getState) {
        if ((0, _isNumber2.default)(data.skip)) data.skip = data.skip + '';
        dispatch(OPERATION_LIST_START);
        (0, _ajax.AjaxByToken)('emp/operationList_employees', {
            head: {
                transcode: 'L0058'
            },
            data: data
        }).then(function (res) {
            dispatch(OPERATION_LIST_DONE);
            dispatch((0, _extends3.default)({}, OPERATION_LIST, { list: res.list, count: res.count }));
        }, function (err) {
            ;
            dispatch(OPERATION_LIST_DONE);
        });
    };
};

var UploadMaterial = exports.UploadMaterial = function UploadMaterial(data, queryEmployee) {
    return function (dispatch, getState) {
        (0, _ajax.AjaxByToken)('emp/data_employees', {
            head: {
                transcode: 'L0054'
            },
            data: data
        }).then(function (res) {
            queryEmployee({ rid: data.rid });
            _antd.notification.success({
                message: '提示',
                description: '材料附件上传成功！'
            });
        }, function (err) {
            ;
        });
    };
};
var viewUploadAttachment = exports.viewUploadAttachment = function viewUploadAttachment(data) {
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, IMAGEURL, { imageUrl: data }));
    };
};
var showImageModal = exports.showImageModal = function showImageModal(data) {
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, SHOW_IMAGE_MODAL, { attactmentType: data }));
    };
};
var hideImageModal = exports.hideImageModal = function hideImageModal() {
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, HIDE_IMAGE_MODAL));
    };
};
var cancelImageUrl = exports.cancelImageUrl = function cancelImageUrl() {
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, CANCELIMAGEURL));
    };
};
var downloadAttachment = exports.downloadAttachment = function downloadAttachment(name) {
    return function (dispatch, getState) {
        var token = _store2.default.get('token');
        (0, _axios2.default)({
            url: prefixUri + '/download_uploadAttachment',
            method: 'get',
            responseType: 'blob',
            params: {
                token: token.token,
                tokenKey: token.tokenKey,
                fileName: name
            }
        }).then(function (res) {
            var blob = new Blob([res.data]);
            _fileSaver2.default.saveAs(blob);
        }).catch(function (error) {});
    };
};
var isPreviewLicense = exports.isPreviewLicense = function isPreviewLicense() {
    return function (dispatch, getState) {
        dispatch(IS_PREVIEW_IMAGE_START);
        var token = _store2.default.get('token');
        (0, _ajax.AjaxByToken)('companyinfo', {
            head: {
                transcode: 'L0117'
            },
            data: {
                token: token.token,
                tokenKey: token.tokenKey
            }
        }).then(function (res) {
            if (res.result) {
                dispatch(IS_PREVIEW_IMAGE_DONE);
                dispatch((0, _extends3.default)({}, IS_PREVIEW_IMAGE, { companyInfo: res.result }));
            }
        }, function (err) {
            dispatch(IS_PREVIEW_IMAGE_DONE);
        });
    };
};

var upInfoLicense = exports.upInfoLicense = function upInfoLicense(file) {
    return function (dispatch, getState) {
        var token = _store2.default.get('token');
        var formData = new FormData();
        formData.append('license', file);
        formData.append('tokenKey', token.tokenKey);
        formData.append('token', token.token);

        (0, _axios2.default)({
            url: prefixUri + '/uploadlicense',
            method: 'post',
            data: formData
        }).then(function (res) {
            _antd.message.info("上传营业执照成功");
        }).catch(function (error) {
            _antd.message.err("上传营业执照失败");
        });
    };
};
var getBDLink = exports.getBDLink = function getBDLink() {
    return function (dispatch, getState) {
        dispatch(LOAD_EMPLOYEEINFO_START);
        var token = _store2.default.get('token');
        (0, _ajax.AjaxByToken)('getBDLink', {
            head: {
                transcode: 'L0116'
            },
            data: {
                token: token.token,
                tokenKey: token.tokenKey
            }
        }).then(function (res) {
            if (res.result) {
                window.open(res.result.url);
            }
        }, function (err) {
            ;
        });
    };
};

var DeleteMaterial = exports.DeleteMaterial = function DeleteMaterial(data, props, value) {
    return function (dispatch, getState) {
        (0, _ajax.AjaxByToken)('emp/dataDel_employees', {
            head: {
                transcode: 'L0055'
            },
            data: data
        }).then(function (res) {
            var queryEmployee = props.queryEmployee,
                viewUploadAttachment = props.viewUploadAttachment;

            _antd.notification.success({
                message: '提示',
                description: '材料附件删除成功！'
            });
            queryEmployee({ rid: value.rid + '' });
        }, function (err) {
            ;
        });
    };
};
var searchCreditInvestgation = exports.searchCreditInvestgation = function searchCreditInvestgation() {
    return function (dispatch, getState) {
        (0, _ajax.AjaxByToken)('cerditFlag_employees', {
            head: {
                transcode: 'L0059'
            }

        }).then(function (res) {
            dispatch((0, _extends3.default)({}, CREDITINVESTGATION, { creditData: res }));
        }, function (err) {
            ;
        });
    };
};
var cancelData = exports.cancelData = function cancelData() {
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, CANCELDATA));
    };
};
var searchCredit = exports.searchCredit = function searchCredit(data, showcredit) {
    return function (dispatch, getState) {
        dispatch(SEARCHCREDITINVESTGATION_START);
        (0, _ajax.AjaxByToken)('cerditQueryperationList_employees', {
            head: {
                transcode: 'L0060'
            },
            data: data
        }).then(function (res) {
            NProgress.start();
            dispatch((0, _extends3.default)({}, CANCELLOADING));
            dispatch((0, _extends3.default)({}, SEARCHCREDITINVESTGATION, { creditInfoData: res.data }));
            if (showcredit) {
                showcredit();
            }
            NProgress.done();
        }, function (err) {
            dispatch((0, _extends3.default)({}, CANCELLOADING));
        });
    };
};
var hidecredit = exports.hidecredit = function hidecredit() {
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, HIDECREDITINVESTGATIONSTATE, { isFill: false }));
    };
};
var showcredit = exports.showcredit = function showcredit() {
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, CREDITINVESTGATIONSTATE, { isFill: true }));
    };
};

var getEmployeeResumeInfo = exports.getEmployeeResumeInfo = function getEmployeeResumeInfo(data) {
    return function (dispatch, getState) {
        dispatch(LOAD_EMPLOYEEINFO_START);
        (0, _ajax.AjaxByToken)('employeeinfo/employeeResumeview', {
            head: {
                transcode: 'L0056'
            },
            data: data
        }).then(function (res) {
            dispatch(LOAD_EMPLOYEEINFO_DONE);
            dispatch((0, _extends3.default)({}, LOAD_EMPLOYEEINFO, { employeeInfo: res }));
        }, function (err) {
            dispatch(LOAD_EMPLOYEEINFO_DONE);
        });
    };
};

var showResumeModal = exports.showResumeModal = function showResumeModal(data) {
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, SHOW_INFO_MODAL, { uriParams: data }));
    };
};
var hideResumeModal = exports.hideResumeModal = function hideResumeModal() {
    return function (dispatch, getState) {
        dispatch(HIDE_INFO_MODAL);
    };
};

var GET_ARCHIVES_START = { type: types.GET_ARCHIVES_START };
var GET_ARCHIVES_DONE = { type: types.GET_ARCHIVES_DONE };
var GET_ARCHIVES_LIST = { type: types.GET_ARCHIVES_LIST };

var GET_LEAVEARCHIVES_START = { type: types.GET_LEAVEARCHIVES_START };
var GET_LEAVEARCHIVES_DONE = { type: types.GET_LEAVEARCHIVES_DONE };
var GET_LEAVEARCHIVES_LIST = { type: types.GET_LEAVEARCHIVES_LIST };

var GET_ARCHIVES_DATA = { type: types.GET_ARCHIVES_DATA };

var SHOW_PERSONALMATERIAL_MODAL = { type: types.SHOW_PERSONALMATERIAL_MODAL };
var HIDE_PERSONALMATERIAL_MODAL = { type: types.HIDE_PERSONALMATERIAL_MODAL };

var ARCHIVES_TABLE_DATA = { type: types.ARCHIVES_TABLE_DATA };

var PROGRESS = { type: types.PROGRESS };
var CANCELPROGRESS = { type: types.CANCELPROGRESS };

var GET_EMPLOYEE_WORK = { type: types.GET_EMPLOYEE_WORK };
var GET_EMPLOYEE_SEX = { type: types.GET_EMPLOYEE_SEX };
var GET_EMPLOYEE_EDU = { type: types.GET_EMPLOYEE_EDU };
var GET_EMPLOYEE_AGE = { type: types.GET_EMPLOYEE_AGE };
var GET_EMPLOYEE_MARRY = { type: types.GET_EMPLOYEE_MARRY };
var GET_EMPLOYEE_CHILD = { type: types.GET_EMPLOYEE_CHILD };
var GET_EMPLOYEE_DEPART = { type: types.GET_EMPLOYEE_DEPART };
var GET_EMPLOYEE_POST = { type: types.GET_EMPLOYEE_POST };

var GET_DEPARTMENT_START = { type: types.GET_DEPARTMENT_START };
var GET_DEPARTMENT_DONE = { type: types.GET_DEPARTMENT_DONE };
var GET_DEPARTMENT_LIST = { type: types.GET_DEPARTMENT_LIST };

var GET_ORGANIZE_CHART = { type: types.GET_ORGANIZE_CHART };

var GET_DEPARTMENT_STAFF = { type: types.GET_DEPARTMENT_STAFF };

var ADD_EDIT_DEPARTMENT = { type: types.ADD_EDIT_DEPARTMENT };

var DELETE_DEPARTMENT = { type: types.DELETE_DEPARTMENT };

var ADD_MECHANISM = { type: types.ADD_MECHANISM };

var DELETE_MECHANISM = { type: types.DELETE_MECHANISM };

var EDIT_MECHANISM = { type: types.EDIT_MECHANISM };

var GET_ARRANGE_DEPARTMENT = { type: types.GET_ARRANGE_DEPARTMENT };

var ARRANGE_DEPARTMENT = { type: types.ARRANGE_DEPARTMENT };

var getArchivesList = exports.getArchivesList = function getArchivesList() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (dispatch, getState) {
        NProgress.start();
        dispatch(GET_ARCHIVES_START);
        (0, _ajax.AjaxByToken)('archives/resume_statis_List_Job', {
            head: {
                transcode: 'L0075'
            },
            data: data
        }).then(function (res) {
            dispatch(GET_ARCHIVES_DONE);
            for (var i = 0; i < res.list.length; i++) {
                delete res.list[i].children;
            };
            dispatch((0, _extends3.default)({}, GET_ARCHIVES_LIST, { list: res.list, count: res.count }));
        }, function (err) {
            dispatch(GET_ARCHIVES_DONE);
        });
    };
};

var getLeaveArchivesList = exports.getLeaveArchivesList = function getLeaveArchivesList() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (dispatch, getState) {
        NProgress.start();
        dispatch(GET_LEAVEARCHIVES_START);
        (0, _ajax.AjaxByToken)('archives/resume_statis_List_Department', {
            head: {
                transcode: 'L0076'
            },
            data: data
        }).then(function (res) {
            dispatch(GET_LEAVEARCHIVES_DONE);
            for (var i = 0; i < res.list.length; i++) {
                delete res.list[i].children;
            }
            dispatch((0, _extends3.default)({}, GET_LEAVEARCHIVES_LIST, { list: res.list, count: res.count }));
        }, function (err) {
            dispatch(GET_LEAVEARCHIVES_DONE);
        });
    };
};

var downloadMaterial = exports.downloadMaterial = function downloadMaterial(data, showProgress) {
    return function (dispatch, getState) {
        var token = _store2.default.get('token');
        var rid = data.rid,
            name = data.name;

        (0, _axios2.default)({
            url: prefixUri + '/archives/DOWNLOAD_RESUME_METERIAL',
            method: 'get',
            params: (0, _extends3.default)({}, token, {
                rid: rid,
                transcode: 'L0077'
            }),
            responseType: 'blob'
        }).then(function (res) {
            var blob = new Blob([res.data], { type: "application/zip" });
            _fileSaver2.default.saveAs(blob, name + '\u4E2A\u4EBA\u6750\u6599\u9644\u4EF6.zip');
            showProgress();
        }).catch(function (error) {});
    };
};
var showProgress = exports.showProgress = function showProgress() {
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, PROGRESS));
    };
};
var cancelProgress = exports.cancelProgress = function cancelProgress() {
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, CANCELPROGRESS));
    };
};

var editEmployeeInformation = exports.editEmployeeInformation = function editEmployeeInformation(data, props) {
    return function (dispatch, getState) {
        (0, _ajax.AjaxByToken)('employeeinfo/addEmployee', {
            head: {
                transcode: 'L0045'
            },
            data: data
        }).then(function (res) {
            if (props) {
                var _getArchivesList = props.getArchivesList,
                    _getLeaveArchivesList = props.getLeaveArchivesList,
                    archivesTableData = props.archivesTableData,
                    _getDepartMentStaff = props.getDepartMentStaff,
                    currentUid = props.currentUid;

                if (data.rid) {
                    _antd.message.success('编辑信息成功！');
                    if (archivesTableData == '1') {
                        _getArchivesList({ sort: '4' });
                    } else if (archivesTableData == '2') {
                        _getLeaveArchivesList({ sort: '4' });
                    }
                    _getDepartMentStaff({ departmentId: currentUid }, currentUid);
                } else {
                    _antd.message.success('添加信息成功！');
                    if (archivesTableData == '1') {
                        _getArchivesList({ sort: '4' });
                    } else if (archivesTableData == '2') {
                        _getLeaveArchivesList({ sort: '4' });
                    }
                }
            } else {
                _antd.message.success('编辑信息成功');
                NProgress.done();
            }
        }, function (err) {});
    };
};

var showPersonalMaterialModal = exports.showPersonalMaterialModal = function showPersonalMaterialModal(data) {
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, SHOW_PERSONALMATERIAL_MODAL, { personalMaterialVisible: true, data: data }));
    };
};

var hidePersonalMaterialModal = exports.hidePersonalMaterialModal = function hidePersonalMaterialModal() {
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, HIDE_PERSONALMATERIAL_MODAL, { personalMaterialVisible: false }));
    };
};

var getArchivesData = exports.getArchivesData = function getArchivesData() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (dispatch, getState) {
        (0, _ajax.AjaxByToken)('archives/resume_statis', {
            head: {
                transcode: 'L0074'
            },
            data: data
        }).then(function (res) {
            dispatch((0, _extends3.default)({}, GET_ARCHIVES_DATA, { archivesData: res }));
        }, function (err) {
            dispatch(GET_ARCHIVES_DONE);
        });
    };
};

var getEmployeeQuality = exports.getEmployeeQuality = function getEmployeeQuality(type) {
    return function (dispatch, getState) {
        (0, _ajax.AjaxByToken)('empoverview/singleclumn', {
            head: {
                transcode: 'L0085'
            },
            data: type
        }).then(function (res) {
            if (type.counttype == "1") {
                dispatch((0, _extends3.default)({}, GET_EMPLOYEE_WORK, { work: res.content }));
            } else if (type.counttype == "2") {
                dispatch((0, _extends3.default)({}, GET_EMPLOYEE_SEX, { sex: res.content }));
            } else if (type.counttype == "3") {
                dispatch((0, _extends3.default)({}, GET_EMPLOYEE_EDU, { edu: res.content }));
            } else if (type.counttype == "4") {
                dispatch((0, _extends3.default)({}, GET_EMPLOYEE_AGE, { age: res.content }));
            } else if (type.counttype == "5") {
                dispatch((0, _extends3.default)({}, GET_EMPLOYEE_MARRY, { marry: res.content }));
            } else if (type.counttype == "6") {
                dispatch((0, _extends3.default)({}, GET_EMPLOYEE_CHILD, { child: res.content }));
            } else if (type.counttype == "7") {
                dispatch((0, _extends3.default)({}, GET_EMPLOYEE_DEPART, { depart: res.content }));
            } else if (type.counttype == "8") {
                dispatch((0, _extends3.default)({}, GET_EMPLOYEE_POST, { post: res.content }));
            }
        }, function (err) {});
    };
};

var getDepartMentList = exports.getDepartMentList = function getDepartMentList() {
    return function (dispatch, getState) {
        dispatch(GET_DEPARTMENT_START);
        (0, _ajax.AjaxByToken)('structure/resume_statis_List_Department', {
            head: {
                transcode: 'L0078',
                type: 'h'
            }
        }).then(function (res) {
            dispatch(GET_DEPARTMENT_DONE);
            dispatch((0, _extends3.default)({}, GET_DEPARTMENT_LIST, { list: res.list, count: res.count }));
        }, function (err) {
            dispatch((0, _extends3.default)({}, GET_DEPARTMENT_LIST, { list: [], count: 0 }));
        });
    };
};

var getTreeList = exports.getTreeList = function getTreeList(list) {
    return function (dispatch, getState) {
        var treeList = [];
        function recursion(list) {
            list.forEach(function (item, index) {
                var childList = item.list;
                if (childList) {
                    treeList.push({ name: item.name, uid: item.uid, sup_id: item.supDepartmentId });
                    recursion(childList);
                } else {
                    treeList.push({ name: item.name, uid: item.uid, sup_id: item.supDepartmentId });
                }
            });
        }
        recursion(list);
        return treeList;
    };
};

var changeTableData = exports.changeTableData = function changeTableData(data) {
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, ARCHIVES_TABLE_DATA, { archivesTableData: data }));
    };
};

var getDepartMentStaff = exports.getDepartMentStaff = function getDepartMentStaff() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var currentUid = arguments[1];
    var departmentName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var current = arguments[3];
    return function (dispatch, getState) {
        (0, _ajax.AjaxByToken)('structure/resume_statis_List_DepartmentAndResumeOff', {
            head: {
                transcode: 'L0079',
                type: 'h'
            },
            data: data
        }).then(function (res) {
            dispatch((0, _extends3.default)({}, GET_DEPARTMENT_STAFF, { departmentStaff: res, currentUid: currentUid, departmentName: departmentName, current: current }));
        }, function (err) {
            dispatch((0, _extends3.default)({}, GET_DEPARTMENT_STAFF));
        });
    };
};

var addMechnism = exports.addMechnism = function addMechnism() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, ADD_MECHANISM, { mechanismInfo: '' }));
        (0, _ajax.AjaxByToken)('structure/insert_structure_department', {
            head: {
                transcode: 'L0082',
                type: 'h'
            },
            data: data
        }).then(function (res) {
            dispatch((0, _extends3.default)({}, ADD_MECHANISM, { mechanismInfo: 'success' }));
        }, function (err) {
            dispatch((0, _extends3.default)({}, ADD_MECHANISM, { mechanismInfo: '' }));
        });
    };
};

var editMechnism = exports.editMechnism = function editMechnism() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, EDIT_MECHANISM, { mechanismInfo: '' }));
        (0, _ajax.AjaxByToken)('structure/update_structure_department', {
            head: {
                transcode: 'L0087',
                type: 'h'
            },
            data: data
        }).then(function (res) {
            dispatch((0, _extends3.default)({}, EDIT_MECHANISM, { mechanismInfo: 'success' }));
        }, function (err) {
            dispatch((0, _extends3.default)({}, EDIT_MECHANISM, { mechanismInfo: '' }));
        });
    };
};

var addEditDepartment = exports.addEditDepartment = function addEditDepartment() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (dispatch, getState) {
        (0, _ajax.AjaxByToken)('structure/resume_statis_operation_Department', {
            head: {
                transcode: 'L0080',
                type: 'h'
            },
            data: data
        }).then(function (res) {
            dispatch((0, _extends3.default)({}, ADD_EDIT_DEPARTMENT, { departmentInfo: 'success' }));
        }, function (err) {
            dispatch((0, _extends3.default)({}, ADD_EDIT_DEPARTMENT, { departmentInfo: '' }));
        });
    };
};
var refreshDepartmentInfo = exports.refreshDepartmentInfo = function refreshDepartmentInfo() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, ADD_EDIT_DEPARTMENT, { departmentInfo: '' }));
        (0, _ajax.AjaxByToken)('structure/resume_statis_List_Department', {
            head: {
                transcode: 'L0078',
                type: 'h'
            },
            data: data
        }).then(function (res) {
            dispatch((0, _extends3.default)({}, GET_DEPARTMENT_LIST, { list: res.list, count: res.count }));
        }, function (err) {
            dispatch((0, _extends3.default)({}, GET_DEPARTMENT_LIST, { list: [], count: 0 }));
        });
    };
};

var deleteDepartment = exports.deleteDepartment = function deleteDepartment() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (dispatch, getState) {
        (0, _ajax.AjaxByToken)('structure/resume_statis_del_Department', {
            head: {
                transcode: 'L0081',
                type: 'h'
            },
            data: data
        }).then(function (res) {
            dispatch((0, _extends3.default)({}, DELETE_DEPARTMENT, { departmentInfo: 'success' }));
        }, function (err) {
            dispatch((0, _extends3.default)({}, DELETE_DEPARTMENT));
        });
    };
};

var getOrganizeChart = exports.getOrganizeChart = function getOrganizeChart() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, ADD_MECHANISM, { mechanismInfo: '' }));
        (0, _ajax.AjaxByToken)('structure/company_structure', {
            head: {
                transcode: 'L0083',
                type: 'h'
            },
            data: data
        }).then(function (res) {
            dispatch((0, _extends3.default)({}, GET_ORGANIZE_CHART, { organizeList: res.companystructure, isLoading: false }));
        }, function (err) {
            dispatch((0, _extends3.default)({}, GET_ORGANIZE_CHART));
        });
    };
};

var deleteMechnism = exports.deleteMechnism = function deleteMechnism() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (dispatch, getState) {

        dispatch((0, _extends3.default)({}, DELETE_MECHANISM, { mechanismInfo: '' }));
        (0, _ajax.AjaxByToken)('structure/del_structure_department', {
            head: {
                transcode: 'L0084',
                type: 'h'
            },
            data: data
        }).then(function (res) {
            dispatch((0, _extends3.default)({}, DELETE_MECHANISM, { mechanismInfo: 'success' }));
        }, function (err) {
            dispatch((0, _extends3.default)({}, DELETE_MECHANISM));
        });
    };
};
var getArrangeDepartment = exports.getArrangeDepartment = function getArrangeDepartment() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, ADD_MECHANISM, { mechanismInfo: '' }));
        (0, _ajax.AjaxByToken)('structure/toset_structure_department', {
            head: {
                transcode: 'L0089',
                type: 'h'
            },
            data: data
        }).then(function (res) {
            dispatch((0, _extends3.default)({}, GET_ARRANGE_DEPARTMENT, { arrangeDepartment: res.list }));
        }, function (err) {
            dispatch((0, _extends3.default)({}, GET_ARRANGE_DEPARTMENT));
        });
    };
};

var arrangeDepartmentFuc = exports.arrangeDepartmentFuc = function arrangeDepartmentFuc() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, ARRANGE_DEPARTMENT, { mechanismInfo: '' }));
        (0, _ajax.AjaxByToken)('structure/set_structure_department', {
            head: {
                transcode: 'L0090',
                type: 'h'
            },
            data: data
        }).then(function (res) {
            dispatch((0, _extends3.default)({}, ARRANGE_DEPARTMENT, { mechanismInfo: 'success' }));
        }, function (err) {
            dispatch((0, _extends3.default)({}, ARRANGE_DEPARTMENT));
        });
    };
};

/***/ }),

/***/ 399:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hideRecommendModal = exports.showRecommendModal = exports.hideUploadModal = exports.showUploadModal = exports.hideResumeModal = exports.showResumeModal = exports.getUpInfoFilePath = exports.matchResume = exports.getUpInfoName = exports.selectPosition = exports.getRecommendRecruit = exports.setResetFormFalse = exports.uploadResume = exports.quickImport = exports.getRecruitList = exports.getRecruitCategory = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _recruit = __webpack_require__(130);

var types = _interopRequireWildcard(_recruit);

var _ajax = __webpack_require__(12);

var _antd = __webpack_require__(18);

var _store = __webpack_require__(28);

var _store2 = _interopRequireDefault(_store);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultData = {};

var LOAD_CATEGORY_START = {
  type: types.LOAD_CATEGORY_START
};

var LOAD_CATEGORY_DONE = {
  type: types.LOAD_CATEGORY_DONE
};

var LOAD_RECRUIT_CATEGORY = {
  type: types.LOAD_RECRUIT_CATEGORY
};

var LOAD_LIST_START = {
  type: types.LOAD_LIST_START
};

var LOAD_LIST_DONE = {
  type: types.LOAD_LIST_DONE
};

var LOAD_RECRUIT_LIST = {
  type: types.LOAD_RECRUIT_LIST
};

var LOAD_RECOMMEND_START = {
  type: types.LOAD_RECOMMEND_START
};
var LOAD_RECOMMEND_DONE = {
  type: types.LOAD_RECOMMEND_DONE
};
var LOAD_RECOMMEND_LIST = {
  type: types.LOAD_RECOMMEND_LIST
};

var SHOW_INFO_MODAL = {
  type: types.SHOW_INFO_MODAL
};

var HIDE_INFO_MODAL = {
  type: types.HIDE_INFO_MODAL
};

var SHOW_UPLOAD_MODAL = {
  type: types.SHOW_UPLOAD_MODAL
};

var HIDE_UPLOAD_MODAL = {
  type: types.HIDE_UPLOAD_MODAL
};

var UPLOAD_RESUME_START = {
  type: types.UPLOAD_RESUME_START
};
var UPLOAD_RESUME_DONE = {
  type: types.UPLOAD_RESUME_DONE
};
var SET_RESETFORM_TRUE = {
  type: types.SET_RESETFORM_TRUE
};
var SET_RESETFORM_FALSE = {
  type: types.SET_RESETFORM_FALSE
};

var SHOW_RECOMMEND_MODAL = {
  type: types.SHOW_RECOMMEND_MODAL
};

var HIDE_RECOMMEND_MODAL = {
  type: types.HIDE_RECOMMEND_MODAL
};

var SELECT_POSITION = {
  type: types.SELECT_POSITION
};

var UP_INFO_NAME = {
  type: types.UP_INFO_NAME
};

var UP_INFO_FILEPATH = {
  type: types.UP_INFO_FILEPATH
};
var MATCH_UPRESUME = {
  type: types.MATCH_UPRESUME
};

var getRecruitCategory = exports.getRecruitCategory = function getRecruitCategory() {
  return function (dispatch, getState) {
    dispatch(LOAD_CATEGORY_START);
    (0, _ajax.AjaxByToken)('jobclassCount', {
      head: {
        transcode: 'L0015'
      }
    }).then(function (res) {
      dispatch(LOAD_CATEGORY_DONE);
      dispatch((0, _extends3.default)({}, LOAD_RECRUIT_CATEGORY, {
        categoryData: res.list
      }));
    }, function (err) {
      dispatch(LOAD_CATEGORY_DONE);
    });
  };
};

var getRecruitList = exports.getRecruitList = function getRecruitList() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultData;
  return function (dispatch, getState) {
    data.skip = data.skip + '';
    defaultData = (0, _extends3.default)({}, data, {
      count: '20'
    });
    var uri = 'queryResume';
    (0, _ajax.cancelRequestByKey)(uri);
    dispatch(LOAD_LIST_START);
    (0, _ajax.AjaxByToken)(uri, {
      head: {
        transcode: 'L0016'
      },
      data: defaultData
    }).then(function (res) {
      dispatch(LOAD_LIST_DONE);
      dispatch((0, _extends3.default)({}, LOAD_RECRUIT_LIST, {
        recruitList: res
      }));
    }, function (err) {
      dispatch(LOAD_LIST_DONE);
    });
  };
};

var quickImport = exports.quickImport = function quickImport(data, hideUploadModal, getRecritList) {
  return function (dispatch, getState) {
    var uri = 'addresume';

    (0, _ajax.AjaxByToken)(uri, {
      head: {
        transcode: 'L0119'
      },
      data: data
    }).then(function (res) {
      _antd.notification.success({
        message: '成功',
        description: res.result
      });
      hideUploadModal();
    }, function (err) {});
  };
};

var uploadResume = exports.uploadResume = function uploadResume(data, props, params) {
  return function (dispatch, getState) {
    dispatch(UPLOAD_RESUME_START);
    (0, _ajax.AjaxByToken)('resumeUpload', {
      head: {
        transcode: 'L0030'
      },
      data: data
    }).then(function (res) {
      dispatch(UPLOAD_RESUME_DONE);
      _antd.notification.success({
        message: '提示',
        description: "上传成功"
      });
      dispatch(SET_RESETFORM_TRUE);

      setTimeout(function () {
        dispatch(HIDE_UPLOAD_MODAL);
      }, 500);
      var getRecruitList = props.getRecruitList,
          getTalentList = props.getTalentList;
      var isRecruitUpload = params.isRecruitUpload,
          isTalentUpload = params.isTalentUpload;

      isRecruitUpload && getRecruitList({
        stageid: data.type,
        skip: '0',
        range: '2'
      });
      isTalentUpload && getTalentList({
        start: 0,
        type: 'all'
      });
    }, function (err) {
      dispatch(UPLOAD_RESUME_DONE);
    });
  };
};

var setResetFormFalse = exports.setResetFormFalse = function setResetFormFalse() {
  return function (dispatch, getState) {
    dispatch(SET_RESETFORM_FALSE);
  };
};

var getRecommendRecruit = exports.getRecommendRecruit = function getRecommendRecruit(data) {
  return function (dispatch, getState) {
    data.skip = data.skip + '';
    var uri = 'listPositioninfo';
    (0, _ajax.cancelRequestByKey)(uri);
    dispatch(LOAD_RECOMMEND_START);
    (0, _ajax.AjaxByToken)(uri, {
      head: {
        transcode: 'L0018'
      },
      data: (0, _extends3.default)({}, data, {
        count: '10'
      })
    }).then(function (res) {
      dispatch(LOAD_RECOMMEND_DONE);
      dispatch((0, _extends3.default)({}, LOAD_RECOMMEND_LIST, {
        data: res
      }));
    });
  };
};

var selectPosition = exports.selectPosition = function selectPosition(data) {
  return function (dispatch, getState) {
    dispatch((0, _extends3.default)({}, SELECT_POSITION, {
      position: data
    }));
  };
};
var getUpInfoName = exports.getUpInfoName = function getUpInfoName(info) {
  return function (dispatch, getState) {
    dispatch((0, _extends3.default)({}, UP_INFO_NAME, {
      name: info.name
    }));
  };
};
var matchResume = exports.matchResume = function matchResume(data) {
  return function (dispatch, getState) {
    var uri = 'analysisresume';
    (0, _ajax.cancelRequestByKey)(uri);
    (0, _ajax.AjaxByToken)(uri, {
      head: {
        transcode: 'L0118'
      },
      data: data
    }).then(function (res) {
      dispatch((0, _extends3.default)({}, MATCH_UPRESUME, { matchResumeInfo: res.result }));
    });
  };
};

var getUpInfoFilePath = exports.getUpInfoFilePath = function getUpInfoFilePath(info) {
  return function (dispatch, getState) {
    dispatch((0, _extends3.default)({}, UP_INFO_FILEPATH, {
      filepath: info
    }));
  };
};

var showResumeModal = exports.showResumeModal = function showResumeModal(data) {
  return function (dispatch, getState) {
    dispatch((0, _extends3.default)({}, SHOW_INFO_MODAL, {
      uriParams: data
    }));
  };
};
var hideResumeModal = exports.hideResumeModal = function hideResumeModal() {
  return function (dispatch, getState) {
    dispatch(HIDE_INFO_MODAL);
  };
};

var showUploadModal = exports.showUploadModal = function showUploadModal() {
  return function (dispatch, getState) {
    dispatch(SHOW_UPLOAD_MODAL);
  };
};
var hideUploadModal = exports.hideUploadModal = function hideUploadModal() {
  return function (dispatch, getState) {
    dispatch(HIDE_UPLOAD_MODAL);
    dispatch(SET_RESETFORM_TRUE);
  };
};

var showRecommendModal = exports.showRecommendModal = function showRecommendModal() {
  return function (dispatch, getState) {
    dispatch(SHOW_RECOMMEND_MODAL);
  };
};
var hideRecommendModal = exports.hideRecommendModal = function hideRecommendModal() {
  return function (dispatch, getState) {
    dispatch(HIDE_RECOMMEND_MODAL);
  };
};

/***/ }),

/***/ 400:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hideResumeEditModal = exports.showResumeEditModal = exports.hideQrcodeLinkModal = exports.showQrcodeLinkModal = exports.hideBackgroundModal = exports.showBackgroundModal = exports.hideEvaluationModal = exports.showEvaluationModal = exports.hideShareModal = exports.showShareModal = exports.hideModal = exports.showModal = exports.getAllInterviews = exports.getEvaluation = exports.addEvaluation = exports.getResumeUrl = exports.fillEvaluation = exports.getResumeInfo = exports.changeStageStatus = exports.downloadResume = exports.getTalentResumeInfo = exports.getStageLog = exports.changeType = exports.getResult = exports.getInterviewInfo = exports.submitEditResumeInfo = exports.getRecruitResumeInfo = exports.tempOtherlist = exports.tempCertlist = exports.tempTrainlist = exports.tempLanlist = exports.tempWorklist = exports.tempProjectlist = exports.tempEducList = exports.tempAssessment = exports.tempIntention = exports.tempborndate = exports.tempbasicInfo = exports.removeUpAdvar = exports.upAdvar = exports.clearUpAdvar = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _resumeInfo = __webpack_require__(224);

var types = _interopRequireWildcard(_resumeInfo);

var _axios = __webpack_require__(35);

var _axios2 = _interopRequireDefault(_axios);

var _store = __webpack_require__(28);

var _store2 = _interopRequireDefault(_store);

var _fileSaver = __webpack_require__(279);

var _fileSaver2 = _interopRequireDefault(_fileSaver);

var _antd = __webpack_require__(18);

var _ajax = __webpack_require__(12);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GET_EVALUATION_INTERVIEWS = { type: types.GET_EVALUATION_INTERVIEWS };

var SHOW_ECHARTS_STATUS = { type: types.SHOW_ECHARTS_STATUS };
var HIDE_ECHARTS_STATUS = { type: types.HIDE_ECHARTS_STATUS };

var SHOW_RESUME_EDIT_MODEL = { type: types.SHOW_RESUME_EDIT_MODEL };

var HIDE_RESUME_EDIT_MODEL = { type: types.HIDE_RESUME_EDIT_MODEL };

var LOAD_RESUME_INFO = { type: types.LOAD_RESUME_INFO };

var LOAD_INFO_START = { type: types.LOAD_INFO_START };

var LOAD_INFO_DONE = { type: types.LOAD_INFO_DONE };

var SHOW_MODAL_LOADING = { type: types.SHOW_MODAL_LOADING };

var HIDE_MODAL_LOADING = { type: types.HIDE_MODAL_LOADING };

var DOWNLOAD_RESUME_START = { type: types.DOWNLOAD_RESUME_START };
var DOWNLOAD_RESUME_DONE = { type: types.DOWNLOAD_RESUME_DONE };
var DOWNLOAD_RESUME = { type: types.DOWNLOAD_RESUME };

var SHOW_MODAL = { type: types.SHOW_MODAL };
var HIDE_MODAL = { type: types.HIDE_MODAL };

var SHOW_SHARE_MODAL = { type: types.SHOW_SHARE_MODAL };
var HIDE_SHARE_MODAL = { type: types.HIDE_SHARE_MODAL };

var SHOW_INTERVIEW_EVALUATION_MODAL = { type: types.SHOW_INTERVIEW_EVALUATION_MODAL };
var HIDE_INTERVIEW_EVALUATION_MODAL = { type: types.HIDE_INTERVIEW_EVALUATION_MODAL };

var GET_EVALUATION = { type: types.GET_EVALUATION };

var GET_EVALUATION_ID = { type: types.GET_EVALUATION_ID };

var SHOW_BACKGROUNDSURVEY_MODAL = { type: types.SHOW_BACKGROUNDSURVEY_MODAL };
var HIDE_BACKGROUNDSURVEY_MODAL = { type: types.HIDE_BACKGROUNDSURVEY_MODAL };

var RESUME_INFORMATION = { type: types.RESUME_INFORMATION };

var RESUME_INFO = { type: types.RESUME_INFO };

var INTERVIEW_INFO = { type: types.INTERVIEW_INFO };

var FILL_LOADING = { type: types.FILL_LOADING };

var SHOW_QRCODE_LINKMODAL = { type: types.SHOW_QRCODE_LINKMODAL };
var HIDE_QRCODE_LINKMODAL = { type: types.HIDE_QRCODE_LINKMODAL };

var SCORES = { type: types.SCORES };
var SUMMARY = { type: types.SUMMARY };

var TYPE = { type: types.TYPE };

var TEMP_BACICINFO = { type: types.TEMP_BACICINFO };
var TEMP_INTENTION = { type: types.TEMP_INTENTION };
var TEMP_ASSESSMENT = { type: types.TEMP_ASSESSMENT };
var TEMP_EDUCLIST = { type: types.TEMP_EDUCLIST };
var TEMP_PROJECT_LIST = { type: types.TEMP_PROJECT_LIST };
var TEMP_WORK_LIST = { type: types.TEMP_WORK_LIST };
var TEMP_LAN_LIST = { type: types.TEMP_LAN_LIST };
var TEMP_TRAIN_LIST = { type: types.TEMP_TRAIN_LIST };
var TEMP_CERT_LIST = { type: types.TEMP_CERT_LIST };
var TEMP_OTHER_LIST = { type: types.TEMP_OTHER_LIST };
var TEMP_BORNDATA = { type: types.TEMP_BORNDATA };
var TEMP_ADVAR = { type: types.TEMP_ADVAR };

var TEMP_ADVAR_FILEPATH = { type: types.TEMP_ADVAR_FILEPATH };

var clearUpAdvar = exports.clearUpAdvar = function clearUpAdvar() {
    return function (dispatch, getState) {

        dispatch((0, _extends3.default)({}, TEMP_ADVAR, { tempAdvar: '' }));
    };
};

var upAdvar = exports.upAdvar = function upAdvar(file) {
    return function (dispatch, getState) {
        var token = _store2.default.get('token');
        var formData = new FormData();
        formData.append('file', file);
        formData.append('tokenKey', token.tokenKey);
        formData.append('token', token.token);
        (0, _axios2.default)({
            url: prefixUri + '/uploadrheadimg',
            method: 'post',
            data: formData
        }).then(function (res) {

            dispatch((0, _extends3.default)({}, TEMP_ADVAR, { tempAdvar: res.data.result.headimg }));
            dispatch((0, _extends3.default)({}, TEMP_ADVAR_FILEPATH, { tempAdvarFilepath: res.data.result.headimg }));
        }).catch(function (error) {
            _antd.message.info("上传失败");
        });
    };
};

var removeUpAdvar = exports.removeUpAdvar = function removeUpAdvar(value) {
    return function (dispatch, getState) {

        (0, _ajax.AjaxByToken)('delrheadimg', {
            head: {
                transcode: 'L0122'
            },
            data: {
                headimg: value
            }
        }).then(function (res) {}, function (err) {});
    };
};

var tempbasicInfo = exports.tempbasicInfo = function tempbasicInfo(data) {
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, TEMP_BACICINFO, { tempResumeInfo: data }));
    };
};
var tempborndate = exports.tempborndate = function tempborndate(data) {
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, TEMP_BORNDATA, { tempborndate: data }));
    };
};

var tempIntention = exports.tempIntention = function tempIntention(data) {
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, TEMP_INTENTION, { tempIntention: data }));
    };
};
var tempAssessment = exports.tempAssessment = function tempAssessment(data) {
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, TEMP_ASSESSMENT, { tempAssessment: data }));
    };
};
var tempEducList = exports.tempEducList = function tempEducList(data) {
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, TEMP_EDUCLIST, { tempEducList: data }));
    };
};
var tempProjectlist = exports.tempProjectlist = function tempProjectlist(data) {
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, TEMP_PROJECT_LIST, { tempProjectlist: data }));
    };
};
var tempWorklist = exports.tempWorklist = function tempWorklist(data) {
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, TEMP_WORK_LIST, { tempWorklist: data }));
    };
};
var tempLanlist = exports.tempLanlist = function tempLanlist(data) {
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, TEMP_LAN_LIST, { tempLanlist: data }));
    };
};
var tempTrainlist = exports.tempTrainlist = function tempTrainlist(data) {
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, TEMP_TRAIN_LIST, { tempTrainlist: data }));
    };
};
var tempCertlist = exports.tempCertlist = function tempCertlist(data) {
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, TEMP_CERT_LIST, { tempCertlist: data }));
    };
};
var tempOtherlist = exports.tempOtherlist = function tempOtherlist(data) {
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, TEMP_OTHER_LIST, { tempOtherlist: data }));
    };
};

var getRecruitResumeInfo = exports.getRecruitResumeInfo = function getRecruitResumeInfo(data) {
    return function (dispatch, getState) {
        dispatch(LOAD_INFO_START);
        (0, _ajax.AjaxByToken)('getResumeById', {
            head: {
                transcode: 'L0017'
            },
            data: data
        }).then(function (res) {
            dispatch(LOAD_INFO_DONE);
            dispatch((0, _extends3.default)({}, LOAD_RESUME_INFO, { resumeInfo: res }));
        });
    };
};

var submitEditResumeInfo = exports.submitEditResumeInfo = function submitEditResumeInfo(data, hideResumeEditModal, logId, getRecruitResumeInfo, getTalentResumeInfo) {
    return function (dispatch, getState) {
        (0, _ajax.AjaxByToken)('updateresume', {
            head: {
                transcode: 'L0115'
            },
            data: data
        }).then(function (res) {
            _antd.message.info("编辑简历提交成功");
            if (logId == undefined) {
                setTimeout(function () {
                    getTalentResumeInfo({
                        resumeid: data.resumeInfo.resumeid
                    });
                    hideResumeEditModal();
                }, 1000);
            } else {
                setTimeout(function () {
                    getRecruitResumeInfo({
                        resumeId: data.resumeInfo.resumeid,
                        logId: logId
                    });
                    hideResumeEditModal();
                }, 1000);
            }
        });
    };
};

var getInterviewInfo = exports.getInterviewInfo = function getInterviewInfo(data) {
    return function (dispatch, getState) {
        dispatch(LOAD_INFO_START);
        (0, _ajax.AjaxByToken)('intepinfo', {
            head: {
                transcode: 'L0100'
            },
            data: data

        }).then(function (res) {

            dispatch(LOAD_INFO_DONE);
            if (res.result != null) {
                dispatch((0, _extends3.default)({}, INTERVIEW_INFO, { interviewInfo: res.result }));
                dispatch((0, _extends3.default)({}, TYPE, { type: 4 }));
                if (data.type) {
                    window.print();
                }
            } else {
                dispatch((0, _extends3.default)({}, INTERVIEW_INFO, { interviewInfo: {} }));
                dispatch((0, _extends3.default)({}, TYPE, { type: 4 }));
                if (data.type) {
                    window.print();
                }
            }
        }, function (err) {
            dispatch(LOAD_INFO_DONE);
        });
    };
};
var getResult = exports.getResult = function getResult(data, list) {
    return function (dispatch, getState) {
        dispatch(LOAD_INFO_START);
        (0, _ajax.AjaxByToken)('getgram', {
            head: {
                transcode: 'L0099'
            },
            data: data
        }).then(function (res) {
            dispatch(LOAD_INFO_DONE);
            if (res.result != null) {
                list.map(function (obj, idx) {
                    obj.fraction = res.result.scores[idx];
                    return obj;
                });
                var dignityList = list.sort(function (a, b) {
                    return b.fraction - a.fraction;
                });
                dispatch((0, _extends3.default)({}, SCORES, { scores: res.result.scores, dignityList: dignityList }));
                dispatch((0, _extends3.default)({}, SUMMARY, { summary: res.result.summary }));
                dispatch((0, _extends3.default)({}, TYPE, { type: 5 }));
            } else {
                dispatch((0, _extends3.default)({}, TYPE, { type: 5 }));
            }
            if (data.type) {
                setTimeout(function () {
                    window.print();
                }, 1000);
            }
        }, function (err) {
            dispatch(LOAD_INFO_DONE);
        });
    };
};
var changeType = exports.changeType = function changeType() {
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, TYPE, { type: 0 }));
        setTimeout(function () {
            window.print();
        }, 200);
    };
};

var getStageLog = exports.getStageLog = function getStageLog(data) {
    return function (dispatch, getState) {
        dispatch(LOAD_INFO_START);
        (0, _ajax.AjaxByToken)('detailsByPosition', {
            head: {
                transcode: 'L0019'
            },
            data: data
        }).then(function (res) {
            dispatch(LOAD_INFO_DONE);
            dispatch((0, _extends3.default)({}, LOAD_RESUME_INFO, { resumeInfo: res }));
            dispatch((0, _extends3.default)({}, TYPE, { type: 0 }));
        });
    };
};
var getTalentResumeInfo = exports.getTalentResumeInfo = function getTalentResumeInfo(data) {
    return function (dispatch, getState) {
        dispatch(LOAD_INFO_START);
        (0, _ajax.AjaxByToken)('resumeView', {
            head: {
                transcode: 'L0040'
            },
            data: data
        }).then(function (res) {
            dispatch(LOAD_INFO_DONE);
            dispatch((0, _extends3.default)({}, LOAD_RESUME_INFO, { resumeInfo: res }));
        }, function (err) {});
    };
};

var downloadResume = exports.downloadResume = function downloadResume(data, username) {
    return function (dispatch, getState) {
        dispatch(DOWNLOAD_RESUME_START);
        var token = _store2.default.get('token');
        (0, _axios2.default)({
            url: prefixUri + '/downloadResume',
            method: 'post',
            data: (0, _extends3.default)({ data: (0, _extends3.default)({}, token, data) }, {
                head: {
                    type: 'h',
                    transcode: 'L0023'
                }
            }),
            header: {
                contentType: 'application/json;charset=utf-8'
            }
        }).then(function (res) {
            NProgress.done();
            var data = res.data;

            var blob = new Blob([data], { type: "text/html;charset=utf-8" });
            _fileSaver2.default.saveAs(blob, username + '\u7684\u4E2A\u4EBA\u7B80\u5386.html');
            dispatch(DOWNLOAD_RESUME_DONE);
        });
    };
};
var changeStageStatus = exports.changeStageStatus = function changeStageStatus(data, props) {
    return function (dispatch, getState) {
        dispatch(SHOW_MODAL_LOADING);
        (0, _ajax.AjaxByToken)('changeStageStatus', {
            head: {
                transcode: 'L0020'
            },
            data: data
        }).then(function (res) {
            dispatch(HIDE_MODAL_LOADING);

            dispatch(HIDE_MODAL);
            var currentStage = props.currentStage,
                getStageLog = props.getStageLog;
            var positionid = currentStage.positionid,
                resumeid = currentStage.resumeid;

            getStageLog({
                positionId: positionid,
                resumeId: resumeid
            });
            window.parent.postMessage('rerequest', '*');
        }, function (err) {
            dispatch(HIDE_MODAL_LOADING);
        });
    };
};
var getResumeInfo = exports.getResumeInfo = function getResumeInfo(query) {
    return function (dispatch, getState) {

        (0, _axios2.default)({
            url: prefixUri + '/share/shareResume',
            method: 'post',
            data: (0, _extends3.default)({ data: { params: query } }, {
                head: {
                    type: 'h',
                    transcode: 'L0092'
                }
            }),
            header: {
                contentType: 'application/json;charset=utf-8'
            }
        }).then(function (res) {
            dispatch((0, _extends3.default)({}, RESUME_INFO, { resumeInformation: res.data }));
            if (res.data.returnMsg == "该链接已超时!请重新分享。") {
                _antd.Modal.warning({
                    title: '链接已过期，请重新获取！',
                    okText: "确定",
                    style: { top: 200 }
                });
            }
        }, function (err) {});
    };
};
var fillEvaluation = exports.fillEvaluation = function fillEvaluation(query, resform) {
    return function (dispatch, getState) {
        (0, _axios2.default)({
            url: prefixUri + '/share/evaluationEdit',
            method: 'post',
            data: (0, _extends3.default)({ data: { params: query } }, {
                head: {
                    type: 'h',
                    transcode: 'L0093'
                }
            }),
            header: {
                contentType: 'application/json;charset=utf-8'
            }
        }).then(function (res) {
            dispatch((0, _extends3.default)({}, FILL_LOADING));
            if (res.data.returnMsg == "该链接以超时!请重新获取链接。") {
                _antd.Modal.warning({
                    title: '链接已过期，请重新分享！',
                    okText: "确定",
                    style: { top: 330 }
                });
                return false;
            } else {
                _antd.Modal.success({
                    title: '成功添加评估表！',
                    okText: "确定",
                    style: { top: 330 }
                });
            }
        }, function (err) {
            dispatch((0, _extends3.default)({}, FILL_LOADING));
            _antd.Modal.error({
                title: '添加评估表失败！'
            });
        });
    };
};

var getResumeUrl = exports.getResumeUrl = function getResumeUrl(data) {
    return function (dispatch, getState) {
        (0, _ajax.AjaxByToken)("employeeinfo/resumeUrl", {
            head: {
                transcode: "L0064"
            },
            data: data
        }).then(function (res) {
            dispatch((0, _extends3.default)({}, RESUME_INFORMATION, { resumeUrl: res }));
        }, function (err) {
            _antd.message.error('获取简历参数失败！');
        });
    };
};

var addEvaluation = exports.addEvaluation = function addEvaluation(data, props) {
    return function (dispatch, getState) {
        (0, _ajax.AjaxByToken)('evaluationEdit', {
            head: {
                transcode: 'L0063'
            },
            data: data
        }).then(function (res) {
            var getRecruitResumeInfo = props.getRecruitResumeInfo,
                resumeid = props.resumeid,
                logId = props.logId;

            getRecruitResumeInfo({
                resumeId: resumeid,
                logId: logId
            });
            if (data.id) {
                _antd.message.success('修改评估表成功！');
            } else {
                _antd.message.success('添加评估表成功！');
            }
        }, function (err) {
            if (data.id) {
                _antd.message.error('修改评估表失败！');
            } else {
                _antd.message.success('添加评估表失败！');
            }
        });
    };
};

var getEvaluation = exports.getEvaluation = function getEvaluation(data) {
    return function (dispatch, getState) {
        (0, _ajax.AjaxByToken)('employeeinfo/getResumeEvaluationById', {
            head: {
                transcode: 'L0066'
            },
            data: data,
            header: {
                contentType: 'application/json;charset=utf-8'
            }
        }).then(function (res) {

            dispatch((0, _extends3.default)({}, GET_EVALUATION, { evaluation: res.evaluation[0] }));
        }, function (err) {
            _antd.message.error('获取评估表失败！');
        });
    };
};
var getAllInterviews = exports.getAllInterviews = function getAllInterviews(data) {
    return function (dispatch, getState) {
        dispatch(LOAD_INFO_START);
        (0, _ajax.AjaxByToken)('intefb', {
            head: {
                transcode: 'L0107'
            }, data: data
        }).then(function (res) {
            dispatch(LOAD_INFO_DONE);
            dispatch((0, _extends3.default)({}, GET_EVALUATION_INTERVIEWS, { evaluationInterviews: res.result }));
        }, function (err) {
            dispatch(LOAD_INFO_DONE);
            ;
        });
    };
};

var showModal = exports.showModal = function showModal(data) {
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, SHOW_MODAL, { currentStage: data }));
    };
};

var hideModal = exports.hideModal = function hideModal() {
    return function (dispatch, getState) {
        dispatch(HIDE_MODAL);
    };
};

var showShareModal = exports.showShareModal = function showShareModal(data) {
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, SHOW_SHARE_MODAL, { resumeData: data }));
    };
};

var hideShareModal = exports.hideShareModal = function hideShareModal() {
    return function (dispatch, getState) {
        dispatch(HIDE_SHARE_MODAL);
    };
};

var showEvaluationModal = exports.showEvaluationModal = function showEvaluationModal(data) {
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, SHOW_INTERVIEW_EVALUATION_MODAL, { evaluationData: data }));
    };
};

var hideEvaluationModal = exports.hideEvaluationModal = function hideEvaluationModal() {
    return function (dispatch, getState) {
        dispatch(HIDE_INTERVIEW_EVALUATION_MODAL);
    };
};

var showBackgroundModal = exports.showBackgroundModal = function showBackgroundModal(data) {
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, SHOW_BACKGROUNDSURVEY_MODAL, { evaluationData: data }));
    };
};

var hideBackgroundModal = exports.hideBackgroundModal = function hideBackgroundModal() {
    return function (dispatch, getState) {
        dispatch(HIDE_BACKGROUNDSURVEY_MODAL);
    };
};

var showQrcodeLinkModal = exports.showQrcodeLinkModal = function showQrcodeLinkModal(data) {
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, SHOW_QRCODE_LINKMODAL, { companyInfo: data }));
    };
};

var hideQrcodeLinkModal = exports.hideQrcodeLinkModal = function hideQrcodeLinkModal() {
    return function (dispatch, getState) {
        dispatch(HIDE_QRCODE_LINKMODAL);
    };
};
var showResumeEditModal = exports.showResumeEditModal = function showResumeEditModal() {
    return function (dispatch, getState) {
        dispatch(SHOW_RESUME_EDIT_MODEL);
    };
};
var hideResumeEditModal = exports.hideResumeEditModal = function hideResumeEditModal() {
    return function (dispatch, getState) {
        dispatch(HIDE_RESUME_EDIT_MODEL);
    };
};

/***/ }),

/***/ 401:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.deleteData = exports.searchData = exports.getCondition = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _salaryReport = __webpack_require__(226);

var types = _interopRequireWildcard(_salaryReport);

var _ajax = __webpack_require__(12);

var _axios = __webpack_require__(35);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GET_INDUSTRY = { type: types.GET_INDUSTRY };
var GET_DEPARTMENT = { type: types.GET_DEPARTMENT };
var GET_POSITION = { type: types.GET_POSITION };
var SALARY_DATA = { type: types.SALARY_DATA };
var DELETE_DATA = { type: types.DELETE_DATA };

var getCondition = exports.getCondition = function getCondition(data) {
    return function (dispatch, getState) {
        (0, _ajax.AjaxByToken)('salarycount/conditions', {
            head: {
                transcode: 'L0095'
            },
            data: data
        }).then(function (res) {
            if (data && data.industry && !data.department) {
                dispatch((0, _extends3.default)({}, GET_DEPARTMENT, { department: res.secondlist }));
            } else if (data && data.industry && data.department) {
                dispatch((0, _extends3.default)({}, GET_POSITION, { position: res.thirdlist }));
            } else {
                dispatch((0, _extends3.default)({}, GET_INDUSTRY, { industry: res.firstlist }));
            }
        }, function (err) {});
    };
};

var searchData = exports.searchData = function searchData(data) {
    return function (dispatch, getState) {
        (0, _ajax.AjaxByToken)('salarycount/serach', {
            head: {
                transcode: 'L0094'
            },
            data: data
        }).then(function (res) {
            console.log(res);
            dispatch((0, _extends3.default)({}, SALARY_DATA, { salaryData: res.list }));
        }, function (err) {});
    };
};

var deleteData = exports.deleteData = function deleteData() {
    return function (dispatch, getState) {
        dispatch((0, _extends3.default)({}, DELETE_DATA));
    };
};

/***/ }),

/***/ 402:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.moveResume = exports.hideMoveResumeModal = exports.showMoveResumeModal = exports.deleteLabel = exports.hideDeleteLabelModal = exports.showDeleteLabelModal = exports.createLabel = exports.hideCreateLabelModal = exports.showCreateLabelModal = exports.cancelCollectionResume = exports.collectionResume = exports.recommendPosition = exports.hideSoleUpResume = exports.showSoleUpResume = exports.addResumeSole = exports.getTalentList = exports.getTalentCategory = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _talent = __webpack_require__(227);

var types = _interopRequireWildcard(_talent);

var _recruit = __webpack_require__(130);

var recruitTypes = _interopRequireWildcard(_recruit);

var _ajax = __webpack_require__(12);

var _antd = __webpack_require__(18);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_CATEGORY_START = {
  type: types.LOAD_CATEGORY_START
};
var LOAD_CATEGORY_DONE = {
  type: types.LOAD_CATEGORY_DONE
};
var LOAD_TALENT_CATEGORY = {
  type: types.LOAD_TALENT_CATEGORY
};

var LOAD_LIST_START = {
  type: types.LOAD_LIST_START
};
var LOAD_LIST_DONE = {
  type: types.LOAD_LIST_DONE
};
var LOAD_TALENT_LIST = {
  type: types.LOAD_TALENT_LIST
};

var TALENT_SOLE_MODEL_START = {
  type: types.TALENT_SOLE_MODEL_START
};
var TALENT_SOLE_MODEL_DONE = {
  type: types.TALENT_SOLE_MODEL_DONE
};
var TALENT_SOLE_START = {
  type: types.TALENT_SOLE_START
};
var TALENT_SOLE_DONE = {
  type: types.TALENT_SOLE_DONE
};

var RECOMMEND_POSITION_START = {
  type: types.RECOMMEND_POSITION_START
};
var RECOMMEND_POSITION_DONE = {
  type: types.RECOMMEND_POSITION_DONE
};

var SHOW_CREATE_LABEL_MODAL = {
  type: types.SHOW_CREATE_LABEL_MODAL
};
var HIDE_CREATE_LABEL_MODAL = {
  type: types.HIDE_CREATE_LABEL_MODAL
};
var CREATE_LABEL_START = {
  type: types.CREATE_LABEL_START
};
var CREATE_LABEL_DONE = {
  type: types.CREATE_LABEL_DONE
};
var SHOW_DELETE_LABEL_MODAL = {
  type: types.SHOW_DELETE_LABEL_MODAL
};
var HIDE_DELETE_LABEL_MODAL = {
  type: types.HIDE_DELETE_LABEL_MODAL
};
var DELETE_LABEL_START = {
  type: types.DELETE_LABEL_START
};
var DELETE_LABEL_DONE = {
  type: types.DELETE_LABEL_DONE
};

var SHOW_MOVE_RESUME_MODAL = {
  type: types.SHOW_MOVE_RESUME_MODAL
};
var HIDE_MOVE_RESUME_MODAL = {
  type: types.HIDE_MOVE_RESUME_MODAL
};
var MOVE_RESUME_START = {
  type: types.MOVE_RESUME_START
};
var MOVE_RESUME_DONE = {
  type: types.MOVE_RESUME_DONE
};

var LOAD_RECOMMEND_LIST = {
  type: recruitTypes.LOAD_RECOMMEND_LIST
};

var getTalentCategory = exports.getTalentCategory = function getTalentCategory() {
  return function (dispatch, getState) {
    dispatch(LOAD_CATEGORY_START);
    (0, _ajax.AjaxByToken)('TalentStatis', {
      head: {
        transcode: 'L0024'
      }
    }).then(function (res) {
      dispatch(LOAD_CATEGORY_DONE);
      dispatch((0, _extends3.default)({}, LOAD_TALENT_CATEGORY, {
        categoryData: res
      }));
    }, function (err) {
      dispatch(LOAD_CATEGORY_DONE);
    });
  };
};
var getTalentList = exports.getTalentList = function getTalentList(data) {
  return function (dispatch, getState) {
    data.start = data.start + '';
    var uri = 'queryTalent';
    (0, _ajax.cancelRequestByKey)(uri);
    dispatch(LOAD_LIST_START);
    (0, _ajax.AjaxByToken)(uri, {
      head: {
        transcode: 'L0025'
      },
      data: (0, _extends3.default)({}, data, {
        rows: 10 + ''
      })
    }).then(function (res) {
      dispatch(LOAD_LIST_DONE);
      dispatch((0, _extends3.default)({}, LOAD_TALENT_LIST, {
        talentList: res
      }));
    }, function (err) {
      dispatch(LOAD_LIST_DONE);
      dispatch((0, _extends3.default)({}, LOAD_TALENT_LIST, {
        talentList: {
          list: [],
          count: 0
        }
      }));
    });
  };
};
var addResumeSole = exports.addResumeSole = function addResumeSole(data, hide, getRecruitList, value, reload) {
  return function (dispatch, getState) {
    var uri = 'addresume';
    (0, _ajax.cancelRequestByKey)(uri);
    (0, _ajax.AjaxByToken)(uri, {
      head: {
        transcode: 'L0119'
      },
      data: data
    }).then(function (res) {
      hide();

      setTimeout(function () {
        reload();
      }, 1500);

      _antd.notification.success({
        message: '提示',
        description: res.result
      });
    }, function (err) {});
  };
};

var showSoleUpResume = exports.showSoleUpResume = function showSoleUpResume() {
  return function (dispatch, getState) {
    dispatch(TALENT_SOLE_MODEL_START);
  };
};

var hideSoleUpResume = exports.hideSoleUpResume = function hideSoleUpResume() {
  return function (dispatch, getState) {
    dispatch(TALENT_SOLE_MODEL_DONE);
  };
};

var recommendPosition = exports.recommendPosition = function recommendPosition(data, listData) {
  return function (dispatch, getState) {
    NProgress.configure({
      className: 'top0'
    });
    NProgress.start();
    dispatch(RECOMMEND_POSITION_START);
    (0, _ajax.AjaxByToken)('recommend', {
      head: {
        transcode: 'L0022'
      },
      data: data
    }).then(function (res) {
      dispatch(RECOMMEND_POSITION_DONE);
      _antd.message.success('职位推荐成功！');
      listData.list.forEach(function (item) {

        if (item.positionid === data.positionid) {
          item.isFlag = '已申请';
        }
      });
      dispatch((0, _extends3.default)({}, LOAD_RECOMMEND_LIST, {
        data: listData
      }));
    }, function (err) {
      dispatch(RECOMMEND_POSITION_DONE);
      _antd.message.error('职位推荐失败！');
    });
  };
};

var collectionResume = exports.collectionResume = function collectionResume(data) {
  return function (dispatch, getState) {
    dispatch(LOAD_LIST_START);
    (0, _ajax.AjaxByToken)('CollectionResume', {
      head: {
        transcode: 'L0027'
      },
      data: data
    }).then(function (res) {
      dispatch(LOAD_LIST_DONE);
      _antd.message.success('收藏成功！');
      var _getState$Talent = getState().Talent,
          categoryData = _getState$Talent.categoryData,
          talentList = _getState$Talent.talentList,
          list = talentList.list,
          count = talentList.count;

      list.forEach(function (item, index) {
        if (item.resumeid === data.resumeid) {
          list[index].iscollection = "1";
        }
      });
      dispatch((0, _extends3.default)({}, LOAD_TALENT_CATEGORY, {
        categoryData: (0, _extends3.default)({}, categoryData, {
          collection: categoryData.collection + 1
        })
      }));
      dispatch((0, _extends3.default)({}, LOAD_TALENT_LIST, {
        talentList: {
          list: list,
          count: count
        }
      }));
    }, function (err) {
      dispatch(LOAD_LIST_DONE);
      _antd.message.success('收藏失败！');
    });
  };
};

var cancelCollectionResume = exports.cancelCollectionResume = function cancelCollectionResume(data) {
  return function (dispatch, getState) {
    dispatch(LOAD_LIST_START);
    (0, _ajax.AjaxByToken)('cancelthecollection', {
      head: {
        transcode: 'L0037'
      },
      data: data
    }).then(function (res) {
      dispatch(LOAD_LIST_DONE);
      _antd.message.success('取消收藏成功！');
      var _getState$Talent2 = getState().Talent,
          categoryData = _getState$Talent2.categoryData,
          talentList = _getState$Talent2.talentList,
          list = talentList.list,
          count = talentList.count;

      list.forEach(function (item, index) {
        if (item.resumeid === data.resumeid) {
          list[index].iscollection = "0";
        }
      });
      dispatch((0, _extends3.default)({}, LOAD_TALENT_CATEGORY, {
        categoryData: (0, _extends3.default)({}, categoryData, {
          collection: categoryData.collection - 1
        })
      }));
      dispatch((0, _extends3.default)({}, LOAD_TALENT_LIST, {
        talentList: {
          list: list,
          count: count
        }
      }));
    }, function (err) {
      dispatch(LOAD_LIST_DONE);
      _antd.message.success('取消收藏失败！');
    });
  };
};

var showCreateLabelModal = exports.showCreateLabelModal = function showCreateLabelModal() {
  return function (dispatch, getState) {
    dispatch(SHOW_CREATE_LABEL_MODAL);
  };
};

var hideCreateLabelModal = exports.hideCreateLabelModal = function hideCreateLabelModal() {
  return function (dispatch, getState) {
    dispatch(HIDE_CREATE_LABEL_MODAL);
  };
};

var createLabel = exports.createLabel = function createLabel(data) {
  var getTalentCategory = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  return function (dispatch, getState) {
    dispatch(CREATE_LABEL_START);
    (0, _ajax.AjaxByToken)('deleteOrSaveTheLable', {
      head: {
        transcode: 'L0026'
      },
      data: data
    }).then(function (res) {
      _antd.message.success('新建类别成功！');
      dispatch(CREATE_LABEL_DONE);
      setTimeout(function () {
        dispatch(HIDE_CREATE_LABEL_MODAL);
      }, 500);

      getTalentCategory();
    }, function (err) {
      dispatch(CREATE_LABEL_DONE);
    });
  };
};

var showDeleteLabelModal = exports.showDeleteLabelModal = function showDeleteLabelModal() {
  return function (dispatch, getState) {
    dispatch(SHOW_DELETE_LABEL_MODAL);
  };
};

var hideDeleteLabelModal = exports.hideDeleteLabelModal = function hideDeleteLabelModal() {
  return function (dispatch, getState) {
    dispatch(HIDE_DELETE_LABEL_MODAL);
  };
};

var deleteLabel = exports.deleteLabel = function deleteLabel(data) {
  var getTalentCategory = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  return function (dispatch, getState) {
    dispatch(DELETE_LABEL_START);
    (0, _ajax.AjaxByToken)('deleteOrSaveTheLable', {
      head: {
        transcode: 'L0026'
      },
      data: data
    }).then(function (res) {
      _antd.message.success('删除类别成功！');
      dispatch(DELETE_LABEL_DONE);
      setTimeout(function () {
        dispatch(HIDE_DELETE_LABEL_MODAL);
      }, 500);
      getTalentCategory();
    }, function (err) {
      _antd.message.success('删除类别失败！');
      dispatch(DELETE_LABEL_DONE);
    });
  };
};

var showMoveResumeModal = exports.showMoveResumeModal = function showMoveResumeModal() {
  return function (dispatch, getState) {
    dispatch(SHOW_MOVE_RESUME_MODAL);
  };
};

var hideMoveResumeModal = exports.hideMoveResumeModal = function hideMoveResumeModal() {
  return function (dispatch, getState) {
    dispatch(HIDE_MOVE_RESUME_MODAL);
  };
};

var moveResume = exports.moveResume = function moveResume(data) {
  var getTalentCategory = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  return function (dispatch, getState) {
    dispatch(MOVE_RESUME_START);
    (0, _ajax.AjaxByToken)('resumemobile', {
      head: {
        transcode: 'L0031'
      },
      data: data
    }).then(function (res) {
      dispatch(MOVE_RESUME_DONE);
      _antd.message.success('移动成功！');
      getTalentCategory();
      dispatch(HIDE_MOVE_RESUME_MODAL);
    }, function (err) {
      dispatch(MOVE_RESUME_DONE);
    });
  };
};

/***/ }),

/***/ 403:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getTaskReport = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _task = __webpack_require__(228);

var types = _interopRequireWildcard(_task);

var _axios = __webpack_require__(35);

var _axios2 = _interopRequireDefault(_axios);

var _store = __webpack_require__(28);

var _store2 = _interopRequireDefault(_store);

var _ajax = __webpack_require__(12);

var _moment = __webpack_require__(119);

var _moment2 = _interopRequireDefault(_moment);

var _test = __webpack_require__(406);

var _test2 = _interopRequireDefault(_test);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GET_TASK_START = { type: types.GET_TASK_START };
var GET_TASK_REPORT = { type: types.GET_TASK_REPORT };
var GET_TASK_DONE = { type: types.GET_TASK_DONE };

var getTaskReport = exports.getTaskReport = function getTaskReport() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var startDate = arguments[1];
    var endDate = arguments[2];
    return function (dispatch, getState) {
        dispatch(GET_TASK_START);
        (0, _ajax.AjaxByToken)('progress_report', {
            head: {
                transcode: 'L0034'
            },
            data: data
        }).then(function (res) {
            dispatch(GET_TASK_DONE);

            var endtime = endDate ? endDate : new Date().getTime(),
                starttime = startDate ? startDate : endtime - 7 * 24 * 60 * 60 * 1000;
            dispatch((0, _extends3.default)({}, GET_TASK_REPORT, { data: { list: res.map, starttime: starttime, endtime: endtime } }));
        }, function (err) {
            dispatch(GET_TASK_DONE);
            dispatch((0, _extends3.default)({}, GET_TASK_REPORT, { data: { list: {} } }));
        });
    };
};

/***/ }),

/***/ 404:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.changeResFalse = exports.changePassWd = exports.changeEmailSetting = exports.changeResumeEmailSetting = exports.getResumeEmail = exports.getUserEmail = exports.getUserInfo = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _user = __webpack_require__(229);

var types = _interopRequireWildcard(_user);

var _ajax = __webpack_require__(12);

var _antd = __webpack_require__(18);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GET_USER_INFO = { type: types.GET_USER_INFO };

var GET_USER_EMAIL_INFO = { type: types.GET_USER_EMAIL_INFO };
var GET_USER_RESUMEEMAIL_INFO = { type: types.GET_USER_RESUMEEMAIL_INFO };

var CHANGE_PASSWD_START = { type: types.CHANGE_PASSWD_START };
var CHANGE_PASSWD_DONE = { type: types.CHANGE_PASSWD_DONE };
var CHANGE_PASSWD = { type: types.CHANGE_PASSWD };
var CHANGE_RES_FALSE = { type: types.CHANGE_RES_FALSE };

var getUserInfo = exports.getUserInfo = function getUserInfo() {
    return function (dispatch, getState) {
        (0, _ajax.AjaxByToken)('basicUserinfo', {
            head: {
                transcode: 'L0006'
            }
        }).then(function (res) {
            dispatch((0, _extends3.default)({}, GET_USER_INFO, { userInfo: res }));
        });
    };
};

var getUserEmail = exports.getUserEmail = function getUserEmail() {
    return function (dispatch, getState) {
        (0, _ajax.AjaxByToken)('toConnectMail', {
            head: {
                transcode: 'L0003'
            }
        }).then(function (res) {
            dispatch((0, _extends3.default)({}, GET_USER_EMAIL_INFO, { userEmailInfo: res }));
        });
    };
};
var getResumeEmail = exports.getResumeEmail = function getResumeEmail() {
    return function (dispatch, getState) {
        (0, _ajax.AjaxByToken)('importEmail/API_AUTO_IMPORT_MAIL_RESUMEINFO_LIST', {
            head: {
                transcode: 'L0071'
            }
        }).then(function (res) {
            dispatch((0, _extends3.default)({}, GET_USER_RESUMEEMAIL_INFO, { resumeEmailInfo: res }));
        });
    };
};

var changeResumeEmailSetting = exports.changeResumeEmailSetting = function changeResumeEmailSetting(data) {
    return function (dispatch, getState) {
        (0, _ajax.AjaxByToken)('importEmail/API_AUTO_IMPORT_MAIL_RESUMEINFOS_UPDATE', {
            head: {
                transcode: 'L0072'
            },
            data: data
        }).then(function (res) {
            NProgress.done();
            _antd.message.success('配置邮箱成功！');
        });
    };
};

var changeEmailSetting = exports.changeEmailSetting = function changeEmailSetting(data) {
    return function (dispatch, getState) {
        (0, _ajax.AjaxByToken)('changeMailPwd', {
            head: {
                transcode: 'L0004'
            },
            data: data
        }).then(function (res) {
            NProgress.done();
            _antd.message.success('配置邮箱成功！');
        });
    };
};

var changePassWd = exports.changePassWd = function changePassWd() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (dispatch, getState) {
        dispatch(CHANGE_PASSWD_START);
        (0, _ajax.AjaxByToken)('changepwd', {
            head: {
                transcode: 'L0002'
            },
            data: data
        }).then(function (res) {
            dispatch(CHANGE_PASSWD_DONE);
            _antd.message.success('修改密码成功！');
            dispatch(CHANGE_PASSWD);
        }, function (err) {
            dispatch(CHANGE_PASSWD_DONE);
        });
    };
};

var changeResFalse = exports.changeResFalse = function changeResFalse() {
    return function (dispatch, getState) {
        dispatch(CHANGE_RES_FALSE);
    };
};

/***/ }),

/***/ 405:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(185);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(181);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(184);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(183);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(182);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(7);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(120);

var _isEmpty = __webpack_require__(331);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _redux = __webpack_require__(51);

var _reactRedux = __webpack_require__(77);

var _actions = __webpack_require__(326);

var Actions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavBarComponents = function (_Component) {
    (0, _inherits3.default)(NavBarComponents, _Component);

    function NavBarComponents() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, NavBarComponents);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = NavBarComponents.__proto__ || (0, _getPrototypeOf2.default)(NavBarComponents)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            isLoading: false,
            showSetting: false,
            keyword: ''
        }, _this.showNprogress = function () {
            var uri = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
            var location = _this.props.location,
                pathname = location.pathname;


            if (uri === pathname) return;
            NProgress.start();
        }, _this.showSettings = function () {
            _this.setState({
                showSetting: true
            });
        }, _this.hideSettings = function () {
            _this.setState({
                showSetting: false
            });
        }, _this.logout = function () {
            _this.hideSettings();
            NProgress.start();
            _this.props.userLoginout(_this.context);
        }, _this.handleClickSetting = function (uri) {
            _this.hideSettings();
            var location = _this.props.location,
                pathname = location.pathname;

            if (uri === pathname) return;
            _this.showNprogress();
            _this.hideSettings();
        }, _this.handleKeyUp = function (event) {
            if (event.keyCode === 13) {
                _this.searchKeyword();
            }
        }, _this.searchKeyword = function () {
            var location = _this.props.location;
            var pathname = location.pathname;

            var matchPath = /\/talent/i;
            if (!matchPath.test(pathname)) {
                NProgress.start();
            }
            _this.context.router.push('/talent/' + _this.state.keyword);
        }, _this.handleChange = function (e) {
            _this.setState({
                keyword: e.target.value
            });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(NavBarComponents, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({
                isLoading: true
            });
            this.props.getUserInfo();
        }
    }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate(nextProps, nextState) {
            if (!(0, _isEmpty2.default)(nextProps.userInfo) && nextState.isLoading) {
                this.setState({
                    isLoading: false
                });
            }

            if (this.state.keyword !== '' && this.props.location.pathname.indexOf('/talent') !== -1 && nextProps.location.pathname.indexOf('/talent') === -1) {
                this.setState({
                    keyword: ''
                });
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return this.props !== nextProps || nextState !== this.state;
        }
    }, {
        key: 'getBDLink',
        value: function getBDLink() {
            this.props.getBDLink();
        }
    }, {
        key: 'showEmail',
        value: function showEmail() {
            var location = this.props.location,
                pathname = location.pathname;

            if (pathname == '/email') return;
            this.showNprogress();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                isLoading = _state.isLoading,
                keyword = _state.keyword,
                _props = this.props,
                location = _props.location,
                userInfo = _props.userInfo,
                pathname = location.pathname,
                _userInfo$username = userInfo.username,
                username = _userInfo$username === undefined ? '' : _userInfo$username,
                _userInfo$companyname = userInfo.companyname,
                companyname = _userInfo$companyname === undefined ? '' : _userInfo$companyname,
                prefix = './static/images/navbar/',
                navData = [{ name: '职位管理', path: '/job/index', type: '0' }, { name: '招聘流程', path: '/recruit', type: '0' }, { name: '人才库', path: '/talent', type: '0' }, { name: '任务报表', path: '/task', type: '0' }, { name: '员工管理', path: '/manager', type: '0' }, { name: '行业薪酬', path: '/chooseSalary', type: '0' }, { name: '我要背调', path: '/ultimately', type: '1' }];

            return _react2.default.createElement(
                'div',
                { className: 'navbar' },
                _react2.default.createElement(
                    'div',
                    { className: 'navbar-inner' },
                    _react2.default.createElement(
                        'div',
                        { className: 'logo' },
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { to: '/', onClick: function onClick() {
                                    return _this2.showNprogress('/');
                                } },
                            _react2.default.createElement('img', { src: prefix + 'logo.png', alt: '51\u4E91\u62DB\u8058' })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'home', style: { backgroundColor: pathname === '/' ? '#00699f' : '' } },
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { to: '#/', onClick: function onClick() {
                                    return _this2.showNprogress('/');
                                } },
                            _react2.default.createElement('img', { src: prefix + 'home.png', alt: '\u9996\u9875' })
                        )
                    ),
                    _react2.default.createElement(
                        'ul',
                        { className: 'nav-list' },
                        navData.map(function (item, index) {
                            var path = item.path,
                                name = item.name,
                                type = item.type;

                            return _react2.default.createElement(
                                'li',
                                {
                                    key: index,
                                    style: {
                                        backgroundColor: pathname.indexOf(path) !== -1 ? '#00699f' : ''
                                    }
                                },
                                type == "0" && _react2.default.createElement(
                                    _reactRouter.Link,
                                    { onClick: function onClick() {
                                            return _this2.showNprogress(path);
                                        }, to: path },
                                    name
                                ),
                                type == "1" && _react2.default.createElement(
                                    _reactRouter.Link,
                                    { onClick: function onClick() {
                                            return _this2.getBDLink();
                                        } },
                                    name
                                )
                            );
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'user' },
                        !isLoading && _react2.default.createElement(
                            'div',
                            { className: 'table' },
                            _react2.default.createElement(
                                'div',
                                { className: 'table-row' },
                                _react2.default.createElement(
                                    'div',
                                    {
                                        className: 'email-address dropdown-wrapper',
                                        onMouseLeave: this.hideSettings,
                                        onMouseOver: this.showSettings

                                    },
                                    username,
                                    _react2.default.createElement(
                                        'ul',
                                        { className: 'dropdown-menu box-border', style: {
                                                transform: this.state.showSetting ? 'translateY(10px)' : ''
                                            } },
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            _react2.default.createElement(
                                                _reactRouter.Link,
                                                { to: '/interview', onClick: this.handleClickSetting.bind(this, '/interview') },
                                                '\u9762\u8BD5\u7BA1\u7406'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            _react2.default.createElement(
                                                _reactRouter.Link,
                                                { to: '/system/upInfo', onClick: this.handleClickSetting.bind(this, '/system/upInfo') },
                                                '\u7CFB\u7EDF\u8BBE\u7F6E'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            _react2.default.createElement(
                                                _reactRouter.Link,
                                                { to: '/help', onClick: this.handleClickSetting.bind(this, '/help') },
                                                '\u4F7F\u7528\u5E2E\u52A9'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            null,
                                            _react2.default.createElement(
                                                _reactRouter.Link,
                                                { href: 'javascript:;', onClick: this.logout },
                                                '\u9000\u51FA\u7CFB\u7EDF'
                                            )
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'table-row' },
                                _react2.default.createElement(
                                    'p',
                                    { className: 'company-name' },
                                    companyname
                                )
                            )
                        ),
                        isLoading && _react2.default.createElement('div', { className: 'preloader-white absolute-center', style: {
                                width: 25,
                                height: 25
                            } })
                    ),
                    _react2.default.createElement(
                        _reactRouter.Link,
                        {
                            to: '/email',
                            className: 'email ' + (pathname === '/email' ? 'active' : ''),

                            onClick: function onClick() {
                                return _this2.showEmail();
                            }
                        },
                        _react2.default.createElement('img', { src: prefix + 'email.png', alt: '\u90AE\u7BB1' })
                    )
                )
            );
        }
    }]);
    return NavBarComponents;
}(_react.Component);

NavBarComponents.contextTypes = {
    router: _react.PropTypes.object
};


var mapStateToProps = function mapStateToProps(state) {
    return {
        userInfo: state.User.userInfo
    };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        getUserInfo: (0, _redux.bindActionCreators)(Actions.UserActions.getUserInfo, dispatch),
        userLoginout: (0, _redux.bindActionCreators)(Actions.logoutActions.userLoginout, dispatch),
        getBDLink: (0, _redux.bindActionCreators)(Actions.ManageActions.getBDLink, dispatch)
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(NavBarComponents);

/***/ }),

/***/ 406:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    "51金融圈总部": [{
        "userId": "131",
        "loginName": "51jrq",
        "userName": "51jrq",
        "branchId": "B_10002",
        "loginNum": 490,
        "search51Num": 0,
        "searchZLNum": 0,
        "down51Num": 0,
        "downZLNum": 0,
        "handHistoryNum": 0,
        "hand51Num": 0,
        "handZLNum": 2,
        "resumeCount": 0,
        "positionNum": 0,
        "applicationNum_todo": 10,
        "applicationNum": 49,
        "reservationNum": 32,
        "interviewNum": 17,
        "reexaminationNum": 8,
        "entryNum": 8,
        "processedNum": 50
    }, { "userId": "136", "loginName": "cathycheng@51jrq.com", "userName": "程东梅", "branchId": "B_10002", "loginNum": 11, "search51Num": 0, "searchZLNum": 0, "down51Num": 0, "downZLNum": 0, "handHistoryNum": 0, "hand51Num": 0, "handZLNum": 0, "resumeCount": 0, "positionNum": 0, "applicationNum_todo": 0, "applicationNum": 0, "reservationNum": 0, "interviewNum": 0, "reexaminationNum": 0, "entryNum": 0, "processedNum": 0 }, { "userId": "137", "loginName": "guychen@51jrq.com", "userName": "陈浩", "branchId": "B_10002", "loginNum": 2, "search51Num": 0, "searchZLNum": 0, "down51Num": 0, "downZLNum": 0, "handHistoryNum": 0, "hand51Num": 0, "handZLNum": 0, "resumeCount": 0, "positionNum": 0, "applicationNum_todo": 4, "applicationNum": 0, "reservationNum": 0, "interviewNum": 0, "reexaminationNum": 0, "entryNum": 0, "processedNum": 0 }, { "userId": "138", "loginName": "huyangke@51jrq.com", "userName": "胡洋可", "branchId": "B_10002", "loginNum": 33, "search51Num": 0, "searchZLNum": 0, "down51Num": 0, "downZLNum": 0, "handHistoryNum": 0, "hand51Num": 0, "handZLNum": 0, "resumeCount": 0, "positionNum": 0, "applicationNum_todo": 1, "applicationNum": 0, "reservationNum": 0, "interviewNum": 0, "reexaminationNum": 0, "entryNum": 0, "processedNum": 0 }, { "userId": "140", "loginName": "luwanding@163.com", "userName": "陆万丁", "branchId": "B_10002", "loginNum": 27, "search51Num": 0, "searchZLNum": 0, "down51Num": 0, "downZLNum": 0, "handHistoryNum": 0, "hand51Num": 0, "handZLNum": 0, "resumeCount": 0, "positionNum": 0, "applicationNum_todo": 3, "applicationNum": 0, "reservationNum": 0, "interviewNum": 0, "reexaminationNum": 0, "entryNum": 0, "processedNum": 0 }, { "userId": "139", "loginName": "winson@51jrq.com", "userName": "余文忠", "branchId": "B_10002", "loginNum": 2, "search51Num": 0, "searchZLNum": 0, "down51Num": 0, "downZLNum": 0, "handHistoryNum": 0, "hand51Num": 0, "handZLNum": 0, "resumeCount": 0, "positionNum": 0, "applicationNum_todo": 0, "applicationNum": 0, "reservationNum": 0, "interviewNum": 0, "reexaminationNum": 0, "entryNum": 0, "processedNum": 0 }]
};

/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.onLeavePage = exports.requireHook = exports.requireAuthHook = exports.onEnterLoginHook = undefined;

var _store = __webpack_require__(28);

var _store2 = _interopRequireDefault(_store);

var _ajax = __webpack_require__(12);

var _resumeSearch = __webpack_require__(214);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onEnterLoginHook = exports.onEnterLoginHook = function onEnterLoginHook(nextState, replace) {
    var _ref = _store2.default.get('token') || {},
        token = _ref.token;

    if (token) replace({ pathname: '/' });
};

var requireAuthHook = exports.requireAuthHook = function requireAuthHook(nextState, replace) {
    var _ref2 = _store2.default.get('token') || {},
        token = _ref2.token;

    if (!token) replace({ pathname: '/login' });
    var routes = nextState.routes,
        title = routes[routes.length - 1].breadcrumbName;

    document.title = '51\u62DB\u8058\u4E91 - ' + (title ? title : routes[routes.length - 2].breadcrumbName);
};

var requireHook = exports.requireHook = function requireHook(nextState, replace) {
    var routes = nextState.routes,
        title = routes[routes.length - 1].breadcrumbName;

    document.title = '51\u62DB\u8058\u4E91 - ' + (title ? title : routes[routes.length - 2].breadcrumbName);
};

var onLeavePage = exports.onLeavePage = function onLeavePage(nextState, replace) {
    (0, _ajax.cancelRequest)();
};

/***/ }),

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(7);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(92);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _promisePolyfill = __webpack_require__(325);

var _promisePolyfill2 = _interopRequireDefault(_promisePolyfill);

__webpack_require__(321);

__webpack_require__(323);

__webpack_require__(324);

__webpack_require__(322);

var _reactRouter = __webpack_require__(120);

var _redux = __webpack_require__(51);

var _reactRedux = __webpack_require__(77);

var _reduxThunk = __webpack_require__(118);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reducer = __webpack_require__(317);

var _reducer2 = _interopRequireDefault(_reducer);

var _router = __webpack_require__(318);

var _router2 = _interopRequireDefault(_router);

__webpack_require__(319);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.prefixUri = '/51hr/api/web';

window.resumeUrl = '/resumeClient/api';
NProgress.configure({
    className: 'top56'
});

if (!window.Promise) {
    window.Promise = _promisePolyfill2.default;
}

var store = (0, _redux.createStore)(_reducer2.default, (0, _redux.applyMiddleware)(_reduxThunk2.default));

_reactDom2.default.render(_react2.default.createElement(
    _reactRedux.Provider,
    { store: store },
    _react2.default.createElement(_reactRouter.Router, { history: _reactRouter.hashHistory, routes: _router2.default })
), document.getElementById('app'));

/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = addInterviews;

var _addInterview = __webpack_require__(215);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    showModel: false,
    isLoading: false,
    AddInterviewList: []
};
function addInterviews() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var actions = arguments[1];

    switch (actions.type) {
        case _addInterview.START_ADDINTERVIEW_MODAL:
            return (0, _extends3.default)({}, state, { isLoading: true });
        case _addInterview.DONE_ADDINTERVIEW_MODAL:
            return (0, _extends3.default)({}, state, { isLoading: false });
        case _addInterview.ADD_INTERVIEW_DATA:
            return (0, _extends3.default)({}, state, { AddInterviewList: actions.addInterviewList });
        case _addInterview.HIDE_ADDINTERVIEW_MODAL:
            return (0, _extends3.default)({}, state, { showModel: false });
        case _addInterview.SHOW_ADDINTERVIEW_MODAL:
            return (0, _extends3.default)({}, state, { showModel: true });
        default:
            return state;
    }
}

/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = downloadQr;

var _downloadQr = __webpack_require__(216);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    visible: false

};
function downloadQr() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var actions = arguments[1];

    console.log(state, actions);
    switch (actions.type) {
        case _downloadQr.SHOW_QR_MODAL:
            return (0, _extends3.default)({}, state, { visible: true });
        case _downloadQr.HIDE_QR_MODAL:
            return (0, _extends3.default)({}, state, { visible: false });
        default:
            return state;
    }
}

/***/ }),

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = email;

var _email = __webpack_require__(217);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    historyEmail: {
        isLoading: false,
        list: []
    },
    isSendEmailDone: true,
    modalVisible: false,
    resetFileList: false,
    personHistoryList: [],
    sendEmailVisible: false
};

function email() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var actions = arguments[1];

    switch (actions.type) {
        case _email.GET_HISTORY_START:
            return (0, _extends3.default)({}, state, { historyEmail: (0, _extends3.default)({}, state.historyEmail, { isLoading: true }) });
        case _email.GET_HISTORY_END:
            return (0, _extends3.default)({}, state, { historyEmail: (0, _extends3.default)({}, state.historyEmail, { isLoading: false }) });
        case _email.GET_EMAIL_HISTORY:
            return (0, _extends3.default)({}, state, { historyEmail: (0, _extends3.default)({}, state.historyEmail, { list: actions.list }) });
        case _email.SEND_EMAIL_START:
            return (0, _extends3.default)({}, state, { isSendEmailDone: false });
        case _email.SEND_EMAIL_DONE:
            return (0, _extends3.default)({}, state, { isSendEmailDone: true });
        case _email.SHOW_UPLOAD_MODAL:
            return (0, _extends3.default)({}, state, { modalVisible: true });
        case _email.HIDE_UPLOAD_MODAL:
            return (0, _extends3.default)({}, state, { modalVisible: false });
        case _email.RESET_FILELIST_TRUE:
            return (0, _extends3.default)({}, state, { resetFileList: true });
        case _email.RESET_FILELIST_FALSE:
            return (0, _extends3.default)({}, state, { resetFileList: false });
        case _email.SHOW_EMAIL_MODAL:
            return (0, _extends3.default)({}, state, { sendEmailVisible: true });
        case _email.HIDE_EMAIL_MODAL:
            return (0, _extends3.default)({}, state, { sendEmailVisible: false });
        case _email.GET_PERSON_INFO_HISTORY_RECORD:
            return (0, _extends3.default)({}, state, { personHistoryList: actions.personHistoryList });
        default:
            return state;
    }
}

/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = file;

var _file = __webpack_require__(218);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {};

function file() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var actions = arguments[1];

    switch (actions.type) {
        case _file.REMOVE_UPLOAD_FILE:
            return (0, _extends3.default)({}, state);
        default:
            return state;
    }
}

/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = home;

var _home = __webpack_require__(219);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    resumeData: {},
    resumeCount: {},
    taskProgress: [],
    isEntryLoading: false,
    entryPersonList: [],
    memoModalVisible: false,
    isMemoLoading: false,
    MemoContent: {},
    DateMemoContent: {},
    video: {}
};

function home() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var actions = arguments[1];

    switch (actions.type) {
        case _home.URGENT_TASKS:
            return (0, _extends3.default)({}, state, { urgentTasks: actions.urgentTasks });
        case _home.GET_MEMO_CONTENT:
            return (0, _extends3.default)({}, state, { MemoContent: actions.MemoContent });
        case _home.GET_DATE_MEMO_CONTENT:
            return (0, _extends3.default)({}, state, { DateMemoContent: actions.DateMemoContent });
        case _home.RESUME:
            return (0, _extends3.default)({}, state, { resumeData: actions.resumeData });
        case _home.RESUMEACCOUNT:
            return (0, _extends3.default)({}, state, { resumeCount: actions.resumeCount });
        case _home.TASK_PROGRESS:
            return (0, _extends3.default)({}, state, { taskProgress: actions.taskProgress });
        case _home.GET_ENTRY_START:
            return (0, _extends3.default)({}, state, { isEntryLoading: true });
        case _home.GET_ENTRY_DONE:
            return (0, _extends3.default)({}, state, { isEntryLoading: false });
        case _home.GET_ENTRY_LIST:
            return (0, _extends3.default)({}, state, { entryPersonList: actions.entryPersonList });
        case _home.SHOW_MEMO_MODAL:
            return (0, _extends3.default)({}, state, { memoModalVisible: true, isMemoLoading: true });
        case _home.HIDE_MEMO_MODAL:
            return (0, _extends3.default)({}, state, { memoModalVisible: false, isMemoLoading: false });
        case _home.GET_VIDEO:
            return (0, _extends3.default)({}, state, { video: actions.video });
        default:
            return state;
    }
}

/***/ }),

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = intellhr;

var _intellHR = __webpack_require__(220);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    hasSingleCall: false,
    hasHisCall: false,
    phoneLogInfo: [],
    robotCallModalVisiable: false
};

function intellhr() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var actions = arguments[1];

    switch (actions.type) {
        case _intellHR.SINGLECALL:
            return (0, _extends3.default)({}, state, { hasSingleCall: true });
        case _intellHR.PHONELOGINFO:
            return (0, _extends3.default)({}, state, { phoneLogInfo: actions.phoneLogInfo, hasHisCall: true });
        case _intellHR.SHOW_ROBOT_CALL_MODAL:
            return (0, _extends3.default)({}, state, { robotCallModalVisiable: true });
        case _intellHR.HIDE_ROBOT_CALL_MODAL:
            return (0, _extends3.default)({}, state, { robotCallModalVisiable: false });
        default:
            return state;
    }
}

/***/ }),

/***/ 415:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = interview;

var _interview = __webpack_require__(221);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    isLoading: false,
    isLoadingList: false,

    interviewList: [],
    searchData: [],
    isLoadingInfo: false,
    interview: {
        visable: false
    }
};
function interview() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var actions = arguments[1];

    console.log(state, actions);
    switch (actions.type) {
        case _interview.LOAD_TABLE_START:
            return (0, _extends3.default)({}, state, { isLoading: true });
        case _interview.LOAD_TABLE_DONE:
            return (0, _extends3.default)({}, state, { isLoading: false });
        case _interview.INTERVIEW_LIST_DATA:
            return (0, _extends3.default)({}, state, { interviewList: actions.interviewList });
        case _interview.INTERVIEW_TABLE_DATA:
            return (0, _extends3.default)({}, state, { interviewData: actions.interviewData });
        case _interview.CANCELINTERVIEW_TABLE_DATA:
            return (0, _extends3.default)({}, state, { interviewData: actions.interviewData });
        case _interview.HIDE_INTERVIEW_MODAL:
            return (0, _extends3.default)({}, state, { interview: (0, _extends3.default)({}, state.interview, { visable: false }) });
        case _interview.SHOW_INTERVIEW_MODAL:
            return (0, _extends3.default)({}, state, { interview: (0, _extends3.default)({}, state.interview, { visable: true }) });
        case _interview.SEARCH_TABLE_DATA:
            return (0, _extends3.default)({}, state, { searchData: actions.searchData });
        default:
            return state;
    }
}

/***/ }),

/***/ 416:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = job;

var _job = __webpack_require__(222);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  categoryData: {
    all: 0,
    completed: 0,
    ongoing: 0,
    preparation: 0,
    stop: 0
  },
  listData: {
    list: [],
    count: 0
  },
  jobInfo: {},
  isLoadingList: true,
  isLoadingInfo: false,
  isCanCreateJob: true,
  isLoadingAbort: false,
  modalVisible: false,
  saveModalVisible: false,
  salaryModalVisible: false,
  interview: {},
  salaryData: [],
  positionSalary: "",
  tagList: [],
  clear: false
};

function job() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var actions = arguments[1];

  switch (actions.type) {
    case _job.CLEAR_CHOOSED_STATUS:
      return (0, _extends3.default)({}, state, { clear: true });
    case _job.ADD_TAGLIST:
      return (0, _extends3.default)({}, state, { tagList: actions.tagList });
    case _job.LOAD_CATEGORY_START:
      return (0, _extends3.default)({}, state, { isLoadingCategory: true });
    case _job.LOAD_CATEGORY_DONE:
      return (0, _extends3.default)({}, state, { isLoadingCategory: false });
    case _job.JOB_CATEGORY:
      return (0, _extends3.default)({}, state, { categoryData: actions.categoryData });
    case _job.LOAD_LIST_START:
      return (0, _extends3.default)({}, state, { isLoadingList: true });
    case _job.LOAD_LIST_DONE:
      return (0, _extends3.default)({}, state, { isLoadingList: false });
    case _job.JOB_LIST:
      return (0, _extends3.default)({}, state, { listData: actions.listData });
    case _job.LOAD_INFO_START:
      return (0, _extends3.default)({}, state, { isLoadingInfo: true });
    case _job.LOAD_INFO_DONE:
      return (0, _extends3.default)({}, state, { isLoadingInfo: false });
    case _job.JOB_INFO:
      return (0, _extends3.default)({}, state, { jobInfo: actions.jobInfo });
    case _job.RESET_FORM:
      return (0, _extends3.default)({}, state, { jobInfo: {} });
    case _job.CREATE_JOB_START:
      return (0, _extends3.default)({}, state, { isCanCreateJob: false });
    case _job.CREATE_JOB_DONE:
      return (0, _extends3.default)({}, state, { isCanCreateJob: true });
    case _job.ABORT_JOB_START:
      return (0, _extends3.default)({}, state, { isLoadingAbort: true });
    case _job.ABORT_JOB_DONE:
      return (0, _extends3.default)({}, state, { isLoadingAbort: false });
    case _job.SHOW_JOB_MODAL:
      return (0, _extends3.default)({}, state, { modalVisible: true });
    case _job.HIDE_JOB_MODAL:
      return (0, _extends3.default)({}, state, { modalVisible: false });
    case _job.SHOW_SAVEJOB_MODAL:
      return (0, _extends3.default)({}, state, { saveModalVisible: true });
    case _job.HIDE_SAVEJOB_MODAL:
      return (0, _extends3.default)({}, state, { saveModalVisible: false });
    case _job.RESUMEID:
      return (0, _extends3.default)({}, state, { interview: actions.interview });
    case _job.CANCELLRESUMEID:
      return (0, _extends3.default)({}, state, { interview: actions.interview });
    case _job.SHOW_SALARY_MODAL:
      return (0, _extends3.default)({}, state, {
        salaryModalVisible: true,
        positionSalary: actions.positionSalary
      });
    case _job.HIDE_SALARY_MODAL:
      return (0, _extends3.default)({}, state, { salaryModalVisible: false });
    case _job.SALARYDATA:
      return (0, _extends3.default)({}, state, { salaryData: actions.salaryData });
    case _job.CANCELSALARY:
      return (0, _extends3.default)({}, state, { salaryData: [] });
    default:
      return state;
  }
}

/***/ }),

/***/ 417:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = login;

var _login = __webpack_require__(129);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    isLoading: false
};

function login() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var actions = arguments[1];

    switch (actions.type) {
        case _login.LOGIN_START:
            return (0, _extends3.default)({}, state, { loaddone: false });
        case _login.LOGIN_DONE:
            return (0, _extends3.default)({}, state, { loaddone: true });
        default:
            return state;
    }
}

/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = manage;

var _manage = __webpack_require__(223);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    staffModal: {
        visible: false
    },
    manageStastistics: {
        isLoading: false,
        list: []
    },
    crewList: {
        isLoading: false,
        list: [],
        count: 0
    },
    uploadClerkModal: {
        isLoading: false,
        visible: false,
        resetForm: false
    },
    exportClerkList: {
        isLoading: false
    },
    deleteClerkList: {
        isLoading: false,
        isDelete: false
    },
    queryEmployeeList: {
        isLoading: false,
        list: {}
    },
    dismissionModal: {
        isLoading: false,
        visible: false
    },
    permanentModal: {
        isLoading: false,
        visible: false
    },
    transferPersonnelModal: {
        isLoading: false,
        visible: false,
        isTransferPersonnel: false
    },
    attactmentModal: {
        isLoading: false,
        visible: false
    },
    operationList: {
        isLoading: false,
        count: 0,
        list: []
    },
    isInfoLoading: false,
    isDataLoading: false,
    employeeInfo: {},
    visible: false,
    uriParams: {},
    creditData: {},
    creditInfoData: {},
    isFill: false,
    attactmentType: {},
    searchLoading: false,

    archivesList: {
        isLoading: false,
        count: 0,
        list: []
    },
    leaveArchivesList: {
        isLoading: false,
        count: 0,
        list: []
    },
    progressVisible: false,
    departmentStaff: {},
    currentUid: '',
    departmentName: '',
    current: '',
    crewDetail: {},
    archivesData: {},
    archivesTableData: '1',
    personalMaterialVisible: false,
    personalMaterialData: {},
    departmentInfo: "",
    departmentList: {
        isLoading: false,
        list: [],
        count: 0
    },
    work: [],
    sex: [],
    edu: [],
    age: [],
    marry: [],
    child: [],
    depart: [],
    post: [],

    organize: {
        organizeList: {},
        isLoading: true
    },
    mechanismInfo: "",
    arrangeDepartment: [],
    isLoading: true,

    companyInfo: {},

    staffLink: '',

    staffLinkLoading: false

};

function manage() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var actions = arguments[1];


    switch (actions.type) {

        case _manage.GET_STAFF_LINK_START:
            {
                return (0, _extends3.default)({}, state, { staffLinkLoading: true });
            }
        case _manage.GET_STAFF_LINK_DONE:
            {
                return (0, _extends3.default)({}, state, { staffLinkLoading: false });
            }
        case _manage.GET_STAFF_LINK:
            {
                return (0, _extends3.default)({}, state, { staffLink: actions.staffLink });
            }
        case _manage.SHOW_STAFF_MODAL:
            {
                return (0, _extends3.default)({}, state, { staffModal: (0, _extends3.default)({}, state.staffModal, { visible: true }) });
            }
        case _manage.HIDE_STAFF_MODAL:
            {
                return (0, _extends3.default)({}, state, { staffModal: (0, _extends3.default)({}, state.staffModal, { visible: false }) });
            }
        case _manage.IS_PREVIEW_IMAGE:
            {
                return (0, _extends3.default)({}, state, { companyInfo: actions.companyInfo });
            }
        case _manage.GET_MANAGE_START:
            return (0, _extends3.default)({}, state, { manageStastistics: (0, _extends3.default)({}, state.manageStastistics, { isLoading: true }) });
        case _manage.GET_MANAGE_END:
            return (0, _extends3.default)({}, state, { manageStastistics: (0, _extends3.default)({}, state.manageStastistics, { isLoading: false }) });
        case _manage.GET_MANAGE_STATISTICS:
            return (0, _extends3.default)({}, state, { manageStastistics: (0, _extends3.default)({}, state.manageStastistics, { list: actions.list }) });
        case _manage.LOAD_LIST_START:
            return (0, _extends3.default)({}, state, { crewList: (0, _extends3.default)({}, state.crewList, { isLoading: true }) });
        case _manage.LOAD_LIST_DONE:
            return (0, _extends3.default)({}, state, { crewList: (0, _extends3.default)({}, state.crewList, { isLoading: false }) });
        case _manage.LOAD_CREW_LIST:
            return (0, _extends3.default)({}, state, { crewList: (0, _extends3.default)({}, state.crewList, { list: actions.list, count: actions.count }) });
        case _manage.SHOW_UPLOAD_CLERK_MODAL:
            return (0, _extends3.default)({}, state, { uploadClerkModal: (0, _extends3.default)({}, state.uploadClerkModal, { visible: true }) });
        case _manage.HIDE_UPLOAD_CLERK_MODAL:
            return (0, _extends3.default)({}, state, { uploadClerkModal: (0, _extends3.default)({}, state.uploadClerkModal, { visible: false }) });
        case _manage.UPLOAD_CLERK_START:
            return (0, _extends3.default)({}, state, { uploadClerkModal: (0, _extends3.default)({}, state.uploadClerkModal, { isLoading: true }) });
        case _manage.UPLOAD_CLERK_DONE:
            return (0, _extends3.default)({}, state, { uploadClerkModal: (0, _extends3.default)({}, state.uploadClerkModal, { isLoading: false }) });
        case _manage.SET_RESETFORM_TRUE:
            return (0, _extends3.default)({}, state, { uploadClerkModal: (0, _extends3.default)({}, state.uploadClerkModal, { resetForm: true }) });
        case _manage.SET_RESETFORM_FALSE:
            return (0, _extends3.default)({}, state, { uploadClerkModal: (0, _extends3.default)({}, state.uploadClerkModal, { resetForm: false }) });
        case _manage.EXPORT_CLERK_START:
            return (0, _extends3.default)({}, state, { exportClerkList: (0, _extends3.default)({}, state.exportClerkList, { isLoading: true }) });
        case _manage.EXPORT_CLERK_DONE:
            return (0, _extends3.default)({}, state, { exportClerkList: (0, _extends3.default)({}, state.exportClerkList, { isLoading: false }) });
        case _manage.DELETE_EMPLOYEE_START:
            return (0, _extends3.default)({}, state, { deleteClerkList: (0, _extends3.default)({}, state.deleteClerkList, { isLoading: true, isDelete: false }) });
        case _manage.DELETE_EMPLOYEE_DONE:
            return (0, _extends3.default)({}, state, { deleteClerkList: (0, _extends3.default)({}, state.deleteClerkList, { isLoading: false, isDelete: true }) });
        case _manage.QUERY_EMPLOYEE_START:
            return (0, _extends3.default)({}, state, { queryEmployeeList: (0, _extends3.default)({}, state.queryEmployeeList, { isLoading: true }) });
        case _manage.QUERY_EMPLOYEE_DONE:
            return (0, _extends3.default)({}, state, { queryEmployeeList: (0, _extends3.default)({}, state.queryEmployeeList, { isLoading: false }) });
        case _manage.QUERY_EMPLOYEE_LIST:
            return (0, _extends3.default)({}, state, { queryEmployeeList: (0, _extends3.default)({}, state.queryEmployeeList, { list: actions.list }) });
        case _manage.QUERY_RESET_FORM:
            return (0, _extends3.default)({}, state, { queryEmployeeList: (0, _extends3.default)({}, state.queryEmployeeList, { list: actions.list }) });
        case _manage.SHOW_DISMISSION_MODAL:
            return (0, _extends3.default)({}, state, { dismissionModal: (0, _extends3.default)({}, state.dismissionModal, { visible: true }) });
        case _manage.HIDE_DISMISSION_MODAL:
            return (0, _extends3.default)({}, state, { dismissionModal: (0, _extends3.default)({}, state.dismissionModal, { visible: false }) });
        case _manage.SHOW_FORMAL_MODAL:
            return (0, _extends3.default)({}, state, { permanentModal: (0, _extends3.default)({}, state.permanentModal, { visible: true }) });
        case _manage.HIDE_FORMAL_MODAL:
            return (0, _extends3.default)({}, state, { permanentModal: (0, _extends3.default)({}, state.permanentModal, { visible: false }) });
        case _manage.SHOW_TRANSFER_PERSONNEL_MODAL:
            return (0, _extends3.default)({}, state, { transferPersonnelModal: (0, _extends3.default)({}, state.transferPersonnelModal, { visible: true }) });
        case _manage.HIDE_TRANSFER_PERSONNEL_MODAL:
            return (0, _extends3.default)({}, state, { transferPersonnelModal: (0, _extends3.default)({}, state.transferPersonnelModal, { visible: false }) });
        case _manage.MOBILIZE_EMPLOYEE_START:
            return (0, _extends3.default)({}, state, { transferPersonnelModal: (0, _extends3.default)({}, state.transferPersonnelModal, { isTransferPersonnel: true }) });
        case _manage.MOBILIZE_EMPLOYEE_DONE:
            return (0, _extends3.default)({}, state, { transferPersonnelModal: (0, _extends3.default)({}, state.transferPersonnelModal, { isTransferPersonnel: false }) });
        case _manage.SHOW_ATTACHMENT_MODAL:
            return (0, _extends3.default)({}, state, { attactmentModal: (0, _extends3.default)({}, state.attactmentModal, { visible: true }) });
        case _manage.HIDE_ATTACHMENT_MODAL:
            return (0, _extends3.default)({}, state, { attactmentModal: (0, _extends3.default)({}, state.attactmentModal, { visible: false }) });
        case _manage.OPERATION_LIST_START:
            return (0, _extends3.default)({}, state, { operationList: (0, _extends3.default)({}, state.operationList, { isLoading: true }) });
        case _manage.OPERATION_LIST_DONE:
            return (0, _extends3.default)({}, state, { operationList: (0, _extends3.default)({}, state.operationList, { isLoading: false }) });
        case _manage.OPERATION_LIST:
            return (0, _extends3.default)({}, state, { operationList: (0, _extends3.default)({}, state.operationList, { list: actions.list, count: actions.count }) });
        case _manage.LOAD_EMPLOYEEINFO_START:
            return (0, _extends3.default)({}, state, { isInfoLoading: true });
        case _manage.LOAD_EMPLOYEEINFO_DONE:
            return (0, _extends3.default)({}, state, { isInfoLoading: false });
        case _manage.LOAD_EMPLOYEEINFO:
            return (0, _extends3.default)({}, state, { employeeInfo: actions.employeeInfo });
        case _manage.SHOW_INFO_MODAL:
            return (0, _extends3.default)({}, state, { visible: true, uriParams: actions.uriParams });
        case _manage.HIDE_INFO_MODAL:
            return (0, _extends3.default)({}, state, { visible: false });
        case _manage.PROGRESS:
            return (0, _extends3.default)({}, state, { progressVisible: true });
        case _manage.CANCELPROGRESS:
            return (0, _extends3.default)({}, state, { progressVisible: false });
        case _manage.SHOW_IMAGE_MODAL:
            return (0, _extends3.default)({}, state, { attactmentType: actions.attactmentType });
        case _manage.HIDE_IMAGE_MODAL:
            return (0, _extends3.default)({}, state, { attactmentType: (0, _extends3.default)({}, state.attactmentType, { imageVisible: false }) });
        case _manage.IMAGEURL:
            return (0, _extends3.default)({}, state, { imageUrl: actions.imageUrl });
        case _manage.GET_ARCHIVES_START:
            return (0, _extends3.default)({}, state, { archivesList: (0, _extends3.default)({}, state.archivesList, { isLoading: true }) });
        case _manage.GET_ARCHIVES_DONE:
            return (0, _extends3.default)({}, state, { archivesList: (0, _extends3.default)({}, state.archivesList, { isLoading: false }) });
        case _manage.GET_ARCHIVES_LIST:
            return (0, _extends3.default)({}, state, { archivesList: (0, _extends3.default)({}, state.archivesList, { list: actions.list, count: actions.count }) });
        case _manage.GET_LEAVEARCHIVES_START:
            return (0, _extends3.default)({}, state, { leaveArchivesList: (0, _extends3.default)({}, state.leaveArchivesList, { isLoading: true }) });
        case _manage.GET_LEAVEARCHIVES_DONE:
            return (0, _extends3.default)({}, state, { leaveArchivesList: (0, _extends3.default)({}, state.leaveArchivesList, { isLoading: false }) });
        case _manage.GET_LEAVEARCHIVES_LIST:
            return (0, _extends3.default)({}, state, { leaveArchivesList: (0, _extends3.default)({}, state.leaveArchivesList, { list: actions.list, count: actions.count }) });
        case _manage.GET_ARCHIVES_DATA:
            return (0, _extends3.default)({}, state, { archivesData: actions.archivesData });
        case _manage.ARCHIVES_TABLE_DATA:
            return (0, _extends3.default)({}, state, { archivesTableData: actions.archivesTableData });
        case _manage.GET_EMPLOYEE_WORK:
            return (0, _extends3.default)({}, state, { work: actions.work });
        case _manage.GET_EMPLOYEE_SEX:
            return (0, _extends3.default)({}, state, { sex: actions.sex });
        case _manage.GET_EMPLOYEE_EDU:
            return (0, _extends3.default)({}, state, { edu: actions.edu });
        case _manage.GET_EMPLOYEE_AGE:
            return (0, _extends3.default)({}, state, { age: actions.age });
        case _manage.GET_EMPLOYEE_MARRY:
            return (0, _extends3.default)({}, state, { marry: actions.marry });
        case _manage.GET_EMPLOYEE_CHILD:
            return (0, _extends3.default)({}, state, { child: actions.child });
        case _manage.GET_EMPLOYEE_DEPART:
            return (0, _extends3.default)({}, state, { depart: actions.depart });
        case _manage.GET_EMPLOYEE_POST:
            return (0, _extends3.default)({}, state, { post: actions.post });
        case _manage.GET_DEPARTMENT_START:
            return (0, _extends3.default)({}, state, { departmentList: (0, _extends3.default)({}, state.departmentList, { isLoading: false }) });
        case _manage.GET_DEPARTMENT_DONE:
            return (0, _extends3.default)({}, state, { departmentList: (0, _extends3.default)({}, state.departmentList, { isLoading: true }) });
        case _manage.GET_DEPARTMENT_LIST:
            return (0, _extends3.default)({}, state, { departmentList: (0, _extends3.default)({}, state.departmentList, { list: actions.list, count: actions.count }) });
        case _manage.SHOW_PERSONALMATERIAL_MODAL:
            return (0, _extends3.default)({}, state, { personalMaterialVisible: actions.personalMaterialVisible, personalMaterialData: actions.data });
        case _manage.HIDE_PERSONALMATERIAL_MODAL:
            return (0, _extends3.default)({}, state, { personalMaterialVisible: actions.personalMaterialVisible });
        case _manage.GET_DEPARTMENT_STAFF:
            return (0, _extends3.default)({}, state, { departmentStaff: actions.departmentStaff, currentUid: actions.currentUid, departmentName: actions.departmentName, current: actions.current });
        case _manage.ADD_EDIT_DEPARTMENT:
            return (0, _extends3.default)({}, state, { departmentInfo: actions.departmentInfo });
        case _manage.DELETE_DEPARTMENT:
            return (0, _extends3.default)({}, state, { departmentInfo: actions.departmentInfo });
        case _manage.GET_ORGANIZE_CHART:
            return (0, _extends3.default)({}, state, { organize: (0, _extends3.default)({}, state.organize, { organizeList: actions.organizeList, isLoading: actions.isLoading }) });
        case _manage.ADD_MECHANISM:
            return (0, _extends3.default)({}, state, { mechanismInfo: actions.mechanismInfo });
        case _manage.DELETE_MECHANISM:
            return (0, _extends3.default)({}, state, { mechanismInfo: actions.mechanismInfo });
        case _manage.EDIT_MECHANISM:
            return (0, _extends3.default)({}, state, { mechanismInfo: actions.mechanismInfo });
        case _manage.CREDITINVESTGATION:
            return (0, _extends3.default)({}, state, { creditData: actions.creditData });
        case _manage.CANCELDATA:
            return (0, _extends3.default)({}, state, { creditData: {} });
        case _manage.SEARCHCREDITINVESTGATION:
            return (0, _extends3.default)({}, state, { creditInfoData: actions.creditInfoData, isDataLoading: false });
        case _manage.SEARCHCREDITINVESTGATION_START:
            return (0, _extends3.default)({}, state, { isDataLoading: true, searchLoading: true });
        case _manage.CREDITINVESTGATIONSTATE:
            return (0, _extends3.default)({}, state, { isFill: actions.isFill });
        case _manage.HIDECREDITINVESTGATIONSTATE:
            return (0, _extends3.default)({}, state, { isFill: actions.isFill, creditInfoData: {} });
        case _manage.GET_ARRANGE_DEPARTMENT:
            return (0, _extends3.default)({}, state, { arrangeDepartment: actions.arrangeDepartment });
        case _manage.ARRANGE_DEPARTMENT:
            return (0, _extends3.default)({}, state, { mechanismInfo: actions.mechanismInfo });
        case _manage.CANCELLOADING:
            return (0, _extends3.default)({}, state, { searchLoading: false });
        default:
            return state;
    }
}

/***/ }),

/***/ 419:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = recruit;

var _recruit = __webpack_require__(130);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  visible: false,
  isCategoryLoading: false,
  isListLoading: false,
  categoryData: [],
  uriParams: {},
  recruitList: {
    list: [],
    count: 0
  },
  uploadModal: {
    visible: false,
    isLoading: false,
    resetForm: false
  },

  recommendModal: {
    visible: false,
    isLoading: false,
    data: {
      allRecords: 0,
      list: []
    }
  },
  position: {},
  name: '',
  filepath: '',
  matchResumeInfo: {}
};

function recruit() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var actions = arguments[1];

  switch (actions.type) {
    case _recruit.MATCH_UPRESUME:
      return (0, _extends3.default)({}, state, { matchResumeInfo: actions.matchResumeInfo
      });
    case _recruit.UP_INFO_NAME:
      return (0, _extends3.default)({}, state, { name: actions.name
      });
    case _recruit.UP_INFO_FILEPATH:
      return (0, _extends3.default)({}, state, { filepath: actions.filepath || ''
      });
    case _recruit.LOAD_CATEGORY_START:
      return (0, _extends3.default)({}, state, { isCategoryLoading: true
      });
    case _recruit.LOAD_CATEGORY_DONE:
      return (0, _extends3.default)({}, state, { isCategoryLoading: false
      });
    case _recruit.LOAD_RECRUIT_CATEGORY:
      return (0, _extends3.default)({}, state, { categoryData: actions.categoryData
      });
    case _recruit.LOAD_LIST_START:
      return (0, _extends3.default)({}, state, { isListLoading: true
      });
    case _recruit.LOAD_LIST_DONE:
      return (0, _extends3.default)({}, state, { isListLoading: false
      });
    case _recruit.LOAD_RECRUIT_LIST:
      return (0, _extends3.default)({}, state, { recruitList: actions.recruitList
      });
    case _recruit.SHOW_INFO_MODAL:
      return (0, _extends3.default)({}, state, { visible: true, uriParams: actions.uriParams
      });
    case _recruit.HIDE_INFO_MODAL:
      return (0, _extends3.default)({}, state, { visible: false
      });
    case _recruit.SHOW_UPLOAD_MODAL:
      return (0, _extends3.default)({}, state, { uploadModal: (0, _extends3.default)({}, state.uploadModal, {
          visible: true
        })
      });
    case _recruit.HIDE_UPLOAD_MODAL:
      return (0, _extends3.default)({}, state, { uploadModal: (0, _extends3.default)({}, state.uploadModal, {
          visible: false
        })
      });
    case _recruit.UPLOAD_RESUME_START:
      return (0, _extends3.default)({}, state, { uploadModal: (0, _extends3.default)({}, state.uploadModal, {
          isLoading: true
        })
      });
    case _recruit.UPLOAD_RESUME_DONE:
      return (0, _extends3.default)({}, state, { uploadModal: (0, _extends3.default)({}, state.uploadModal, {
          isLoading: false
        })
      });
    case _recruit.SET_RESETFORM_TRUE:
      return (0, _extends3.default)({}, state, { uploadModal: (0, _extends3.default)({}, state.uploadModal, {
          resetForm: true
        }), position: {}
      });
    case _recruit.SET_RESETFORM_FALSE:
      return (0, _extends3.default)({}, state, { uploadModal: (0, _extends3.default)({}, state.uploadModal, {
          resetForm: false
        })
      });
    case _recruit.SHOW_RECOMMEND_MODAL:
      return (0, _extends3.default)({}, state, { recommendModal: (0, _extends3.default)({}, state.recommendModal, {
          visible: true
        })
      });
    case _recruit.HIDE_RECOMMEND_MODAL:
      return (0, _extends3.default)({}, state, { recommendModal: (0, _extends3.default)({}, state.recommendModal, {
          visible: false
        })
      });
    case _recruit.LOAD_RECOMMEND_START:
      return (0, _extends3.default)({}, state, { recommendModal: (0, _extends3.default)({}, state.recommendModal, {
          isLoading: true
        })
      });
    case _recruit.LOAD_RECOMMEND_DONE:
      return (0, _extends3.default)({}, state, { recommendModal: (0, _extends3.default)({}, state.recommendModal, {
          isLoading: false
        })
      });
    case _recruit.LOAD_RECOMMEND_LIST:
      return (0, _extends3.default)({}, state, { recommendModal: (0, _extends3.default)({}, state.recommendModal, {
          data: actions.data
        })
      });
    case _recruit.SELECT_POSITION:
      return (0, _extends3.default)({}, state, { position: actions.position
      });
    default:
      return state;
  }
}

/***/ }),

/***/ 420:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = resume;

var _resumeInfo = __webpack_require__(224);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    modalVisible: false,
    shareModalVisible: false,
    evaluationModalVisible: false,
    currentStage: {},
    resumeInfo: {},
    resumeData: {},
    evaluationData: {},
    isModalLoading: false,
    isDownLoading: false,
    evaluation: {},
    evaluationid: "",
    resumeUrl: {},
    backSurveyVisible: false,
    resumeInformation: {},
    isLoading: true,
    shareLinkModalVisible: false,
    companyInfo: {},
    intrerviewInfo: {},
    scores: [],
    summary: '',
    resumeEditModel: false,
    echarts: false,
    dignityList: [],
    tempResumeInfo: {},
    tempIntention: {},
    tempAssessment: {},
    tempEducList: [],
    tempProjectlist: [],
    tempWorkList: [],
    tempLanlist: [],
    tempTrainlist: [],
    tempCertlist: [],
    tempOtherlist: [],
    type: 0,
    evaluationInterviews: [],
    tempborndate: '',
    tempAdvar: '',
    tempAdvarFilepath: ''
};

function resume() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var actions = arguments[1];

    switch (actions.type) {
        case 0:
            return (0, _extends3.default)({}, state, { type: actions.type });
        case 4:
            return (0, _extends3.default)({}, state, { type: actions.type });
        case 5:
            return (0, _extends3.default)({}, state, { type: actions.type });
        case _resumeInfo.GET_EVALUATION_INTERVIEWS:
            return (0, _extends3.default)({}, state, { evaluationInterviews: actions.evaluationInterviews });
        case _resumeInfo.TEMP_BORNDATA:
            return (0, _extends3.default)({}, state, { tempborndate: actions.tempborndate });
        case _resumeInfo.TEMP_OTHER_LIST:
            return (0, _extends3.default)({}, state, { tempOtherlist: actions.tempOtherlist });
        case _resumeInfo.TEMP_CERT_LIST:
            return (0, _extends3.default)({}, state, { tempCertlist: actions.tempCertlist });
        case _resumeInfo.TEMP_TRAIN_LIST:
            return (0, _extends3.default)({}, state, { tempTrainlist: actions.tempTrainlist });
        case _resumeInfo.TEMP_LAN_LIST:
            return (0, _extends3.default)({}, state, { tempLanlist: actions.tempLanlist });
        case _resumeInfo.TEMP_WORK_LIST:
            return (0, _extends3.default)({}, state, { tempWorkList: actions.tempWorklist });
        case _resumeInfo.TEMP_PROJECT_LIST:
            return (0, _extends3.default)({}, state, { tempProjectlist: actions.tempProjectlist });
        case _resumeInfo.TEMP_EDUCLIST:
            return (0, _extends3.default)({}, state, { tempEducList: actions.tempEducList });
        case _resumeInfo.TEMP_ASSESSMENT:
            return (0, _extends3.default)({}, state, { tempAssessment: actions.tempAssessment });
        case _resumeInfo.TEMP_INTENTION:
            return (0, _extends3.default)({}, state, { tempIntention: actions.tempIntention });
        case _resumeInfo.SHOW_ECHARTS_STATUS:
        case _resumeInfo.TEMP_BACICINFO:
            return (0, _extends3.default)({}, state, { tempResumeInfo: actions.tempResumeInfo });
        case _resumeInfo.SHOW_ECHARTS_STATUS:
            return (0, _extends3.default)({}, state, { echarts: true });
        case _resumeInfo.HIDE_ECHARTS_STATUS:
            return (0, _extends3.default)({}, state, { echarts: false });
        case _resumeInfo.TEMP_ADVAR:
            return (0, _extends3.default)({}, state, { tempAdvar: actions.tempAdvar });
        case _resumeInfo.TEMP_ADVAR_FILEPATH:
            return (0, _extends3.default)({}, state, { tempAdvarFilepath: actions.tempAdvarFilepath });
        case _resumeInfo.SCORES:
            return (0, _extends3.default)({}, state, { scores: actions.scores, dignityList: actions.dignityList });
        case _resumeInfo.SUMMARY:
            return (0, _extends3.default)({}, state, { summary: actions.summary });
        case _resumeInfo.SHOW_RESUME_EDIT_MODEL:
            return (0, _extends3.default)({}, state, { resumeEditModel: true });
        case _resumeInfo.HIDE_RESUME_EDIT_MODEL:
            return (0, _extends3.default)({}, state, { resumeEditModel: false });
        case _resumeInfo.INTERVIEW_INFO:
            return (0, _extends3.default)({}, state, { intrerviewInfo: actions.interviewInfo });
        case _resumeInfo.SHOW_MODAL:
            return (0, _extends3.default)({}, state, { modalVisible: true, currentStage: actions.currentStage });
        case _resumeInfo.HIDE_MODAL:
            return (0, _extends3.default)({}, state, { modalVisible: false });
        case _resumeInfo.SHOW_SHARE_MODAL:
            return (0, _extends3.default)({}, state, { shareModalVisible: true, resumeData: actions.resumeData });
        case _resumeInfo.RESUME_INFORMATION:
            return (0, _extends3.default)({}, state, { resumeUrl: actions.resumeUrl });
        case _resumeInfo.GET_EVALUATION:
            return (0, _extends3.default)({}, state, { evaluation: actions.evaluation });
        case _resumeInfo.GET_EVALUATION_ID:
            return (0, _extends3.default)({}, state, { evaluationid: actions.evaluationid });
        case _resumeInfo.HIDE_SHARE_MODAL:
            return (0, _extends3.default)({}, state, { shareModalVisible: false });
        case _resumeInfo.SHOW_INTERVIEW_EVALUATION_MODAL:
            return (0, _extends3.default)({}, state, { evaluationModalVisible: true, evaluationData: actions.evaluationData });
        case _resumeInfo.HIDE_INTERVIEW_EVALUATION_MODAL:
            return (0, _extends3.default)({}, state, { evaluationModalVisible: false });
        case _resumeInfo.LOAD_RESUME_INFO:
            return (0, _extends3.default)({}, state, { resumeInfo: actions.resumeInfo });
        case _resumeInfo.LOAD_INFO_START:
            return (0, _extends3.default)({}, state, { isInfoLoading: true });
        case _resumeInfo.LOAD_INFO_DONE:
            return (0, _extends3.default)({}, state, { isInfoLoading: false });
        case _resumeInfo.SHOW_MODAL_LOADING:
            return (0, _extends3.default)({}, state, { isModalLoading: true });
        case _resumeInfo.HIDE_MODAL_LOADING:
            return (0, _extends3.default)({}, state, { isModalLoading: false });
        case _resumeInfo.DOWNLOAD_RESUME_START:
            return (0, _extends3.default)({}, state, { isDownLoading: true });
        case _resumeInfo.DOWNLOAD_RESUME_DONE:
            return (0, _extends3.default)({}, state, { isDownLoading: false });
        case _resumeInfo.SHOW_BACKGROUNDSURVEY_MODAL:
            return (0, _extends3.default)({}, state, { backSurveyVisible: true });
        case _resumeInfo.HIDE_BACKGROUNDSURVEY_MODAL:
            return (0, _extends3.default)({}, state, { backSurveyVisible: false });
        case _resumeInfo.RESUME_INFO:
            return (0, _extends3.default)({}, state, { resumeInformation: actions.resumeInformation });
        case _resumeInfo.FILL_LOADING:
            return (0, _extends3.default)({}, state, { isLoading: false });
        case _resumeInfo.SHOW_QRCODE_LINKMODAL:
            return (0, _extends3.default)({}, state, { shareLinkModalVisible: true, companyInfo: actions.companyInfo });
        case _resumeInfo.HIDE_QRCODE_LINKMODAL:
            return (0, _extends3.default)({}, state, { shareLinkModalVisible: false });
        default:
            return state;
    }
}

/***/ }),

/***/ 421:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = recruit;

var _resumeSearch = __webpack_require__(225);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    resumeData: [],
    resumeDetailData: {},
    isLoading: false,
    detailLoading: false,
    totalHits: "",
    isView: false,
    contract_count: "",
    isCollect: false,
    noCollect: false
};
function recruit() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var actions = arguments[1];

    switch (actions.type) {
        case _resumeSearch.RESUME_SEARCH:
            return (0, _extends3.default)({}, state, { resumeData: actions.resumeData, totalHits: actions.totalHits });
        case _resumeSearch.RESUME_SEARCH_START:
            return (0, _extends3.default)({}, state, { isLoading: true });
        case _resumeSearch.RESUME_SEARCH_DONE:
            return (0, _extends3.default)({}, state, { isLoading: false });
        case _resumeSearch.VIEW_DETAILS_DONE:
            return (0, _extends3.default)({}, state, { detailLoading: false });
        case _resumeSearch.VIEW_DETAILS_START:
            return (0, _extends3.default)({}, state, { detailLoading: true });
        case _resumeSearch.RESUME_DETAIL:
            return (0, _extends3.default)({}, state, { resumeDetailData: actions.resumeDetailData, isView: actions.isView, detailLoading: false });
        case _resumeSearch.CLEAR_RESUME_DETAIL_DATA:
            return (0, _extends3.default)({}, state, { resumeDetailData: {} });
        case _resumeSearch.CLEAR_RESUME_DATA:
            return (0, _extends3.default)({}, state, { resumeData: [] });
        case _resumeSearch.DOWNLOAD_NUM:
            return (0, _extends3.default)({}, state, { contract_count: actions.contract_count });
        case _resumeSearch.ISCOLLECT:
            return (0, _extends3.default)({}, state, { isCollect: true, noCollect: false });
        case _resumeSearch.NOCOLLECT:
            return (0, _extends3.default)({}, state, { noCollect: true, isCollect: false });
        default:
            return state;
    }
}

/***/ }),

/***/ 422:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = recruit;

var _salaryReport = __webpack_require__(226);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    industry: [],
    department: [],
    position: [],
    salaryData: []
};
function recruit() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var actions = arguments[1];

    switch (actions.type) {
        case _salaryReport.GET_INDUSTRY:
            return (0, _extends3.default)({}, state, { industry: actions.industry });
        case _salaryReport.GET_DEPARTMENT:
            return (0, _extends3.default)({}, state, { department: actions.department });
        case _salaryReport.GET_POSITION:
            return (0, _extends3.default)({}, state, { position: actions.position });
        case _salaryReport.SALARY_DATA:
            return (0, _extends3.default)({}, state, { salaryData: actions.salaryData });
        case _salaryReport.DELETE_DATA:
            return (0, _extends3.default)({}, state, { salaryData: [] });
        default:
            return state;
    }
}

/***/ }),

/***/ 423:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = talent;

var _talent = __webpack_require__(227);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    talentModel: false,
    isListLoading: false,
    categoryData: {},
    talentList: {
        count: 0,
        list: []
    },
    createModal: { isLoading: false, modalVisible: false },
    deleteModal: { isLoading: false, modalVisible: false },
    moveModal: { isLoading: false, modalVisible: false },
    recommendPositioning: false };

function talent() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var actions = arguments[1];

    switch (actions.type) {
        case _talent.TALENT_SOLE_MODEL_START:
            return (0, _extends3.default)({}, state, { talentModel: true });
        case _talent.TALENT_SOLE_MODEL_DONE:
            return (0, _extends3.default)({}, state, { talentModel: false });
        case _talent.LOAD_LIST_START:
            return (0, _extends3.default)({}, state, { isListLoading: true });
        case _talent.LOAD_LIST_DONE:
            return (0, _extends3.default)({}, state, { isListLoading: false });
        case _talent.LOAD_TALENT_LIST:
            return (0, _extends3.default)({}, state, { talentList: actions.talentList.list.length == 0 ? { count: 0,
                    list: [] } : actions.talentList });
        case _talent.LOAD_CATEGORY_START:
            return (0, _extends3.default)({}, state, { isCategoryLoading: true });
        case _talent.LOAD_CATEGORY_DONE:
            return (0, _extends3.default)({}, state, { isCategoryLoading: false });
        case _talent.LOAD_TALENT_CATEGORY:
            return (0, _extends3.default)({}, state, { categoryData: actions.categoryData });
        case _talent.SHOW_CREATE_LABEL_MODAL:
            return (0, _extends3.default)({}, state, { createModal: (0, _extends3.default)({}, state.createModal, { modalVisible: true }) });
        case _talent.HIDE_CREATE_LABEL_MODAL:
            return (0, _extends3.default)({}, state, { createModal: (0, _extends3.default)({}, state.createModal, { modalVisible: false }) });
        case _talent.CREATE_LABEL_START:
            return (0, _extends3.default)({}, state, { createModal: (0, _extends3.default)({}, state.createModal, { isLoading: true }) });
        case _talent.CREATE_LABEL_DONE:
            return (0, _extends3.default)({}, state, { createModal: (0, _extends3.default)({}, state.createModal, { isLoading: false }) });
        case _talent.SHOW_DELETE_LABEL_MODAL:
            return (0, _extends3.default)({}, state, { deleteModal: (0, _extends3.default)({}, state.deleteModal, { modalVisible: true }) });
        case _talent.HIDE_DELETE_LABEL_MODAL:
            return (0, _extends3.default)({}, state, { deleteModal: (0, _extends3.default)({}, state.deleteModal, { modalVisible: false }) });
        case _talent.DELETE_LABEL_START:
            return (0, _extends3.default)({}, state, { deleteModal: (0, _extends3.default)({}, state.deleteModal, { isLoading: true }) });
        case _talent.DELETE_LABEL_DONE:
            return (0, _extends3.default)({}, state, { deleteModal: (0, _extends3.default)({}, state.deleteModal, { isLoading: false }) });
        case _talent.SHOW_MOVE_RESUME_MODAL:
            return (0, _extends3.default)({}, state, { moveModal: (0, _extends3.default)({}, state.moveModal, { modalVisible: true }) });
        case _talent.HIDE_MOVE_RESUME_MODAL:
            return (0, _extends3.default)({}, state, { moveModal: (0, _extends3.default)({}, state.moveModal, { modalVisible: false }) });
        case _talent.MOVE_RESUME_START:
            return (0, _extends3.default)({}, state, { moveModal: (0, _extends3.default)({}, state.moveModal, { isLoading: true }) });
        case _talent.MOVE_RESUME_DONE:
            return (0, _extends3.default)({}, state, { moveModal: (0, _extends3.default)({}, state.moveModal, { isLoading: false }) });
        case _talent.RECOMMEND_POSITION_START:
            return (0, _extends3.default)({}, state, { recommendPositioning: true });
        case _talent.RECOMMEND_POSITION_DONE:
            return (0, _extends3.default)({}, state, { recommendPositioning: false });
        default:
            return state;
    }
}

/***/ }),

/***/ 424:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = user;

var _task = __webpack_require__(228);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    isLoading: false,
    data: { list: {} },
    downLoading: false
};

function user() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var actions = arguments[1];

    switch (actions.type) {
        case _task.GET_TASK_START:
            return (0, _extends3.default)({}, state, { isLoading: true });
        case _task.GET_TASK_DONE:
            return (0, _extends3.default)({}, state, { isLoading: false });
        case _task.GET_TASK_REPORT:
            return (0, _extends3.default)({}, state, { data: actions.data });

        default:
            return state;
    }
}

/***/ }),

/***/ 425:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = user;

var _user = __webpack_require__(229);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    userInfo: {},
    userEmailInfo: {
        userMail: {},
        mailServersList: []
    },
    resumeEmailInfo: {},
    isLoading: false,
    changeRes: false
};

function user() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var actions = arguments[1];

    switch (actions.type) {
        case _user.GET_USER_INFO:
            return (0, _extends3.default)({}, state, { userInfo: actions.userInfo });
        case _user.GET_USER_EMAIL_INFO:
            return (0, _extends3.default)({}, state, { userEmailInfo: actions.userEmailInfo });
        case _user.GET_USER_RESUMEEMAIL_INFO:
            return (0, _extends3.default)({}, state, { resumeEmailInfo: actions.resumeEmailInfo });
        case _user.CHANGE_PASSWD_START:
            return (0, _extends3.default)({}, state, { isLoading: true });
        case _user.CHANGE_PASSWD_DONE:
            return (0, _extends3.default)({}, state, { isLoading: false });
        case _user.CHANGE_PASSWD:
            return (0, _extends3.default)({}, state, { changeRes: true });
        case _user.CHANGE_RES_FALSE:
            return (0, _extends3.default)({}, state, { changeRes: false });
        default:
            return state;
    }
}

/***/ }),

/***/ 426:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notification = undefined;

var _notification2 = __webpack_require__(427);

var _notification3 = _interopRequireDefault(_notification2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.notification = _notification3.default;

/***/ }),

/***/ 427:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _antd = __webpack_require__(18);

module.exports = function () {
    var ntfication = function ntfication() {};

    ntfication.prototype.error = function (message) {
        var description = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

        description = arguments.length === 1 ? message : description;
        message = arguments.length === 1 ? '错误信息' : message;
        _antd.notification.error({
            message: message,
            description: description
        });
    };
    ntfication.prototype.success = function (message) {
        var description = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

        description = arguments.length === 1 ? message : description;
        message = arguments.length === 1 ? '提示' : message;
        _antd.notification.success({
            message: message,
            description: description
        });
    };
    return new ntfication();
}();

/***/ }),

/***/ 428:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(185);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(181);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(184);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(183);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(182);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(7);

var _react2 = _interopRequireDefault(_react);

var _navbar = __webpack_require__(405);

var _navbar2 = _interopRequireDefault(_navbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _class = function (_Component) {
    (0, _inherits3.default)(_class, _Component);

    function _class() {
        (0, _classCallCheck3.default)(this, _class);
        return (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).apply(this, arguments));
    }

    (0, _createClass3.default)(_class, [{
        key: 'render',
        value: function render() {
            var location = this.props.location,
                pathname = location.pathname,
                patternLogin = /\/login/i,
                patternResume = /(\/resumeInfo)/i;

            var patternShowResume = /\/showResume/i;
            var patternEvaluation = /\/evaluation/i;
            var patternCaseView = /\/CaseView/i;
            var patternResumeDetail = /\/resumeDetail/i;
            var preview = /\/preview/i;
            var employeeInfo = /\/employeeInfo/i;

            return _react2.default.createElement(
                'div',
                null,
                !employeeInfo.test(pathname) && !preview.test(pathname) && !patternLogin.test(pathname) && !patternResume.test(pathname) && !patternShowResume.test(pathname) && !patternEvaluation.test(pathname) && !patternCaseView.test(pathname) && !patternResumeDetail.test(pathname) && _react2.default.createElement(_navbar2.default, { location: location }),
                this.props.children
            );
        }
    }]);
    return _class;
}(_react.Component);

exports.default = _class;

/***/ })

},[408]);


// WEBPACK FOOTER //
// static/js/app.70388504e8f99a6623a2.js